var _defs, _rect, _g, _g2, _rect2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _g7, _path6, _path7, _path8, _g8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g10, _g11, _path24, _path25, _path26, _g12, _path27, _g13, _path28, _path29, _path30, _path31, _path32, _g14, _path33, _path34, _path35, _path36, _path37, _g15, _g16, _g17, _g18, _g19, _path38, _g20, _path39, _g21, _g22, _g23, _g24, _g25, _g26, _path40, _path41, _path42, _path43;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BBPS_API-Header",
    "data-name": "BBPS API-Header",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 666,
    height: 650,
    viewBox: "0 0 666 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12152",
    "data-name": "Rectangle 12152",
    width: 665.915,
    height: 602.704,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12104",
    "data-name": "Rectangle 12104",
    width: 165.15,
    height: 195.394,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12108",
    "data-name": "Rectangle 12108",
    width: 108.985,
    height: 88.992,
    fill: "#f0f3f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.153,
    y2: 1.109,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#086ef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32cbd1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12113",
    "data-name": "Rectangle 12113",
    width: 35.15,
    height: 33.184,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12114",
    "data-name": "Rectangle 12114",
    width: 20.585,
    height: 11.129,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12115",
    "data-name": "Rectangle 12115",
    width: 20.586,
    height: 11.129,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12117",
    "data-name": "Rectangle 12117",
    width: 20.585,
    height: 11.13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12118",
    "data-name": "Rectangle 12118",
    width: 56.841,
    height: 27.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12119",
    "data-name": "Rectangle 12119",
    width: 19.522,
    height: 14.404,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12121",
    "data-name": "Rectangle 12121",
    width: 205.916,
    height: 424.399,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12122",
    "data-name": "Rectangle 12122",
    width: 31.422,
    height: 6.259,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12153",
    "data-name": "Rectangle 12153",
    width: 159.666,
    height: 30.887,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12124",
    "data-name": "Rectangle 12124",
    width: 185.493,
    height: 329.09,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12125",
    "data-name": "Rectangle 12125",
    width: 181.089,
    height: 267.389,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x2: 0.336,
    y2: 1.164,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12127",
    "data-name": "Rectangle 12127",
    width: 47.754,
    height: 50.251,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12129",
    "data-name": "Rectangle 12129",
    width: 38.875,
    height: 51.282,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12130",
    "data-name": "Rectangle 12130",
    width: 3.212,
    height: 3.822,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12131",
    "data-name": "Rectangle 12131",
    width: 24.415,
    height: 38.979,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12132",
    "data-name": "Rectangle 12132",
    width: 18.571,
    height: 6.387,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12134",
    "data-name": "Rectangle 12134",
    width: 76.588,
    height: 16.648,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12136",
    "data-name": "Rectangle 12136",
    width: 94.436,
    height: 126.675,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12137",
    "data-name": "Rectangle 12137",
    width: 9.685,
    height: 16.31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12138",
    "data-name": "Rectangle 12138",
    width: 4.954,
    height: 7.46,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12139",
    "data-name": "Rectangle 12139",
    width: 15.642,
    height: 15.641,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12140",
    "data-name": "Rectangle 12140",
    width: 8.339,
    height: 13.133,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12141",
    "data-name": "Rectangle 12141",
    width: 7.262,
    height: 9.126,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12142",
    "data-name": "Rectangle 12142",
    width: 7.882,
    height: 4.333,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12143",
    "data-name": "Rectangle 12143",
    width: 15.451,
    height: 5.848,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12144",
    "data-name": "Rectangle 12144",
    width: 35.16,
    height: 47.221,
    fill: "#34bcdb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12145",
    "data-name": "Rectangle 12145",
    width: 8.004,
    height: 8.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12146",
    "data-name": "Rectangle 12146",
    width: 3.616,
    height: 4.724,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12148",
    "data-name": "Rectangle 12148",
    width: 3.617,
    height: 4.724,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12150",
    "data-name": "Rectangle 12150",
    width: 7.175,
    height: 9.017,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9728",
    "data-name": "Rectangle 9728",
    width: 666,
    height: 650,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40998",
    "data-name": "Group 40998",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40997",
    "data-name": "Group 40997",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40876",
    "data-name": "Group 40876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40875",
    "data-name": "Group 40875",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87601",
    "data-name": "Path 87601",
    d: "M505.842,394.91H265.119a7.821,7.821,0,0,1-7.807-7.818V35.987a7.821,7.821,0,0,1,7.807-7.818H505.842a7.821,7.821,0,0,1,7.807,7.818V387.092a7.821,7.821,0,0,1-7.807,7.818M265.119,28.5a7.488,7.488,0,0,0-7.474,7.484V387.092a7.487,7.487,0,0,0,7.474,7.484H505.842a7.487,7.487,0,0,0,7.474-7.484V35.987a7.488,7.488,0,0,0-7.474-7.484Z",
    transform: "translate(85.384 9.398)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87602",
    "data-name": "Path 87602",
    d: "M297.415,394.91H56.691a7.821,7.821,0,0,1-7.807-7.818V35.987a7.821,7.821,0,0,1,7.807-7.818H297.415a7.821,7.821,0,0,1,7.807,7.818V387.092a7.821,7.821,0,0,1-7.807,7.818M56.691,28.5a7.489,7.489,0,0,0-7.474,7.484V387.092a7.488,7.488,0,0,0,7.474,7.484H297.415a7.488,7.488,0,0,0,7.474-7.484V35.987a7.489,7.489,0,0,0-7.474-7.484Z",
    transform: "translate(16.221 9.398)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12087",
    "data-name": "Rectangle 12087",
    width: 665.915,
    height: 0.333,
    transform: "translate(0 434.084)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12088",
    "data-name": "Rectangle 12088",
    width: 21.389,
    height: 0.333,
    transform: "translate(68.818 453.107)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12089",
    "data-name": "Rectangle 12089",
    width: 71.293,
    height: 0.333,
    transform: "translate(226.88 449.494)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12090",
    "data-name": "Rectangle 12090",
    width: 48.279,
    height: 0.333,
    transform: "translate(91.539 465.498)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12091",
    "data-name": "Rectangle 12091",
    width: 57.522,
    height: 0.333,
    transform: "translate(503.901 449.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12092",
    "data-name": "Rectangle 12092",
    width: 8.43,
    height: 0.333,
    transform: "translate(573.289 449.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12093",
    "data-name": "Rectangle 12093",
    width: 71.772,
    height: 0.333,
    transform: "translate(421.141 457.628)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12094",
    "data-name": "Rectangle 12094",
    width: 103.678,
    height: 148.575,
    transform: "translate(43.832 360.853) rotate(-19.86)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87603",
    "data-name": "Path 87603",
    d: "M62.538,281.115c1,2.779-.714,5.233-5.025,6.783l-8.67,3.115-5.761-16.075,8.213-2.951c4.219-1.516,6.9-.535,7.789,1.946a4.038,4.038,0,0,1-.9,4.265,4.307,4.307,0,0,1,4.359,2.918m-4.768,1.143c-.4-1.1-1.41-1.334-2.971-.773l-3.806,1.368,1.169,3.261,3.806-1.367c1.561-.561,2.2-1.386,1.8-2.488m-9.015-5.652,1.111,3.1,3.119-1.122c1.513-.544,2.1-1.352,1.734-2.386-.362-1.009-1.332-1.258-2.845-.715Z",
    transform: "translate(14.296 90.499)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12095",
    "data-name": "Rectangle 12095",
    width: 4.816,
    height: 17.074,
    transform: "translate(75.011 359.101) rotate(-19.741)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87604",
    "data-name": "Path 87604",
    d: "M62.158,267.582l4.542-1.631,4.468,12.469,7.659-2.751,1.292,3.6-12.2,4.384Z",
    transform: "translate(20.626 88.726)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87605",
    "data-name": "Path 87605",
    d: "M72.659,263.815l4.542-1.632,4.468,12.469L89.33,271.9l1.292,3.6-12.2,4.385Z",
    transform: "translate(24.11 87.468)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12096",
    "data-name": "Rectangle 12096",
    width: 40.933,
    height: 4.432,
    transform: "matrix(0.941, -0.34, 0.34, 0.941, 107.433, 380.238)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12097",
    "data-name": "Rectangle 12097",
    width: 84.232,
    height: 54.273,
    transform: "matrix(0.941, -0.34, 0.34, 0.941, 71.287, 410.7)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12098",
    "data-name": "Rectangle 12098",
    width: 84.253,
    height: 3.145,
    transform: "matrix(0.941, -0.34, 0.34, 0.941, 70.748, 409.203)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87606",
    "data-name": "Path 87606",
    d: "M116.292,294.4l-22.781,8.24c-.6.216-.342,1.183.265.964l22.781-8.24c.6-.217.342-1.184-.265-.964",
    transform: "translate(30.917 98.207)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87607",
    "data-name": "Path 87607",
    d: "M119.768,304.026l-22.781,8.24c-.6.216-.342,1.183.265.964l22.781-8.24c.6-.217.342-1.184-.265-.964",
    transform: "translate(32.07 101.418)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87608",
    "data-name": "Path 87608",
    d: "M113.328,296.866l-7.316,2.646c-.6.217-.341,1.184.266.964l7.314-2.646c.6-.217.342-1.184-.265-.964",
    transform: "translate(35.065 99.029)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87609",
    "data-name": "Path 87609",
    d: "M121.366,301.473l-32.895,11.9c-.6.216-.341,1.183.265.964l32.895-11.9c.6-.217.342-1.184-.265-.964",
    transform: "translate(29.244 100.566)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87610",
    "data-name": "Path 87610",
    d: "M74.059,308.215l-12.17,4.4c-.6.216-.341,1.183.266.964l12.169-4.4c.6-.217.342-1.184-.265-.964",
    transform: "translate(20.424 102.815)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87611",
    "data-name": "Path 87611",
    d: "M76.769,315.716l-12.17,4.4c-.6.216-.341,1.183.265.964l12.17-4.4c.6-.217.342-1.184-.265-.964",
    transform: "translate(21.323 105.318)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87612",
    "data-name": "Path 87612",
    d: "M120.291,310.457l-15.558,5.628c-.6.216-.34,1.183.266.964l15.557-5.628c.6-.217.342-1.184-.265-.964",
    transform: "translate(34.641 103.563)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87613",
    "data-name": "Path 87613",
    d: "M79.554,323.425q-6.085,2.2-12.17,4.4c-.6.216-.341,1.183.266.964l12.168-4.4c.6-.217.344-1.184-.264-.964",
    transform: "translate(22.247 107.889)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87614",
    "data-name": "Path 87614",
    d: "M126.935,316.889l-32.895,11.9c-.6.216-.341,1.183.265.964l32.895-11.9c.6-.217.342-1.184-.265-.964",
    transform: "translate(31.092 105.709)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87615",
    "data-name": "Path 87615",
    d: "M82.338,331.133l-12.17,4.4c-.6.216-.341,1.183.266.964L82.6,332.1c.6-.217.341-1.184-.265-.964",
    transform: "translate(23.171 110.461)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12099",
    "data-name": "Rectangle 12099",
    width: 20.246,
    height: 4.902,
    transform: "translate(96.143 464.65) rotate(-19.859)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87616",
    "data-name": "Path 87616",
    d: "M150.688,345.171l-74.66,27c-.6.217-.341,1.184.265.964l74.66-27c.6-.217.342-1.184-.265-.964",
    transform: "translate(25.116 115.144)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87617",
    "data-name": "Path 87617",
    d: "M149.771,342.632l-74.66,27c-.6.217-.341,1.184.265.964l74.66-27c.6-.217.342-1.184-.265-.964",
    transform: "translate(24.811 114.297)",
    fill: "#e0e0e0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40878",
    "data-name": "Group 40878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40877",
    "data-name": "Group 40877",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87618",
    "data-name": "Path 87618",
    d: "M599.792,443.58c0,9.233-125.412,16.717-280.117,16.717S39.559,452.813,39.559,443.58s125.412-16.717,280.116-16.717,280.117,7.484,280.117,16.717",
    transform: "translate(13.127 142.409)",
    fill: "#f2f8ff"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12102",
    "data-name": "Rectangle 12102",
    width: 165.805,
    height: 115.702,
    transform: "translate(407.573 328.121) rotate(-70.139)",
    fill: "#e7f1ff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40886",
    "data-name": "Group 40886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40885",
    "data-name": "Group 40885",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87619",
    "data-name": "Path 87619",
    d: "M366.05,156.926c-1.117,3.1-4.331,3.992-9.139,2.252l-9.668-3.5,6.466-17.926,9.159,3.313c4.705,1.7,6.312,4.454,5.314,7.22a4.493,4.493,0,0,1-3.808,3.023,4.817,4.817,0,0,1,1.675,5.615m-4.912-2.413c.444-1.23-.264-2.152-2-2.782l-4.245-1.535-1.312,3.637,4.245,1.535c1.741.629,2.874.373,3.316-.855M357.4,143.231l-1.248,3.457,3.479,1.258c1.687.611,2.77.336,3.186-.816.406-1.127-.25-2.03-1.939-2.641Z",
    transform: "translate(115.226 45.957)",
    fill: "#096ef2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12105",
    "data-name": "Rectangle 12105",
    width: 19.055,
    height: 5.376,
    transform: "matrix(0.34, -0.941, 0.941, 0.34, 482.132, 208.751)",
    fill: "#096ef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87620",
    "data-name": "Path 87620",
    d: "M374.982,145.439l5.065,1.832-5.018,13.9,8.541,3.09-1.449,4.021-13.606-4.921Z",
    transform: "translate(122.284 48.521)",
    fill: "#096ef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87621",
    "data-name": "Path 87621",
    d: "M386.691,149.669l5.065,1.831-5.017,13.906,8.542,3.09-1.449,4.021L380.225,167.6Z",
    transform: "translate(126.17 49.932)",
    fill: "#096ef2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12106",
    "data-name": "Rectangle 12106",
    width: 4.945,
    height: 45.68,
    transform: "translate(457.103 222.25) rotate(-70.14)",
    fill: "#096ef2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40884",
    "data-name": "Group 40884",
    transform: "translate(433.098 235.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40883",
    "data-name": "Group 40883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40882",
    "data-name": "Group 40882",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12107",
    "data-name": "Rectangle 12107",
    width: 60.568,
    height: 94,
    transform: "translate(0 57.011) rotate(-70.14)",
    fill: "#f0f3f7"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12109",
    "data-name": "Rectangle 12109",
    width: 3.51,
    height: 94.024,
    transform: "matrix(0.34, -0.941, 0.941, 0.34, 453.061, 236.801)",
    fill: "#096ef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87622",
    "data-name": "Path 87622",
    d: "M343.28,186.167l25.423,9.2c.606.22.867-.747.266-.964l-25.425-9.2c-.6-.219-.866.747-.265.964",
    transform: "translate(113.798 61.776)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87623",
    "data-name": "Path 87623",
    d: "M339.4,196.908l25.423,9.2c.606.22.867-.747.265-.964l-25.423-9.2c-.6-.219-.866.747-.265.964",
    transform: "translate(112.51 65.36)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87624",
    "data-name": "Path 87624",
    d: "M342.286,188.918l8.164,2.953c.606.219.866-.747.265-.964l-8.164-2.953c-.6-.219-.866.747-.265.964",
    transform: "translate(113.468 62.694)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87625",
    "data-name": "Path 87625",
    d: "M340.429,194.058l36.711,13.277c.6.22.866-.747.265-.964l-36.711-13.277c-.6-.219-.866.747-.265.964",
    transform: "translate(112.852 64.409)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87626",
    "data-name": "Path 87626",
    d: "M387.459,201.582l13.582,4.913c.6.219.866-.748.265-.966l-13.582-4.912c-.6-.219-.866.747-.265.964",
    transform: "translate(128.458 66.919)",
    fill: "#0a192c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87627",
    "data-name": "Path 87627",
    d: "M384.435,209.954l13.582,4.913c.6.219.866-.748.265-.966L384.7,208.99c-.6-.219-.866.747-.265.964",
    transform: "translate(127.454 69.712)",
    fill: "#0a192c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87628",
    "data-name": "Path 87628",
    d: "M336.807,204.085l17.362,6.28c.606.219.867-.747.266-.964q-8.682-3.141-17.363-6.28c-.6-.219-.866.747-.265.964",
    transform: "translate(111.65 67.754)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87629",
    "data-name": "Path 87629",
    d: "M381.328,218.556l13.582,4.913c.6.219.866-.748.265-.966l-13.582-4.912c-.6-.219-.866.747-.265.964",
    transform: "translate(126.423 72.582)",
    fill: "#0a192c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87630",
    "data-name": "Path 87630",
    d: "M334.215,211.263l36.711,13.277c.6.22.866-.747.265-.964L334.48,210.3c-.6-.219-.866.747-.265.964",
    transform: "translate(110.79 70.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87631",
    "data-name": "Path 87631",
    d: "M378.221,227.158l13.582,4.913c.6.219.866-.748.265-.966l-13.582-4.912c-.6-.219-.866.747-.265.964",
    transform: "translate(125.392 75.452)",
    fill: "#0a192c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12110",
    "data-name": "Rectangle 12110",
    width: 5.471,
    height: 22.593,
    transform: "matrix(0.34, -0.941, 0.941, 0.34, 491.237, 324.79)",
    fill: "#32cbd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87632",
    "data-name": "Path 87632",
    d: "M319.319,242.824l64.976,23.5,18.342,6.633c.606.22.867-.747.265-.964l-64.975-23.5-18.343-6.635c-.6-.219-.866.747-.265.964",
    transform: "translate(105.847 80.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87633",
    "data-name": "Path 87633",
    d: "M320.342,239.991l64.976,23.5q9.17,3.319,18.342,6.635c.606.22.867-.747.265-.964l-64.975-23.5-18.343-6.635c-.6-.219-.866.747-.265.964",
    transform: "translate(106.186 79.733)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12111",
    "data-name": "Rectangle 12111",
    width: 6.354,
    height: 20.26,
    transform: "translate(538.52 227.01) rotate(-70.139)",
    fill: "#32cbd1"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40909",
    "data-name": "Group 40909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40908",
    "data-name": "Group 40908",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87634",
    "data-name": "Path 87634",
    d: "M387.51,144.383,257.634,86.141a2.223,2.223,0,0,1-1.117-2.935L293.143,1.313a2.216,2.216,0,0,1,2.93-1.119L425.949,58.437a2.222,2.222,0,0,1,1.117,2.934L390.44,143.264a2.216,2.216,0,0,1-2.93,1.119",
    transform: "translate(85.055 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40889",
    "data-name": "Group 40889",
    transform: "translate(377.8 20.344)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40888",
    "data-name": "Group 40888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40887",
    "data-name": "Group 40887",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87635",
    "data-name": "Path 87635",
    d: "M306.906,48.2l-21.614-9.693a2.746,2.746,0,0,1-1.381-3.627l8.051-18a2.74,2.74,0,0,1,3.623-1.383L317.2,25.188a2.747,2.747,0,0,1,1.381,3.627l-8.051,18a2.74,2.74,0,0,1-3.623,1.383",
    transform: "translate(-283.67 -15.255)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40892",
    "data-name": "Group 40892",
    transform: "translate(371.686 56.028)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40891",
    "data-name": "Group 40891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40890",
    "data-name": "Group 40890",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87636",
    "data-name": "Path 87636",
    d: "M280.034,45.222l17.308,7.762a1.673,1.673,0,0,0,1.365-3.053L281.4,42.169a1.673,1.673,0,0,0-1.365,3.053",
    transform: "translate(-279.079 -42.012)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40895",
    "data-name": "Group 40895",
    transform: "translate(398.333 67.978)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40894",
    "data-name": "Group 40894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40893",
    "data-name": "Group 40893",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87637",
    "data-name": "Path 87637",
    d: "M300.043,54.183l17.308,7.762a1.673,1.673,0,0,0,1.365-3.053L301.408,51.13a1.673,1.673,0,0,0-1.365,3.053",
    transform: "translate(-299.087 -50.973)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40898",
    "data-name": "Group 40898",
    transform: "translate(423.682 80.144)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40897",
    "data-name": "Group 40897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40896",
    "data-name": "Group 40896",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87638",
    "data-name": "Path 87638",
    d: "M319.076,63.305l17.308,7.762a1.673,1.673,0,0,0,1.365-3.053l-17.308-7.762a1.673,1.673,0,0,0-1.365,3.053",
    transform: "translate(-318.12 -60.095)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40901",
    "data-name": "Group 40901",
    transform: "translate(451.63 91.878)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40900",
    "data-name": "Group 40900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40899",
    "data-name": "Group 40899",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87639",
    "data-name": "Path 87639",
    d: "M340.061,72.1l17.308,7.762a1.673,1.673,0,0,0,1.365-3.053l-17.309-7.762a1.673,1.673,0,0,0-1.365,3.053",
    transform: "translate(-339.105 -68.894)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40904",
    "data-name": "Group 40904",
    transform: "translate(364.277 71.643)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40903",
    "data-name": "Group 40903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40902",
    "data-name": "Group 40902",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87640",
    "data-name": "Path 87640",
    d: "M274.292,56.465l18.121,8.372,28.938,13.371,6.718,3.1c1.739.8,3.263-1.782,1.513-2.591q-9.062-4.185-18.121-8.372L282.522,56.978l-6.716-3.1c-1.739-.8-3.264,1.782-1.513,2.591",
    transform: "translate(-273.516 -53.721)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40907",
    "data-name": "Group 40907",
    transform: "translate(465.24 61.819)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40906",
    "data-name": "Group 40906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40905",
    "data-name": "Group 40905",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87641",
    "data-name": "Path 87641",
    d: "M361.649,60.31l-9.3-4.172a5.114,5.114,0,0,1,4.175-9.337l9.3,4.172a5.114,5.114,0,0,1-4.175,9.337",
    transform: "translate(-349.324 -46.354)"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40923",
    "data-name": "Group 40923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40922",
    "data-name": "Group 40922",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41000",
    "data-name": "Group 41000",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 463.9, 361.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76649",
    "data-name": "Path 76649",
    d: "M56.657,45.439A30.351,30.351,0,1,1,45.369,4.048a30.269,30.269,0,0,1,11.288,41.39",
    transform: "translate(0 0)",
    fill: "#dde8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76650",
    "data-name": "Path 76650",
    d: "M43.176,34.627a23.129,23.129,0,1,1-8.6-31.542,23.065,23.065,0,0,1,8.6,31.542",
    transform: "translate(7.218 7.217)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76651",
    "data-name": "Path 76651",
    d: "M40.841,34.83a13.667,13.667,0,0,1,.851-2.719A24.554,24.554,0,0,0,42.9,24.63a23.811,23.811,0,0,0-.569-5.172,23.238,23.238,0,0,0-2.051-5.58,22.672,22.672,0,0,0-3.833-5.307,22.391,22.391,0,0,0-2.6-2.3,24.744,24.744,0,0,0-3.008-1.922,24.7,24.7,0,0,0-3.273-1.425,22.4,22.4,0,0,0-3.353-.876,22.59,22.59,0,0,0-6.537-.218,23.078,23.078,0,0,0-5.767,1.415,23.65,23.65,0,0,0-4.6,2.418A24.544,24.544,0,0,0,1.793,10.85C.679,12.275.143,13.143.02,13.076a6.782,6.782,0,0,1,1.209-2.622A21.375,21.375,0,0,1,6.58,4.648,23.125,23.125,0,0,1,17.475.215a22.389,22.389,0,0,1,3.444-.2,22.634,22.634,0,0,1,3.59.331,23.423,23.423,0,0,1,3.624.918,25.6,25.6,0,0,1,3.536,1.529,25.581,25.581,0,0,1,3.24,2.081,23.75,23.75,0,0,1,2.785,2.5,23.643,23.643,0,0,1,4.038,5.771,23.212,23.212,0,0,1,2.419,11.527,21.439,21.439,0,0,1-1.815,7.692,6.8,6.8,0,0,1-1.495,2.47",
    transform: "translate(9.906 6.382)",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-rupee-sign",
    "data-name": "Icon awesome-rupee-sign",
    d: "M15.878,3.311a.618.618,0,0,0,.618-.618V.631a.62.62,0,0,0-.619-.619L.619,0A.618.618,0,0,0,0,.62L0,2.926a.62.62,0,0,0,.619.619l4.4,0A3.723,3.723,0,0,1,8.161,4.955L.623,4.95A.618.618,0,0,0,0,5.569V7.631a.62.62,0,0,0,.619.619l8.183.005a3.556,3.556,0,0,1-3.851,3.02l-4.33,0a.618.618,0,0,0-.618.618l0,2.733a.62.62,0,0,0,.2.455l8.512,7.86a.619.619,0,0,0,.42.164l4.255,0a.618.618,0,0,0,.419-1.073L6.035,14.847a7.05,7.05,0,0,0,7.125-6.589l2.722,0a.618.618,0,0,0,.618-.618V5.579a.62.62,0,0,0-.619-.619l-3.025,0a7.072,7.072,0,0,0-.736-1.65Z",
    transform: "translate(27.977 16.329) rotate(26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41001",
    "data-name": "Group 41001",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 514.221, 85.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76649-2",
    "data-name": "Path 76649",
    d: "M75.48,60.533A40.436,40.436,0,1,1,60.46,5.369,40.357,40.357,0,0,1,75.48,60.533",
    transform: "translate(0 0)",
    fill: "#dde8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76650-2",
    "data-name": "Path 76650",
    d: "M57.52,46.13A30.815,30.815,0,1,1,46.074,4.091,30.753,30.753,0,0,1,57.52,46.13",
    transform: "translate(9.615 9.616)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76651-2",
    "data-name": "Path 76651",
    d: "M54.409,46.4c-.165-.087.392-1.328,1.135-3.625A32.747,32.747,0,0,0,57.157,32.8a31.733,31.733,0,0,0-.756-6.894,30.951,30.951,0,0,0-2.731-7.437A30.183,30.183,0,0,0,48.564,11.4,29.8,29.8,0,0,0,45.1,8.344,32.936,32.936,0,0,0,41.1,5.784a32.88,32.88,0,0,0-4.361-1.9A29.827,29.827,0,0,0,32.269,2.72a30.1,30.1,0,0,0-8.711-.287,30.77,30.77,0,0,0-7.686,1.89A31.548,31.548,0,0,0,9.739,7.55a32.753,32.753,0,0,0-7.356,6.911C.9,16.361.182,17.518.018,17.428c-.123-.062.316-1.371,1.613-3.5A28.526,28.526,0,0,1,8.767,6.19,30.843,30.843,0,0,1,23.288.275,29.837,29.837,0,0,1,27.878,0a30.152,30.152,0,0,1,4.785.439,31.194,31.194,0,0,1,4.83,1.222A34.08,34.08,0,0,1,42.2,3.7,34.053,34.053,0,0,1,46.52,6.473,31.613,31.613,0,0,1,50.23,9.8a31.476,31.476,0,0,1,5.378,7.69,30.93,30.93,0,0,1,3.217,15.364A28.6,28.6,0,0,1,56.4,43.108c-1.034,2.264-1.873,3.36-1.994,3.294",
    transform: "translate(13.197 8.5)",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-rupee-sign-2",
    "data-name": "Icon awesome-rupee-sign",
    d: "M21.153,4.41a.824.824,0,0,0,.824-.824V.836a.825.825,0,0,0-.824-.825L.825,0A.824.824,0,0,0,0,.826V3.9a.825.825,0,0,0,.824.825l5.856,0A4.957,4.957,0,0,1,10.871,6.6L.828,6.6A.824.824,0,0,0,0,7.424v2.749A.825.825,0,0,0,.83,11l10.9.005c-.426,2.48-2.262,4.029-5.132,4.028l-5.768,0a.824.824,0,0,0-.824.824l0,3.644a.826.826,0,0,0,.265.606L11.614,30.581a.824.824,0,0,0,.559.219l5.67,0a.824.824,0,0,0,.558-1.431L8.036,19.794a9.4,9.4,0,0,0,9.494-8.787l3.627,0a.824.824,0,0,0,.824-.824V7.435a.825.825,0,0,0-.824-.825l-4.03,0a9.43,9.43,0,0,0-.98-2.2Z",
    transform: "translate(37.275 21.748) rotate(26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_87642",
    "data-name": "Path 87642",
    d: "M353.214,493.6H196.494c-17.624-.012-31.909-14.316-32.895-31.752V86.753c.986-17.861,15.271-32.164,32.895-32.176h156.72a31.964,31.964,0,0,1,31.921,31.964V461.636A31.965,31.965,0,0,1,353.214,493.6",
    transform: "translate(54.287 18.208)",
    fill: "#0a192c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87643",
    "data-name": "Path 87643",
    d: "M351.166,60.1H310.435a5.275,5.275,0,0,0-5.251,4.564l-.173,1.282a13.028,13.028,0,0,1-12.847,11.321H253.45A13.026,13.026,0,0,1,240.6,65.946l-.152-1.282a5.32,5.32,0,0,0-5.274-4.629H194.445a24.6,24.6,0,0,0-24.673,24.533V459.815a24.6,24.6,0,0,0,24.587,24.62h156.72a24.625,24.625,0,0,0,24.608-24.62V84.72A24.625,24.625,0,0,0,351.166,60.1",
    transform: "translate(56.335 20.029)",
    fill: "#e7f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40915",
    "data-name": "Group 40915",
    transform: "translate(313.409 81.172)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40914",
    "data-name": "Group 40914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40913",
    "data-name": "Group 40913",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87645",
    "data-name": "Path 87645",
    d: "M241.571,63.973a3.125,3.125,0,1,1-3.147-3.107h.044a3.1,3.1,0,0,1,3.1,3.107",
    transform: "translate(-235.322 -60.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87646",
    "data-name": "Path 87646",
    d: "M260.018,60.866H249.341a3.107,3.107,0,0,0,0,6.215h10.677a3.107,3.107,0,0,0,0-6.215",
    transform: "translate(-231.7 -60.866)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12123",
    "data-name": "Rectangle 12123",
    width: 3.299,
    height: 3.303,
    transform: "translate(243.251 93.992)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87647",
    "data-name": "Path 87647",
    d: "M187.581,71.306v3.3h3.3V68h-3.3Z",
    transform: "translate(62.245 22.687)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87648",
    "data-name": "Path 87648",
    d: "M192.535,65.543V75.43h3.3V65.543Z",
    transform: "translate(63.889 21.866)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87649",
    "data-name": "Path 87649",
    d: "M299.348,65.7v2.413h-1.606v4.845h1.606v2.413H313.93V65.7Zm6.51,7.258H300.91V68.118h4.839Z",
    transform: "translate(98.8 21.92)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41003",
    "data-name": "Group 41003",
    transform: "translate(253.124 207.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41003-2",
    "data-name": "Group 41003",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87732",
    "data-name": "Path 87732",
    d: "M163.841,9.069c-.183.767.362.622.785.622q10.683,0,21.364.006c.777,0,1.627-.135,2.152.691a.325.325,0,0,1-.244.081,3.342,3.342,0,0,0-1.171-.332,4.045,4.045,0,0,0-1.15-.079q-9.949,0-19.9,0a2.3,2.3,0,0,1-.8-.041,9.878,9.878,0,0,0,1.73.041q9.375.008,18.751,0a8.789,8.789,0,0,1,1.8.172c.82.17,1.132.57,1.011,1.4a7.483,7.483,0,0,1-.491,1.741,2.035,2.035,0,0,0-.36,1,29.108,29.108,0,0,0-.849,2.982,12.872,12.872,0,0,0-.873,2.494,3.6,3.6,0,0,1-2,3.012,4.532,4.532,0,0,1-1.932.33q-12.841.029-25.683.007c-1.105,0-1.236-.214-.905-1.305.215-.71.476-1.405.658-2.126a1.15,1.15,0,0,1,1.215-.666q1.611,0,3.223,0H179.52a12.911,12.911,0,0,0,1.319-.029c.35-.062.476-.341.577-.627.414-1.181.749-2.386,1.134-3.575a.625.625,0,0,0-.188-.807c-1.177-.087-2.356-.108-3.533-.111-6.123-.021-12.246-.01-18.369-.01-.331,0-.663.015-.993-.016a1.34,1.34,0,0,1-1.343-1.616,3.893,3.893,0,0,1,.255-1.04c.553-1.5.9-3.055,1.448-4.548.63-.116.434-.589.419-.985a.613.613,0,0,1,.26-.5c.241-.095.38.339.532.184.223-.228.008-.44-.2-.6a.544.544,0,0,1-.175-.361.633.633,0,0,1,.155-.523c.232-.077.229-.216.1-.388a.382.382,0,0,1,.169-.377c.423-.145.42-.829,1.056-.778-.21-.068-.382-.078-.492-.214-.086-.236.05-.348.24-.43a.288.288,0,0,0,.363-.246.329.329,0,0,1,.167-.126.581.581,0,0,0,.752-.393.943.943,0,0,1,.269-.055,56.865,56.865,0,0,0,7.247.135c5.677.035,11.354,0,17.031.018,1.159,0,2.315.144,3.476.171a3.164,3.164,0,0,1-.6,2.2c-.347.268-.755-.032-1.122.112.344.219.968.2.732.888a1.2,1.2,0,0,1-.86.223c-7.974-.006-15.949.037-23.922-.018-.224-.014-.434-.114-.66-.122-.584.1-.793.421-.81,1.031a9.335,9.335,0,0,1-.017,1.974c-.026.107.025.229-.019.326-.191.415-.312,1.112-.663,1.139-.456.035-.365-.68-.63-1.105.059.38.331.651.211.992a.4.4,0,0,0,.227.545c.295.14.383-.085.5-.27a.2.2,0,0,1,.278-.084",
    transform: "translate(-47.971 -0.281)",
    fill: "#243081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87733",
    "data-name": "Path 87733",
    d: "M110.68,3.991c.208-1.2.737-2.3,1.024-3.476C111.8.14,112.062.1,112.4.1q13.639.011,27.277.02c.373,0,.855-.118,1.066.395A4.8,4.8,0,0,1,139.2.446q-13.143.023-26.285.012c-.425,0-.924-.12-.986.569a.6.6,0,0,1,.72-.57c.467.02.937,0,1.4,0h24.88a6.667,6.667,0,0,1,.988.046c1.4.208,1.627.529,1.3,1.93-.159.666-.745,1.207-.591,1.971-.463,2.071-1.384,4.014-1.749,6.107a3.751,3.751,0,0,1-4.053,3.181c-6.923-.054-13.847-.023-20.77-.017a2.864,2.864,0,0,0-1.3.12,17.043,17.043,0,0,0-1.2,3.639l.009-.016c-.226.255-.2.619-.386.893a.862.862,0,0,0-.19.195,17.421,17.421,0,0,0-1.029,3.3,1.127,1.127,0,0,1-1.289.97c-.88-.037-1.763.025-2.643-.024-.687-.038-.836-.252-.616-.909.959-2.865,1.726-5.79,2.721-8.645.3-.852.511-1.735.819-2.589a1.156,1.156,0,0,1,1.227-.874c1.074.01,2.148,0,3.222,0q9.83,0,19.662,0A2.194,2.194,0,0,0,134.2,9.62a3.48,3.48,0,0,0,.645-1.483c.278-.939.586-1.866.9-2.794.109-.324.278-.7-.177-.933a6.938,6.938,0,0,0-2.051.008q-10.526-.013-21.052,0a3.289,3.289,0,0,1-1.519-.3.428.428,0,0,1-.262-.128",
    transform: "translate(-32.612 -0.03)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87734",
    "data-name": "Path 87734",
    d: "M212.129,19.109c-.9.7-1.666,1.555-2.625,2.18-.518-.093-.3-.374-.151-.622.1-.165.417-.274.157-.525a2.229,2.229,0,0,1-.516-2.48,1.592,1.592,0,0,0-.013-.407,7,7,0,0,1,.673-1.848c1.133-.079,2.213-.678,3.386-.366a1.3,1.3,0,0,0,.786-.155c.393-.128.806-.135,1,.3.215.486-.213.6-.54.738-.5.216-1.028.369-1.2,1.01-.122.441-.466.2-.807.07.428.559.752.68,1.06.007.245-.535.8-.676,1.257-.949.726-.433,1.177-1.195,1.953-1.625-.79-.3-1.551.4-2.291-.107-.145-.1-.319.162-.473.272a3.614,3.614,0,0,1-3.381-.092.817.817,0,0,1-.293-.571,9.25,9.25,0,0,1,.582-2.272c.639-1.837,1.089-3.73,1.689-5.579a22.155,22.155,0,0,0,.987-3.134.582.582,0,0,1,.436-.547c.292-.044.435.216.55.423a21.607,21.607,0,0,1,1.361,2.436,1.731,1.731,0,0,0,1,1.132,1.451,1.451,0,0,1,.556.594c.835,1.547,1.712,3.071,2.585,4.6a.977.977,0,0,1-.2,1.372c-1.316,1.293-2.812,2.373-4.184,3.6-.675.6-1.374,1.181-2.062,1.769a4.162,4.162,0,0,0-.7.533c-.156.173-.382.18-.583.247",
    transform: "translate(-64.664 -0.742)",
    fill: "#f57821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87735",
    "data-name": "Path 87735",
    d: "M214.652,17.738c1.689-1.454,3.358-2.932,5.071-4.357,1.733-1.442,1.761-1.425.688-3.34-.752-1.342-1.535-2.669-2.3-4-.07-.1-.2-.15-.227-.28a.4.4,0,0,1,.032-.271q.69-2.175,1.38-4.35c.052-.165.016-.424.307-.377.154.024.191.172.193.317-.581,1.191-.759,2.517-1.239,3.682-.051.158.126.1.016.1-.014,0-.015-.029,0-.081.322-.872.521-1.783.831-2.659.168-.475.382-.51.633-.055.478.868,1,1.709,1.393,2.625.336.776.951,1.4,1.348,2.16.168.318.4.612.134.985-.013.019-.055.1-.012.083.521-.169.563.3.739.561.553.824.976,1.725,1.485,2.574a.881.881,0,0,1-.191,1.305c-1.042.8-1.825,1.93-3.1,2.439-.422.169-.474.655-.8.919-1.334,1.066-2.561,2.272-3.931,3.281a34.121,34.121,0,0,1-2.833,2.348c-.246.144-.416.551-.751.368-.311-.169-.149-.549-.168-.842.115-.748.452-1.435.574-2.184.068-.418.456-.65.728-.945",
    transform: "translate(-66.054 -0.233)",
    fill: "#008b44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87736",
    "data-name": "Path 87736",
    d: "M91.638,2.685c-.7.96-.746,2.157-1.183,3.211a.654.654,0,0,1-.2.327A10,10,0,0,1,90.8,3.511a7.842,7.842,0,0,0,.426-1.969.689.689,0,0,0-.6-.8,2.608,2.608,0,0,0-.737-.045C81.017.693,72.142.7,63.267.675c-.677,0-.966.189-1.115.837C61.741,3.3,60.983,4.977,60.6,6.782a40.731,40.731,0,0,1-1.362,4.046c-.282.856-.477,1.741-.77,2.593-.179.523.235,1.242-.557,1.586-.2.085.039.545-.235.741-.257-.225-.16-.518-.15-.793.665-2.044,1.218-4.124,1.9-6.164.1-.284.146-.576.221-.863.427-2,1.165-3.9,1.754-5.844.615-2.035.633-2.03,2.8-2.03h25.38c.138,0,.275,0,.413,0,1.616.045,2.278,1.1,1.653,2.632",
    transform: "translate(-17.803 -0.016)",
    fill: "#202e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87737",
    "data-name": "Path 87737",
    d: "M161.458,6.42c-.5.483-.423,1.166-.616,1.755-.383,1.168-.777,2.334-1.1,3.519-.368,1.339.05,1.839,1.45,1.839q9.557,0,19.115-.008c.979,0,1.95.366,2.941.026a.708.708,0,0,1,.723.311c-.139.124-.305.088-.471.087q-11.166-.013-22.332,0a2.749,2.749,0,0,1-1.36-.25c-.837-.67-.924-1.264-.365-2.491q1.389-4.189,2.606-8.431a8.887,8.887,0,0,1,.558-1.19.42.42,0,0,1,.294-.315,6.166,6.166,0,0,1,1.461-.74,1.992,1.992,0,0,1,.968-.149l26.84,0c.938,0,.947.008.679.933-.276.949-.581,1.89-.893,2.828-.114.343-.24.624-.679.518a2.433,2.433,0,0,0-.738-.064q-10.948,0-21.895,0a3.262,3.262,0,0,0-.411.021,2.225,2.225,0,0,1-.741.052c-.317-.23-.89.209-1.062-.4q12.068,0,24.136,0c.366,0,.8.135,1.022-.327a.665.665,0,0,1,.165-.662,13.042,13.042,0,0,0,.662-1.985c.129-.249.054-.342-.225-.341-8.433.025-16.867-.01-25.3.026a9.478,9.478,0,0,0-2.447-.017h-.165c-.141.271-.458.186-.663.33-.11.111-.135.306-.331.33a.574.574,0,0,0-.331.331,3.7,3.7,0,0,1-.5,1.158.341.341,0,0,0-.164.331.22.22,0,0,1,0,.33c-.193.12-.159.315-.164.5-.15.26.017.646-.331.827-.055.165-.11.33-.164.5a.814.814,0,0,1-.167.826",
    transform: "translate(-49.259 -0.119)",
    fill: "#1b297c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87738",
    "data-name": "Path 87738",
    d: "M37.261,9.665c0-.055,0-.111,0-.165.17-.427.01-.935.331-1.324.8-.773.646-1.88.993-2.812.165-.271,0-.6.136-.87a2.041,2.041,0,0,1,.157-.538c.264-.5-.223-.069-.249-.205a.353.353,0,0,1-.045-.538c.01-.109.029-.2.164-.232a1.041,1.041,0,0,0,.664-1.753c-.289-.57-.975-.084-1.324-.5C29.492.732,20.9.744,12.3.713c-.848,0-1.508.051-1.829.962C9.985,3.055,9.709,4.5,9.13,5.858c.577-.256.307-1.1,1.007-1.271-.117.42-.251.816-.336,1.224-.066.316-.016.361.38.472.075.021.176.006.135.1a.8.8,0,0,1-.244.31c-.128.095-.312.208-.426,0-.44-.791-.575-.223-.708.164-.273.8-.808,1.539-.385,2.476.11.244-.605.63.1.881-.315.354-.42-.466-.653-.008-.18.355.266.4.471.741-1.181-.372-1.087.511-1.28,1.115-.312.973-.431,1.983-.793,2.967a34.861,34.861,0,0,0-1.271,3.915c-.037.156-.186.346-.027.458.958.679.063.773-.315,1.027a2.721,2.721,0,0,1-.293.151c-.281-.546.266-1.035.11-1.573.8-2.566,1.649-5.118,2.356-7.713l-.01.015c.527-1.6,1.122-3.172,1.5-4.816l-.01.017a7.72,7.72,0,0,0,.352-1.162l0,.008A39.728,39.728,0,0,0,10.264.514L10.47.236a5.773,5.773,0,0,1,1.548.01Q25,.225,37.973.239a2.039,2.039,0,0,1,1.495.312c.232,0,.286.238.442.341.537.94.066,1.757-.315,2.585.137.384-.255.682-.173,1.058C38.845,6,38.513,7.538,38,9.02a3.011,3.011,0,0,1-.405.973l-.141.165a2.466,2.466,0,0,1-.523.515l-.607.5c-.158-.027-.353-.018-.418-.191-.052-.142.1-.143.2-.16a4.588,4.588,0,0,1,1.158-1.157",
    transform: "translate(-1.365 -0.055)",
    fill: "#203080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87739",
    "data-name": "Path 87739",
    d: "M134.192,13.821c.035.458-.317.321-.539.326-.772.015-1.544.006-2.315.006-7.028,0-14.056.012-21.083-.018-.752,0-1.128.18-1.357.93C108,18,107.005,20.9,106.136,23.836c-.239.807-.458,1.621-.759,2.406-.155.406-.01.487.347.485,1.075-.006,2.15,0,3.225,0,.363,0,.517-.175.588-.541a17.674,17.674,0,0,1,.949-3.385c.077-.188.125-.366.368-.373.221.526-.124.957-.265,1.411a16.321,16.321,0,0,1-.872,2.641c0,.082-.009.165-.013.247-.111.214-.187.424-.516.42-1.395-.018-2.79,0-4.184-.011-.171,0-.337-.032-.289-.274.715-2.49,1.456-4.972,2.305-7.42.642-1.717,1.107-3.49,1.689-5.226a.707.707,0,0,1,.816-.571c7.709.023,15.417.014,23.126.016a4.327,4.327,0,0,1,1.543.163",
    transform: "translate(-32.421 -4.212)",
    fill: "#1c2b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87740",
    "data-name": "Path 87740",
    d: "M4.207,27.559c.39.547-.184.978-.18,1.479-.567,1.984-.567,1.984,1.488,1.984,8,0,15.993-.023,23.989.021a5.372,5.372,0,0,0,3.819-1.177.28.28,0,0,1,.014.363,3.268,3.268,0,0,1-2.755,1.234q-13.549.012-27.1.013c-.554,0-.689-.144-.483-.668.251-.636.445-1.295.663-1.944.32-.377.226-.926.541-1.305",
    transform: "translate(-0.901 -8.508)",
    fill: "#18257a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87741",
    "data-name": "Path 87741",
    d: "M213.289,21.051c.039.231-.085.485.118.738.553-.581,1.343-.9,1.809-1.5.752-.964,1.863-1.437,2.708-2.265a24.221,24.221,0,0,0,2.754-2.4c.547-.738,1.308-.966,1.916-1.488.728-.626,1.417-1.3,2.131-1.938.267-.241.295-.424.084-.763-.579-.928-1.1-1.894-1.618-2.856-.226-.418-.4-.915-.87.1.835-1.174-.059-1.8-.476-2.435a20.214,20.214,0,0,1-1.369-2.526c-.278-.589-.663-1.128-1.034-1.745-.544,1.148-.592,2.467-1.311,3.671a9.016,9.016,0,0,1,.639-2.531c.11-.59.334-1.157.465-1.744.057-.259.167-.228.337-.165q2.436,4.3,4.869,8.606c.4.714,1.107,1.472,1.058,2.166-.052.73-1.1,1.126-1.721,1.657q-5.326,4.558-10.681,9.085a2.124,2.124,0,0,1-.276.172c-.077.015-.214.023-.2-.043a2.72,2.72,0,0,1,.672-1.794",
    transform: "translate(-65.835 -0.357)",
    fill: "#03873c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87742",
    "data-name": "Path 87742",
    d: "M158.947,19.647a10.368,10.368,0,0,0,2.536.16l21.627,0c.226.656-.19,1.2-.338,1.782a18.333,18.333,0,0,1-1.149,3.348,1.1,1.1,0,0,1-.646.078q-11.875,0-23.75,0c-.318,0-.677.1-.911-.241.2-.293.505-.14.757-.14,7.881-.008,15.762-.019,23.644.012a1.01,1.01,0,0,0,1.188-.9,25.08,25.08,0,0,1,.882-2.838c.266-.7.146-.894-.624-.891-4.6.015-9.2-.015-13.8-.025-2.7-.006-5.4,0-8.1,0a1.6,1.6,0,0,1-1.309-.346",
    transform: "translate(-48.402 -6.065)",
    fill: "#253382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87743",
    "data-name": "Path 87743",
    d: "M193.42,4.541a.438.438,0,0,0,.537-.369c.312-1.053.632-2.106,1-3.141.191-.539-.032-.638-.487-.614-.165.009-.331,0-.5,0q-12.95,0-25.9,0a7.1,7.1,0,0,0-1.8.186.121.121,0,0,1-.191-.03,2.034,2.034,0,0,1,1.334-.337q13.649-.006,27.3-.012c.558,0,.752.1.541.7-.356,1.013-.668,2.043-.944,3.081-.154.579-.429.761-1.042.759-7.887-.024-15.773,0-23.66-.036a1.089,1.089,0,0,0-1.267.935c-.249.926-.591,1.828-.893,2.74a.418.418,0,0,1-.144-.438,16.4,16.4,0,0,1,.889-3.3c.438-.34.916-.183,1.388-.115h.661a1.255,1.255,0,0,1,.648-.069q10.939,0,21.879,0a1.255,1.255,0,0,1,.648.069",
    transform: "translate(-51.426 -0.068)",
    fill: "#243181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87744",
    "data-name": "Path 87744",
    d: "M83.275,31.545a2.985,2.985,0,0,1-1.814.425q-13.422.008-26.843.015c-.67,0-.842-.156-.577-.8a20.957,20.957,0,0,1,.688-2.02c.337.565-.06,1.056-.173,1.569-.176.79-.145.865.659.865q13.154,0,26.31.016c.588,0,1.156-.394,1.751-.074",
    transform: "translate(-16.697 -9.005)",
    fill: "#243081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87745",
    "data-name": "Path 87745",
    d: "M135.229,13.146c-8.043,0-16.087.025-24.13-.031-.924-.007-1.269.24-1.485,1.085-.332,1.3-.784,2.572-1.2,3.85-.081.248-.076.556-.353.714.415-1.883,1.121-3.678,1.661-5.523.144-.494.555-.361.893-.361q6.734-.005,13.467,0c3.36,0,6.721-.039,10.079.029.842.017,1.212-.246,1.354-1.009a1.987,1.987,0,0,1,.2-.443.12.12,0,0,1,.074.117q-.007.073-.029.073a4.24,4.24,0,0,1-.524,1.5",
    transform: "translate(-33.459 -3.537)",
    fill: "#313d8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87746",
    "data-name": "Path 87746",
    d: "M42.186.5A2.866,2.866,0,0,0,41.05.345q-12.826,0-25.65,0A7.824,7.824,0,0,1,13.188.182c.2-.3.506-.14.755-.14q13.388-.015,26.776,0c.521,0,1.123-.161,1.467.456",
    transform: "translate(-4.084 0)",
    fill: "#243282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87747",
    "data-name": "Path 87747",
    d: "M137.234,9.878l-.045-.19a12.193,12.193,0,0,1,.729-2.532c.249-.688.03-.786-.6-.785q-8.973.024-17.947.009c-1.985,0-3.97-.007-5.954.006-.539,0-.766-.129-.413-.657l.059.037a3.771,3.771,0,0,0,1.45.244q10.785-.011,21.57,0a5.951,5.951,0,0,1,2.113.075c.24.194.165.425.085.663q-.528,1.565-1.051,3.13",
    transform: "translate(-34.939 -1.769)",
    fill: "#243381"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87748",
    "data-name": "Path 87748",
    d: "M216.016,5.838l.186.33c-.841-.049-.967-.771-1.273-1.336a31.248,31.248,0,0,0-1.63-2.724c-.4,1.179-.779,2.309-1.165,3.437-.669,1.955-1.156,3.968-1.8,5.934a6.835,6.835,0,0,0-.55,2.133,2.322,2.322,0,0,1-.5,1.489l-.662,1.819c0,.624-.426,1.176-.308,1.82a3.23,3.23,0,0,1-.205.754c-.184.4-.217,1.167-.721,1.005s.012-.744.095-1.134c.238-1.12.692-2.179.959-3.292l-.01.012a26.245,26.245,0,0,0,.971-3.135c.8-2.19,1.388-4.446,2.094-6.665.539-1.694,1.116-3.376,1.584-5.112.463.052.439.505.69.688a20.235,20.235,0,0,1,1.651,2.95,1.836,1.836,0,0,0,.592,1.025",
    transform: "translate(-64.15 -0.363)",
    fill: "#f4751d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87749",
    "data-name": "Path 87749",
    d: "M83.407,29.2c-3.126.3-6.26.112-9.39.129-6.275.034-12.549.01-18.825.01h-.845a13.591,13.591,0,0,0,.513-2.516l.806-2.8c.213-.2.1-.538.32-.733.318-.541.13-1.289.71-1.721v.827c-.5,2.078-1.439,4.021-1.908,6.11-.1.465-.047.7.472.673.137-.007.276,0,.414,0q12.825,0,25.65,0a3.64,3.64,0,0,0,2.518-.825c.338-.15.409-.013.266.275a.931.931,0,0,1-.43.37l-.271.208",
    transform: "translate(-16.828 -6.656)",
    fill: "#18257a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87750",
    "data-name": "Path 87750",
    d: "M155.765,28.181a5.973,5.973,0,0,1-.526,1.98c-.356,1.168-.376,1.162.879,1.162h25.309a3.785,3.785,0,0,0,3.047-1.079,2.944,2.944,0,0,0,.573-1.154,3.328,3.328,0,0,1,.344-1.076c.153-.047.226.045.284.162a3.59,3.59,0,0,1-.59,1.91l.025.041-.03.037a3.515,3.515,0,0,1-.847.827l-.446.357a7.991,7.991,0,0,1-3.009.38q-12.412-.015-24.825-.006c-1.553,0-1.537,0-1.118-1.475a17.557,17.557,0,0,1,.678-2.117c.049-.044.026-.154.156-.127s.068.118.1.178",
    transform: "translate(-47.869 -8.644)",
    fill: "#18277c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87751",
    "data-name": "Path 87751",
    d: "M143.892,2.817a1.646,1.646,0,0,1,0-.165c.191-1.689-.043-1.977-1.816-1.979-8.763-.012-17.526.014-26.289-.032-.982-.006-.8.755-1.131,1.246C114.607.578,114.683.5,115.87.5q13.268,0,26.537,0a4.2,4.2,0,0,1,1.221.138l.264.031c.714.461.656,1.165.516,1.843a5.024,5.024,0,0,1-.521,1.47.166.166,0,0,1-.224-.057,1.566,1.566,0,0,1,.229-1.107",
    transform: "translate(-35.499 -0.154)",
    fill: "#132378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87752",
    "data-name": "Path 87752",
    d: "M155.524,27.85c-.3.972-.585,1.949-.906,2.913-.136.409-.035.573.389.557.193-.008.386,0,.579,0q11.253,0,22.506,0a43.958,43.958,0,0,0,5.6-.137,1.686,1.686,0,0,1-.708.314,3.08,3.08,0,0,1-1.134.158q-13.3,0-26.59-.015c-.4,0-1.141.29-.927-.656q.568-1.766,1.136-3.532a.283.283,0,0,1,.05.4",
    transform: "translate(-47.778 -8.473)",
    fill: "#31418c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87753",
    "data-name": "Path 87753",
    d: "M96.831,27.791c-.063-.245.669-.288.164-.645.811-.556.795-1.52,1.123-2.311.208-.5.322-1.045.494-1.564.074-.226.188-.386.007-.668a.524.524,0,0,1,.271-.833c.6-.286.322-1.125.753-1.572a3.024,3.024,0,0,0,.455-2.072c-.031-.162-.1-.313.057-.445a1.389,1.389,0,0,1,.258,1.6q-1.046,3.474-2.155,6.93a2.271,2.271,0,0,1-1.426,1.577",
    transform: "translate(-29.982 -5.458)",
    fill: "#1f2e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87754",
    "data-name": "Path 87754",
    d: "M114.358,23.416a17.8,17.8,0,0,1,.977-3.664,2.108,2.108,0,0,1,1.209-.16q10.363-.007,20.725,0a10.506,10.506,0,0,0,1.971-.135.483.483,0,0,1,.287.144,2.6,2.6,0,0,1-1.673.293c-7.141.006-14.282.015-21.422-.014-.7,0-1.042.18-1.216.876-.224.9-.566,1.775-.857,2.661",
    transform: "translate(-35.41 -6.007)",
    fill: "#243382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87755",
    "data-name": "Path 87755",
    d: "M168.11,6.429a17.989,17.989,0,0,1-.67,2.734,2.218,2.218,0,0,0-.138.949.468.468,0,0,1-.155.457.387.387,0,0,0-.195.339c-.019.207-.065.6-.3.405-.277-.23-1.066-.129-.8-.7.288-.625-.045-.96-.251-1.453.22.136,1-.609.612.494-.066.188.191.489.3.73.8-1.184.552-2.5.512-3.8-.017-.538.563-.606.928-.823.178.189.374.375.166.662",
    transform: "translate(-51.276 -1.781)",
    fill: "#233180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87756",
    "data-name": "Path 87756",
    d: "M208.02,25.4a4.769,4.769,0,0,1,.5-1.82c.2.26.07.514-.006.774a1.7,1.7,0,0,0,.913,2.153c.052.474-1.072.346-.542,1.063a1.863,1.863,0,0,1-.852.689c-.1-.092-.037-.247-.126-.344-.574.87-.689-.006-.969-.254a1.6,1.6,0,0,1-.11-.116,36.3,36.3,0,0,1,1.512-4.811,25.374,25.374,0,0,1-1,3.7,1.117,1.117,0,0,0-.1.663c.543-.164.307-.767.619-1.03.158-.195.356-.38.166-.662",
    transform: "translate(-64.041 -7.017)",
    fill: "#f47821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87757",
    "data-name": "Path 87757",
    d: "M156.05,27.733q-.025-.2-.05-.4l.217-.263a4.062,4.062,0,0,0,1.3.169q12-.009,24.01,0c-.272.285-.623.16-.938.16q-11.593.01-23.187,0c-.49,0-.93.022-1.2.5l-.151-.161",
    transform: "translate(-48.304 -8.356)",
    fill: "#1b287b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87758",
    "data-name": "Path 87758",
    d: "M220.789,41.843a8.74,8.74,0,0,0-.454.831.308.308,0,0,1-.454.191.319.319,0,0,1-.061-.5,15.432,15.432,0,0,1,1.31-2.016,3.841,3.841,0,0,0,.46-.892c-.017-.123,0-.233.128-.289.2-.106.383-.33.492.138a6.7,6.7,0,0,0,.42,1.7l0-.011c.185.131-.157.77.464.484l-.01.021a2.956,2.956,0,0,0,.514-.674,7.479,7.479,0,0,1,1.3-1.515.3.3,0,0,1,.158.13,4.546,4.546,0,0,1,.289.678.9.9,0,0,1-.05.43.383.383,0,0,1-.316.059c-.316-.2-.528-.05-.708.21l-1.52,1.684c-.606.156-.237-.456-.469-.594-.139-.376-.227-.77-.395-1.137-.106-.232-.238-.278-.429-.1l-.168.344c-.206.251-.3.571-.493.829",
    transform: "translate(-68.038 -12.047)",
    fill: "#323234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87759",
    "data-name": "Path 87759",
    d: "M80.346,42.662c-1.322,0-1.321,0-.929-1.289.257-.843.516-1.687.759-2.534.1-.365.284-.647.691-.5.429.158.1.469.041.69-.224.8-.454,1.592-.732,2.37-.188.527-.053.677.494.688.329.006.958-.281.951.243-.008.57-.659.252-1.027.328a1.287,1.287,0,0,1-.248,0",
    transform: "translate(-24.52 -11.824)",
    fill: "#2f2f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87760",
    "data-name": "Path 87760",
    d: "M151.807,39.517a6.785,6.785,0,0,1,1.3,1.468c.07.418.431.283.681.358.159.14-.027.368.13.509.026.243.1.532-.188.641-.211.08-.313-.178-.42-.311a23.979,23.979,0,0,1-1.883-2.133c-.06-.185-.232-.246-.372-.335a.159.159,0,0,1-.026-.131c0-.021-.057-.01-.069.048a2.844,2.844,0,0,1-.064.362c-.135.671-.407,1.3-.552,1.974-.195.207-.106.572-.4.723l-.164,0c-.334-.693.313-1.219.329-1.86a1.451,1.451,0,0,1,.246-.687c-.007-.409.208-.777.224-1.182-.022-.163-.041-.394.115-.43.273-.064.39.231.573.377a5.013,5.013,0,0,0,.547.607",
    transform: "translate(-46.346 -11.893)",
    fill: "#303032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87761",
    "data-name": "Path 87761",
    d: "M110.825,40.8a9.6,9.6,0,0,1,1.255-1.492c.258-.094.394-.479.759-.32l0,0a.791.791,0,0,1,.058.456,1.9,1.9,0,0,1-.19.411c-.153.164-.4.156-.558.317a1.787,1.787,0,0,0-.544.795c.35.31.737.116,1.106.088.337-.4-.21-.868.1-1.266a.192.192,0,0,1,.211.031c.213.838.423,1.677.638,2.515.119.465-.06.611-.505.483-.175-1.11-.94-1.214-1.845-1.085-.211.03-.438-.06-.636.079-.421.3-.53.962-1.164,1.025-.219-.413.251-.572.324-.877l.443-.493a1.89,1.89,0,0,0,.552-.663",
    transform: "translate(-33.89 -12.026)",
    fill: "#313033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87762",
    "data-name": "Path 87762",
    d: "M212.345,40.205a.836.836,0,0,1,.014-.244c.2-.537.138-1.327.619-1.564a4.939,4.939,0,0,1,2.28-.1c.338.009.416.245.077.464a2.627,2.627,0,0,0-1.933-.149c-.6.165-.356.743-.5.949.077-.2.008-.642.38-.908a2.665,2.665,0,0,1,2.046.113c-.4.249-.845.069-1.267.111-.217.021-.473-.03-.58.2-.121.264-.334.556-.213.84.114.268.443.086.666.146.356.094,1.026-.259,1.017.265-.01.588-.7.315-1.089.318-.519,0-.975.01-1.147.613a.865.865,0,0,0-.084.992.372.372,0,0,1-.086.2c-.159.092-.382-.037-.515.147l-.162,0c-.233-.385,0-.736.11-1.079a9.318,9.318,0,0,0,.367-1.314",
    transform: "translate(-65.573 -11.797)",
    fill: "#3b3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87763",
    "data-name": "Path 87763",
    d: "M105.54,39.65a2.039,2.039,0,0,1-.946,1.018,1.582,1.582,0,0,0-2,1.588c-.011.1-.134.168-.186.264-.049.22-.191.2-.347.131a.88.88,0,0,1-.019-.731c-.021-.167-.047-.335.106-.462a10.487,10.487,0,0,0,.692-1.961c.248-.234.037-.585.211-.838l-.007,0c.692-.483,1.447-.19,2.179-.174l-.01,0a.877.877,0,0,1,.323,1.168",
    transform: "translate(-31.576 -11.85)",
    fill: "#363537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87764",
    "data-name": "Path 87764",
    d: "M88.773,39.842a15.351,15.351,0,0,1-.423,1.5c-.226.583-.1.793.543.769.3-.011.864-.275.872.257.006.5-.552.311-.875.313-1.754.014-1.754.006-1.227-1.691q.365-1.173.724-2.346c.289-.16.638-.554.7.176l0,.007a4.784,4.784,0,0,0-.314,1.01",
    transform: "translate(-27.049 -11.854)",
    fill: "#313134"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87765",
    "data-name": "Path 87765",
    d: "M189.494,38.646a6.459,6.459,0,0,0-2.4,3.516c-.067.391-.3.621-.7.471-.417-.16-.116-.478-.042-.695a2.6,2.6,0,0,0,.117-2.136.238.238,0,0,1,.151-.088c-.057-.514-.057-.514-.471-1.1a.841.841,0,0,1-.146-.155c.377-.369.63-.154.813.2a3.842,3.842,0,0,1,.329.842c.146.592.381.465.67.113a8.035,8.035,0,0,0,1.311-1.2l-.008.007c.181-.019.405-.11.375.224",
    transform: "translate(-57.595 -11.814)",
    fill: "#373739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87766",
    "data-name": "Path 87766",
    d: "M38.94,42.83l-.164,0c-.2-.293.074-.475.162-.7l2.454-2.847a.879.879,0,0,0,.181,0c.167-.059.207-.245.341-.339a.189.189,0,0,1,.2.035l0-.006a1.342,1.342,0,0,1,.064.572.587.587,0,0,1-.15.409c-.151.161-.407.069-.556.234-.187.265-.377.526-.554.789.4.319.826,0,1.234.055a.75.75,0,0,1,.434.241c.108.509.411,1,.174,1.543-.2.066-.391.115-.521-.119-.146-.27.077-.629-.211-.864a4.33,4.33,0,0,0-2.086-.012l-.306.312a3.441,3.441,0,0,1-.687.686",
    transform: "translate(-11.984 -12.022)",
    fill: "#39393b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87767",
    "data-name": "Path 87767",
    d: "M64.009,41a3.971,3.971,0,0,1,.48-1.322c.463-1.268.463-1.269,1.858-1.239a.714.714,0,0,1,.469.08c.159.129.4.141.5.357.162.46-.16.785-.32,1.156l-.166.146a.332.332,0,0,1-.3.073.317.317,0,0,1-.143-.151.565.565,0,0,1,0-.316,2.364,2.364,0,0,1,.136-.29c.121-.493-.26-.4-.518-.441-.106,0-.213,0-.319.01-.364.012-.394.314-.483.562-.262.688.463.43.654.682a.361.361,0,0,1,.038.333.435.435,0,0,1-.167.149c-.323.111-.725.05-.929.424a2.92,2.92,0,0,0-.338.782,1.812,1.812,0,0,1-.228.5c-.112.1-.3.033-.393.174-.654-.227-.1-.57-.082-.863.257-.214.233-.517.251-.806",
    transform: "translate(-19.669 -11.863)",
    fill: "#2e2e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87768",
    "data-name": "Path 87768",
    d: "M31.42,41.3a.106.106,0,0,1-.13.071.437.437,0,0,1-.3-.254c-.075-.6.3-1.1.4-1.664.159-.743.48-1.219,1.378-1.055.436.079.944.013,1.147.473a1.2,1.2,0,0,1-.353,1.354,1.676,1.676,0,0,1-.327.252c-.652.167-.82.476-.335,1.029a3.108,3.108,0,0,1,.336.616c.095.125.106.266-.021.357-.157.113-.307.035-.434-.09-.173-.168-.184-.463-.445-.561a.9.9,0,0,1-.289-.608c-.031-.2-.12-.38-.348-.356s-.164.306-.287.436",
    transform: "translate(-9.594 -11.844)",
    fill: "#2a292c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87769",
    "data-name": "Path 87769",
    d: "M214.77,1.751c-.311-.044-.294-.454-.619-.545q-1.7,5.581-3.4,11.141a2.648,2.648,0,0,1-.279.5q-.141-.075-.03-.189c.661-2.209,1.317-4.42,1.985-6.627q.694-2.288,1.42-4.567c.075-.238,0-.638.362-.649.274-.008.293.356.418.556a1.977,1.977,0,0,1,.143.381",
    transform: "translate(-65.147 -0.251)",
    fill: "#f57821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87770",
    "data-name": "Path 87770",
    d: "M196.447,38.844c-.838.707-.832.749.175,1.243,1.3.638,1.349,1.2.182,2.119-.186-.081-.29-.2-.2-.415.306-.434.179-.753-.262-.991a2.81,2.81,0,0,0-.288-.153c-.467-.182-.946-.391-.942-.975a1.268,1.268,0,0,1,.953-1.166.832.832,0,0,1,.2-.039.44.44,0,0,1,.235.194.165.165,0,0,1-.049.184",
    transform: "translate(-60.413 -11.875)",
    fill: "#353436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87771",
    "data-name": "Path 87771",
    d: "M128.537,42.833c-.6.072-.391-.277-.249-.525.6-1.054,1.226-2.1,1.843-3.144.166-.05.411-.384.458.064.067.626.32,1.2.4,1.822.16.212.066.657.538.585a.369.369,0,0,1,.087.2c-.056.274-.309.42-.431.651h0c-.576.273-.278-.392-.516-.481l0,.008a7.084,7.084,0,0,0-.21-.911c-.113-.264-.052-.762-.6-.447l-.84,1.506c-.17.216-.233.51-.484.667",
    transform: "translate(-39.676 -12.039)",
    fill: "#2d2c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87772",
    "data-name": "Path 87772",
    d: "M155.616,4.049c.463-1.082,1.128-2.153.166-3.307.735.44.9,1.03.565,2.114q-1.211,3.935-2.436,7.865a4.04,4.04,0,0,1-.737,1.8.268.268,0,0,1-.133-.213c.8-2.491,1.473-5.021,2.284-7.509.082-.253.054-.555.29-.751",
    transform: "translate(-47.388 -0.229)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87773",
    "data-name": "Path 87773",
    d: "M73.483,40.43c.164-.581.322-1.163.492-1.742a.454.454,0,0,1,.629-.358c.391.137.141.4.077.61a22.064,22.064,0,0,1-1.144,3.409c-.12.245-.313.422-.584.292s-.186-.353-.043-.55a5.647,5.647,0,0,0,.574-1.661",
    transform: "translate(-22.535 -11.822)",
    fill: "#38383a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87774",
    "data-name": "Path 87774",
    d: "M178.561,40.161c.453.148.91.332.974.868.07.579-.333.918-.771,1.207-.134.088-.261.187-.391.281a.4.4,0,0,1-.206.035.427.427,0,0,1-.233-.209.183.183,0,0,1,.061-.188l.295-.165c.554-.3.68-.67.17-1.132-.4-.178-.862-.265-1.126-.676a1.362,1.362,0,0,1,.153-1.356c.083-.214.321-.2.468-.313a.331.331,0,0,1,.206-.034.423.423,0,0,1,.232.212.224.224,0,0,1-.047.2l.01-.008c-.278.151-.6.277-.553.68.055.433.463.453.759.6",
    transform: "translate(-54.871 -11.878)",
    fill: "#313133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87775",
    "data-name": "Path 87775",
    d: "M162.548,42.671c-.416.1-.576-.028-.431-.461.3-.9.6-1.807.9-2.711.441-.882-.511-.389-.67-.679.142-.482.6-.206.874-.363a2.21,2.21,0,0,1,.658,0c.315.195.85-.191,1.021.386a.572.572,0,0,1-.474.076c-.493-.08-.638.187-.79.606a13.934,13.934,0,0,1-1.085,3.144",
    transform: "translate(-50.182 -11.865)",
    fill: "#2f2f31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87776",
    "data-name": "Path 87776",
    d: "M141.774,41.791c.017.306.175.424.481.4s.6-.012.9-.008c.182,0,.421-.041.434.236a.337.337,0,0,1-.367.354c-.683.011-1.366.008-2.048,0-.254,0-.342-.159-.271-.383.09-.283.211-.556.319-.833a28.548,28.548,0,0,0,.846-2.822l0,.007a.275.275,0,0,1,.219-.058.478.478,0,0,1,.351.293,7.346,7.346,0,0,0-.209.785l.006-.011c-.211.205-.044.444-.057.666a.59.59,0,0,1-.084.221c-.379.289-.369.754-.517,1.148",
    transform: "translate(-43.623 -11.943)",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87777",
    "data-name": "Path 87777",
    d: "M9.976,42.471c-.12.281-.353.242-.554.154-.25-.109-.127-.329-.074-.5.35-1.13.71-2.258,1.059-3.389.1-.31.282-.487.6-.415s.28.277.11.487a.135.135,0,0,1-.144.066c-.286.106-.038.324-.1.476a1.447,1.447,0,0,0,.029.861.353.353,0,0,1-.131.311c-.614.509-.529,1.3-.8,1.951",
    transform: "translate(-2.871 -11.825)",
    fill: "#333335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87778",
    "data-name": "Path 87778",
    d: "M162.763,2.126q-1.472,4.65-2.94,9.3c-.042.134-.081.261-.224.322.359-1.8,1.047-3.508,1.545-5.27.3-1.054.641-2.095.967-3.14a2.409,2.409,0,0,1,.652-1.211",
    transform: "translate(-49.419 -0.656)",
    fill: "#233281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87779",
    "data-name": "Path 87779",
    d: "M4.545,24.073A2.008,2.008,0,0,1,4,25.378q1.256-4.6,2.827-9.112a8.912,8.912,0,0,1-.675,2.758c-.485,1.7-1.068,3.368-1.611,5.049",
    transform: "translate(-1.24 -5.022)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87780",
    "data-name": "Path 87780",
    d: "M57.415,18.438c-.424.533-.291,1.266-.652,1.822a.392.392,0,0,1-.01-.5c.884-2.771,1.607-5.591,2.633-8.317a10.117,10.117,0,0,1-.679,2.683c-.385,1.449-.857,2.875-1.292,4.311",
    transform: "translate(-17.547 -3.533)",
    fill: "#243081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87781",
    "data-name": "Path 87781",
    d: "M52.99,38.51c.084.2-.143.209-.192.327-.24.168-.512.078-.767.08-.33,0-.573.084-.648.439-.237.924-.594,1.812-.833,2.736-.059.231-.144.547-.466.424-.3-.115-.093-.366-.023-.559.311-.869.474-1.786.841-2.637.061-.42-.231-.371-.5-.406-.2-.028-.574.207-.562-.277.289-.2.644-.083.951-.2a12.647,12.647,0,0,1,2.2.075",
    transform: "translate(-15.432 -11.862)",
    fill: "#1e1e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87782",
    "data-name": "Path 87782",
    d: "M206.579,29.66c.594-.225.3.562.675.577.42.015-.077-.839.532-.6.469.185.052.487,0,.736a1.732,1.732,0,0,1-.669.617,7.009,7.009,0,0,0-.663.514l-.157.153c-.4-.057-.23-.321-.193-.537a3.249,3.249,0,0,1,.478-1.46",
    transform: "translate(-63.796 -9.137)",
    fill: "#f57821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87783",
    "data-name": "Path 87783",
    d: "M204.59,40.78c.067-.292.111-.59.205-.872.188-.567.476-1.163-.586-.984-.171.029-.337-.048-.331-.264a.321.321,0,0,1,.3-.338c.961-.015,1.921-.011,2.882,0a.221.221,0,0,1,.234.266c-.021.191-.17.348-.32.313-1.08-.25-1.245.559-1.506,1.265a.449.449,0,0,1-.179-.335,2.024,2.024,0,0,1,.224-.866.7.7,0,0,1,.264-.249,1.192,1.192,0,0,1,.485-.067,3.032,3.032,0,0,0-.633.027,1.582,1.582,0,0,1-.431-.024c-.1.012-.2-.041-.3.015a.441.441,0,0,1,.5.328,4.422,4.422,0,0,1-.572,1.809.2.2,0,0,1-.242-.021",
    transform: "translate(-63.129 -11.828)",
    fill: "#454548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87784",
    "data-name": "Path 87784",
    d: "M11.43,40.144c-.387-.281.042-.593-.032-.886.042-.16-.165-.4.142-.477l.2.021c-.228,1.2-.224,1.139.991,1.215.822.052,1.312-.149,1.414-1.017a1.349,1.349,0,0,1,.206-.53.421.421,0,0,1,.515-.147c.261.078.219.265.15.462-.2.565-.391,1.133-.586,1.7-.22-.129-.2-.341-.2-.55,0-.324.266-.585.244-.816.023.173-.188.376-.229.63a.639.639,0,0,1-.634.59c-.73-.046-1.486.2-2.184-.194",
    transform: "translate(-3.489 -11.822)",
    fill: "#383839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87785",
    "data-name": "Path 87785",
    d: "M124.572,38.672a7.548,7.548,0,0,0-2.634,3.846.477.477,0,0,1-.185-.318,4.214,4.214,0,0,1,.822-2.243,7.939,7.939,0,0,1,1.456-1.464c.205-.015.478-.236.541.179",
    transform: "translate(-37.699 -11.861)",
    fill: "#424243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87786",
    "data-name": "Path 87786",
    d: "M162.532,42.619a26.876,26.876,0,0,0,.839-2.725c.18-.886.6-1.271,1.488-1.148-.224-.462-.677-.037-.965-.25l-.746.006c-.31.083-.632.021-.944.075a.337.337,0,0,1-.191-.133,11.617,11.617,0,0,1,3.061-.146.219.219,0,0,1,.246.255c-.019.227-.191.389-.382.344-1.15-.271-1.2.6-1.417,1.317q-.3.982-.613,1.958c-.062.195-.058.46-.376.447",
    transform: "translate(-50.166 -11.813)",
    fill: "#464649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87787",
    "data-name": "Path 87787",
    d: "M50.968,39.716q-.473,1.506-.947,3.011l.22.078,1.044-3.1a.288.288,0,0,1,.039.384,22.545,22.545,0,0,1-.735,2.611.448.448,0,0,1-.621.359c-.329-.1-.18-.357-.119-.545.3-.937.626-1.869.941-2.8.06-.072.119-.075.177,0",
    transform: "translate(-15.409 -12.243)",
    fill: "#313133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87788",
    "data-name": "Path 87788",
    d: "M198.763,28.155a8.081,8.081,0,0,0,.473-1.9,8.7,8.7,0,0,1,.65-2.086,10.452,10.452,0,0,1,.792-2.394.212.212,0,0,1,.241.023c-.479,2.019-1.169,3.974-1.789,5.95a.61.61,0,0,1-.367.412",
    transform: "translate(-61.545 -6.712)",
    fill: "#293884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87789",
    "data-name": "Path 87789",
    d: "M204.653,41.44l.2.014a.345.345,0,0,1,.07.351c.085-.073.034-.181.07-.271.15-.369.013-.868.5-1.085.014.125.028.25.041.374-.2.7-.411,1.407-.6,2.115a.462.462,0,0,1-.6.386c-.408-.091-.2-.377-.133-.583.137-.438.3-.868.46-1.3",
    transform: "translate(-63.192 -12.487)",
    fill: "#313133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87790",
    "data-name": "Path 87790",
    d: "M3.838,39.947l-.2.177a.262.262,0,0,1-.31.079.425.425,0,0,1-.21-.266A.656.656,0,0,1,3.3,39.52c.1-.156.273-.34.015-.47a.882.882,0,0,0-.924-.066c-.2.125-.242.351-.344.539-.087.177-.17.357-.272.526-.164.179-.323.484-.526.032a1.206,1.206,0,0,1,.108-.51c.433-1.34.932-1.516,2.666-.937l0,0a1.115,1.115,0,0,1-.182,1.317",
    transform: "translate(-0.387 -11.83)",
    fill: "#1a181d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87791",
    "data-name": "Path 87791",
    d: "M122.274,39.959c.207.3-.015.509-.173.722a3.309,3.309,0,0,0-.5,1.456c-.1.162-.062.5-.389.385-.21-.077-.068-.281-.019-.422a8.855,8.855,0,0,1,.317-1.081,1.285,1.285,0,0,0-.242-1.005l0,.008c-.142-.378-.222-.777-.383-1.149-.058-.134-.232-.291,0-.4a.336.336,0,0,1,.482.158,9.184,9.184,0,0,1,.4,1.058c.061.169.051.405.345.321a.594.594,0,0,1,.153-.052",
    transform: "translate(-37.397 -11.864)",
    fill: "#1b1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87792",
    "data-name": "Path 87792",
    d: "M133,41.943c0-.062,0-.124,0-.187a.122.122,0,0,1-.029-.213l.115-.144a2.321,2.321,0,0,0,.725-.843c.347-.355.509-.861.943-1.143.278-.18.5-.243.476.221a7.381,7.381,0,0,1-.053,1.43.238.238,0,0,1-.336-.019c-.207-.737-.521-.405-.833-.08l-.335.462c-.21.189-.286.552-.67.517",
    transform: "translate(-41.158 -12.125)",
    fill: "#252426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87793",
    "data-name": "Path 87793",
    d: "M15.265,40.39c.012.23.025.461.038.691l0-.015a5.58,5.58,0,0,0-.362,1.172c-.157.374.067,1-.667.991-.333-.205-.133-.474-.075-.715a4.05,4.05,0,0,0,.336-1.311c.084-.142.013-.3.041-.447.356,0,.311-.39.523-.53a.54.54,0,0,1,.164.162",
    transform: "translate(-4.363 -12.419)",
    fill: "#373739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87794",
    "data-name": "Path 87794",
    d: "M3.158,40.7l.14.136c.1.52.766.971.2,1.574a.086.086,0,0,1-.034.111c-.5.862-1.334.741-2.13.74a.27.27,0,0,1-.222-.088.245.245,0,0,1,.063-.218c.3-.205.678-.08.993-.225a1.622,1.622,0,0,0,.663-.48.38.38,0,0,0-.041-.524.985.985,0,0,1-.227-.214.513.513,0,0,1-.021-.424.758.758,0,0,1,.315-.293.55.55,0,0,1,.3-.095",
    transform: "translate(-0.342 -12.566)",
    fill: "#222224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87795",
    "data-name": "Path 87795",
    d: "M13.428,41.332c.2.462-.133.834-.22,1.246-.066.311-.279.6-.107.937-.576-.071-.244-.429-.181-.653.385-1.379.389-1.32-.978-1.4-.8-.047-1.166.221-1.3.974a5.1,5.1,0,0,1-.347.914c.15-.735-.01-1.6.845-2.042a3.942,3.942,0,0,1,2.291.025",
    transform: "translate(-3.187 -12.704)",
    fill: "#383839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87796",
    "data-name": "Path 87796",
    d: "M213.161,28.511a2.677,2.677,0,0,0-.468,1.837c-.067.163-.193.308-.361.256-.24-.075-.082-.263-.041-.4q.526-1.752,1.059-3.5a2.249,2.249,0,0,1,.278-.834,1.494,1.494,0,0,1,.678-.545,7.539,7.539,0,0,0-1.144,3.188",
    transform: "translate(-65.707 -7.818)",
    fill: "#109049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87797",
    "data-name": "Path 87797",
    d: "M46.977,29.172c0-.121-.009-.242-.013-.363h0a3.4,3.4,0,0,0,.514-1.36,28.455,28.455,0,0,1,1.123-3.3.227.227,0,0,1,.217.043,35.613,35.613,0,0,1-1.346,4.362.959.959,0,0,1-.494.623",
    transform: "translate(-14.542 -7.45)",
    fill: "#2c3a86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87798",
    "data-name": "Path 87798",
    d: "M52.476,11.939q.739-2.415,1.477-4.833a1.044,1.044,0,0,1,.352-.626c-.406,1.761-1,3.465-1.564,5.174a.366.366,0,0,1-.265.284",
    transform: "translate(-16.249 -2.001)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87799",
    "data-name": "Path 87799",
    d: "M155.7,41.834c-.2-.118-.16-.314-.166-.495a.848.848,0,0,1-.027-.709l.153-.272c.178-.511.326-1.03.472-1.551.064-.226.218-.412.471-.324s.128.3.075.479a11.315,11.315,0,0,1-.555,1.693,3.053,3.053,0,0,1-.4,1.071.071.071,0,0,1-.025.106",
    transform: "translate(-48.131 -11.874)",
    fill: "#242425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87800",
    "data-name": "Path 87800",
    d: "M201.791,19.594l-.195-.01a3.856,3.856,0,0,1,.376-1.721c.329-1.054.86-2.08.452-3.237l.166-.006a1.178,1.178,0,0,1,.331,1.358,26.411,26.411,0,0,1-1.129,3.615",
    transform: "translate(-62.418 -4.514)",
    fill: "#1e2d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87801",
    "data-name": "Path 87801",
    d: "M135.8,40.917c.291-.5.119-1.041.139-1.562.01-.25-.241-.1-.376-.124.13-.228.226-.491.5-.539,0,1.255.006,2.5,0,3.741,0,.263-.144.408-.432.308a2.517,2.517,0,0,1,.171-1.824",
    transform: "translate(-41.971 -11.945)",
    fill: "#3b3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87802",
    "data-name": "Path 87802",
    d: "M227.511,40.409l.008-.56c-.136-.175-.086-.438-.279-.586a.452.452,0,0,1-.063-.091.959.959,0,0,1,.621-.6c-.072,1.387-.138,2.708-.216,4.029,0,.036-.13.064-.2.1a2.2,2.2,0,0,1,.129-2.291",
    transform: "translate(-70.327 -11.909)",
    fill: "#3d3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87803",
    "data-name": "Path 87803",
    d: "M156.124,40.626l.63-2.043c-.726.388-.467,1.26-1,1.723a4.752,4.752,0,0,1,.425-1.732c.076-.283.365-.319.616-.246.323.093.191.333.121.532-.2.59-.413,1.178-.619,1.767-.058.075-.116.078-.173,0",
    transform: "translate(-48.225 -11.823)",
    fill: "#333335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87804",
    "data-name": "Path 87804",
    d: "M142.653,40.9c.021-.232-.094-.5.18-.666-.012.751.564.353.886.457.3.1.849-.271.861.272.011.518-.555.366-.851.31a1.241,1.241,0,0,0-1.553,1c.06-.447-.062-.966.485-1.219.546-.186,1.127.028,1.876-.18-.094.017-.264-.058-.206.035.017.028,0,.048-.066.048a6,6,0,0,1-1.613-.053",
    transform: "translate(-44.023 -12.421)",
    fill: "#39393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87805",
    "data-name": "Path 87805",
    d: "M101.215,17.542c.37.962-.116,1.819-.334,2.709-.019.078-.038.277-.159.052a.638.638,0,0,1-.019-.244c.1-.355.142-.721.253-1.081a1.214,1.214,0,0,0-.7-1.684l.651-.062a.362.362,0,0,1,.309.31",
    transform: "translate(-31.043 -5.32)",
    fill: "#172477"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87806",
    "data-name": "Path 87806",
    d: "M9.581,9.321a16.99,16.99,0,0,1-1.5,4.815,37.147,37.147,0,0,1,1.5-4.815",
    transform: "translate(-2.503 -2.878)",
    fill: "#243282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87807",
    "data-name": "Path 87807",
    d: "M33.412,40.457a.734.734,0,0,1,.083-.141c.382-.411.823-.889.476-1.44-.4-.63-1.147-.422-1.749-.365-.511.049-.312.7-.605.973a.152.152,0,0,1-.044-.238c.066-.493.084-1.034.819-.933.678.093,1.622-.329,1.863.688a1.162,1.162,0,0,1-.841,1.456",
    transform: "translate(-9.764 -11.824)",
    fill: "#353538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87808",
    "data-name": "Path 87808",
    d: "M12.225.664a15.984,15.984,0,0,1-1.483,4.847c.437-1.634.906-3.257,1.483-4.847",
    transform: "translate(-3.326 -0.205)",
    fill: "#243282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87809",
    "data-name": "Path 87809",
    d: "M111.964,30.4l1.137-4.052.146-.006a.143.143,0,0,1,.039.227c-.23,1.253-.737,2.425-1.074,3.647-.021.078-.163.124-.249.185",
    transform: "translate(-34.669 -8.132)",
    fill: "#253583"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87810",
    "data-name": "Path 87810",
    d: "M66.778,41.369v-.236a.468.468,0,0,1,.65-.2l-.006-.006c.2.5.721.953.2,1.545a.09.09,0,0,1-.031.11c-.211.274-.39.591-.8.6a.285.285,0,0,1-.244-.216.455.455,0,0,1,.157-.29c.158-.13.334-.248.346-.483a1.822,1.822,0,0,0,0-.3c.008-.227-.236-.321-.273-.523",
    transform: "translate(-20.607 -12.618)",
    fill: "#202021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87811",
    "data-name": "Path 87811",
    d: "M122.057,39.962c-.346.5-.394.036-.46-.162-.156-.463-.13-1.007-.714-1.414.047.624.42,1.067.327,1.586a3.759,3.759,0,0,1-.5-1.1c-.086-.181-.291-.413.023-.545a.5.5,0,0,1,.7.232c.218.464.419.935.627,1.4",
    transform: "translate(-37.332 -11.815)",
    fill: "#434345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87812",
    "data-name": "Path 87812",
    d: "M134.494,41.362c.1-.355.405-.531.712-.79.178.255.077.523.111.762a2.711,2.711,0,0,1-.171,1.947c-.4-.509-.147-1.083-.091-1.6.077-.72-.247-.444-.562-.315",
    transform: "translate(-41.645 -12.525)",
    fill: "#3b3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87813",
    "data-name": "Path 87813",
    d: "M226.3,41.367a.589.589,0,0,1,.478-.561c.171-.031.171.163.209.284a7.755,7.755,0,0,1-.025,2.3c-.348.054-.337-.19-.328-.411.019-.464.026-.93.084-1.389.065-.507-.2-.294-.418-.223",
    transform: "translate(-70.071 -12.597)",
    fill: "#3d3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87814",
    "data-name": "Path 87814",
    d: "M104.673,32.7c.146.219.373.2.59.2,1.2,0,2.41-.013,3.615.009a.961.961,0,0,0,.785-.339c.125.427-.1.537-.472.537-1.4,0-2.8,0-4.206,0-.237,0-.581.025-.312-.4",
    transform: "translate(-32.381 -10.054)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87815",
    "data-name": "Path 87815",
    d: "M212.147,43.966c.115-.214.324-.178.514-.191.482-.191,1.007.031,1.49-.142.106-.035-.067-.1-.005-.012.022.032,0,.055-.058.056a4.82,4.82,0,0,1-1.437-.051.676.676,0,0,1,.18-1c-.242.689.074.825.7.787.305-.019.871-.251.9.215.041.585-.552.354-.892.37-.464.021-.931-.019-1.4-.032",
    transform: "translate(-65.69 -13.16)",
    fill: "#3c3c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87816",
    "data-name": "Path 87816",
    d: "M50.9,39.283l-.177,0c-.048-.536-.456-.341-.751-.365-.2-.016-.409-.009-.419-.275a.3.3,0,0,1,.3-.328,9.438,9.438,0,0,1,3.044.146l-2.349.037c-.246.123-.541-.054-.779.124.191.245.459.127.692.133.369.011.483.2.437.53",
    transform: "translate(-15.345 -11.811)",
    fill: "#474649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87817",
    "data-name": "Path 87817",
    d: "M178.561,38.478l-.273-.064a1.863,1.863,0,0,1,1.592-.142c.244.089.6.2.433.554a.415.415,0,0,1-.693.13c-.287-.254-.616-.178-.941-.166l-.019-.195a2.283,2.283,0,0,1,1.04-.057c-.293-.126-.738.044-1.138-.06",
    transform: "translate(-55.206 -11.779)",
    fill: "#333334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87818",
    "data-name": "Path 87818",
    d: "M196.264,43.215l.2.415a.116.116,0,0,1-.055.118c-.437.333-.982.182-1.461.324l-.158-.019a1.455,1.455,0,0,0-.557-.267c-.226-.115-.265-.241-.15-.5.139-.315.336-.174.53-.169.28.424.6.752,1.163.462l.484-.362",
    transform: "translate(-60.078 -13.3)",
    fill: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87819",
    "data-name": "Path 87819",
    d: "M210.011,17.944c.01.063.019.126.03.189A10.206,10.206,0,0,1,209,21.264a20.325,20.325,0,0,1,1.011-3.32",
    transform: "translate(-64.715 -5.54)",
    fill: "#f47821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87820",
    "data-name": "Path 87820",
    d: "M31.116,39.668l.043.238c-.037.563-.418,1.052-.356,1.637a2.343,2.343,0,0,1-.5,1.5c-.353.012-.236-.232-.184-.386a28.408,28.408,0,0,1,.993-2.987",
    transform: "translate(-9.308 -12.246)",
    fill: "#363638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87821",
    "data-name": "Path 87821",
    d: "M103.3,13.225a14.739,14.739,0,0,1,1.185-3.142,7.728,7.728,0,0,1-1.185,3.142",
    transform: "translate(-31.987 -3.113)",
    fill: "#273583"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87822",
    "data-name": "Path 87822",
    d: "M177.521,43.59c0,.061,0,.121,0,.182-.209.277-.6.055-.824.307-.414.1-.639-.195-.869-.438-.269-.285-.154-.46.207-.514a.294.294,0,0,0,.348.109,2.257,2.257,0,0,0,1.138.355",
    transform: "translate(-54.398 -13.314)",
    fill: "#353537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87823",
    "data-name": "Path 87823",
    d: "M143.112,39.705a1.343,1.343,0,0,1,.148-.855,1.631,1.631,0,0,1,1.918-.1l.077.118a1.166,1.166,0,0,1-.942.084.96.96,0,0,0-1.2.756",
    transform: "translate(-44.308 -11.881)",
    fill: "#39393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87824",
    "data-name": "Path 87824",
    d: "M4.047,38.593c-.162-.017-.327-.021-.485-.055-1.414-.3-1.626-.194-2.128,1.085-.12-.039-.14-.109-.06-.206.247-1.217,1.492-1.6,2.672-.825",
    transform: "translate(-0.411 -11.79)",
    fill: "#353537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87825",
    "data-name": "Path 87825",
    d: "M150.479,42.541q.269-1.076.538-2.153c.08-.111.129-.272.322-.2.215.03.342.137.322.371-.327-.2-.395.008-.479.272-.2.637-.432,1.266-.651,1.9a.123.123,0,0,1-.077-.113c0-.049.011-.074.025-.074",
    transform: "translate(-46.587 -12.401)",
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87826",
    "data-name": "Path 87826",
    d: "M102.607,43.532q.075-.231.15-.462c.478-1.444.478-1.444,2.032-1.39a1.7,1.7,0,0,0-1.93,1.684c-.006.064-.164.113-.252.169",
    transform: "translate(-31.771 -12.862)",
    fill: "#3d3d3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87827",
    "data-name": "Path 87827",
    d: "M49.559,23l-.2-.01a13.038,13.038,0,0,1,.578-2.388.448.448,0,0,1,.211-.3.236.236,0,0,1,.234.047A16.532,16.532,0,0,1,49.559,23",
    transform: "translate(-15.284 -6.264)",
    fill: "#243281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87828",
    "data-name": "Path 87828",
    d: "M67.25,38.436c-.991-.044-2.041-.207-2.328,1.16.185-1.421.768-1.712,2.328-1.16",
    transform: "translate(-20.103 -11.785)",
    fill: "#363538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87829",
    "data-name": "Path 87829",
    d: "M150.331,40.9a10.167,10.167,0,0,0-.652,2.509c-.386.052-.33-.188-.255-.409.234-.7.48-1.4.722-2.1a.111.111,0,0,1,.186,0",
    transform: "translate(-46.251 -12.612)",
    fill: "#303032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87830",
    "data-name": "Path 87830",
    d: "M55.376,3.8a4.165,4.165,0,0,0,.316-2.584A2.025,2.025,0,0,1,55.376,3.8",
    transform: "translate(-17.147 -0.375)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87831",
    "data-name": "Path 87831",
    d: "M65.968,43.846c.38,0,.53-.376.83-.507-.074.617-.568.742-1.04.83a5.66,5.66,0,0,1-1.775.014A.332.332,0,0,1,64.312,44a.77.77,0,0,1,.332-.178,4.086,4.086,0,0,1,.867-.015c.153,0,.295.13.457.041",
    transform: "translate(-19.812 -13.38)",
    fill: "#3b3b3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87832",
    "data-name": "Path 87832",
    d: "M111.218,42.992a3.021,3.021,0,0,1,1.98-.1c.5.088.319.734.5,1.105-.4-1.376-1.535-.963-2.481-1.007",
    transform: "translate(-34.438 -13.206)",
    fill: "#3a3a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87833",
    "data-name": "Path 87833",
    d: "M142.224,38.765a6.966,6.966,0,0,1-.846,2.822,12.062,12.062,0,0,1,.846-2.822",
    transform: "translate(-43.777 -11.968)",
    fill: "#39393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87834",
    "data-name": "Path 87834",
    d: "M131.864,41.1c-.149-.574-.335-1.141-.431-1.723-.05-.307-.153-.361-.409-.294.1-.124.175-.326.295-.355.217-.051.215.188.245.332.129.61.246,1.222.367,1.833.075.1.052.17-.068.207",
    transform: "translate(-40.571 -11.952)",
    fill: "#373739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87835",
    "data-name": "Path 87835",
    d: "M25.21,43.432c.115-.816-.353-1.541-.362-2.337a.138.138,0,0,1,.048-.2c.19.7.385,1.4.567,2.1.054.209.116.456-.253.433",
    transform: "translate(-7.686 -12.625)",
    fill: "#424243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87836",
    "data-name": "Path 87836",
    d: "M223.522,40.9c-.443-.429-.33-1.041-.489-1.562-.087-.283-.18-.337-.425-.274.067-.176.122-.393.351-.377.07,0,.159.2.184.321.135.629.254,1.262.378,1.893",
    transform: "translate(-68.929 -11.944)",
    fill: "#414142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87837",
    "data-name": "Path 87837",
    d: "M1.159,43.994a2.735,2.735,0,0,0,2.3-.655c-.473,1.107-1.429.868-2.313.83-.041-.041-.054-.081-.037-.119s.032-.056.047-.056",
    transform: "translate(-0.342 -13.38)",
    fill: "#323234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87838",
    "data-name": "Path 87838",
    d: "M44.3,43.495a2.642,2.642,0,0,0-.339-1.509c-.171-.261-.342-.522-.175-.852a.156.156,0,0,1,.2.019c.175.651.356,1.3.523,1.954.044.175.117.4-.211.388",
    transform: "translate(-13.538 -12.69)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87839",
    "data-name": "Path 87839",
    d: "M142.785,38.642l-.187-.012a.285.285,0,0,1,.307-.306c.681-.012,1.364-.035,2.045-.007.382.017.5.2.153.492l-.072-.07a4.206,4.206,0,0,0-2.245-.1",
    transform: "translate(-44.154 -11.825)",
    fill: "#39393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87840",
    "data-name": "Path 87840",
    d: "M222.221,41.224c.011-.2.079-.4.3-.409s.181.214.22.36c.109.41.225.818.338,1.227a.126.126,0,0,1-.044.191,2.658,2.658,0,0,1-.351-.957c-.074-.232-.135-.467-.46-.413",
    transform: "translate(-68.809 -12.6)",
    fill: "#414142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87841",
    "data-name": "Path 87841",
    d: "M212.278,41.1c.124.854-.552,1.549-.477,2.393-.246.023-.286-.128-.222-.3a13.535,13.535,0,0,1,.7-2.088",
    transform: "translate(-65.506 -12.687)",
    fill: "#3c3c3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87842",
    "data-name": "Path 87842",
    d: "M121.691,42.114l-.415,1.392c.274.073.262-.189.4-.25.01.127.021.255.032.383a.384.384,0,0,1-.613.108c-.193-.138-.043-.347.012-.514.127-.377.273-.749.412-1.123.059-.075.118-.078.175,0",
    transform: "translate(-37.466 -12.983)",
    fill: "#37373a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87843",
    "data-name": "Path 87843",
    d: "M20.821,43.472a.741.741,0,0,1,.91-.631c.518.075,1.092-.236,1.557.214-.844.007-1.749-.339-2.467.418",
    transform: "translate(-6.447 -13.215)",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87844",
    "data-name": "Path 87844",
    d: "M150.729,19.062l-.193-.035a9.247,9.247,0,0,1,1.8-1.314l.061.049a2.56,2.56,0,0,1-1.67,1.3",
    transform: "translate(-46.612 -5.468)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87845",
    "data-name": "Path 87845",
    d: "M30.417,43.878a3.471,3.471,0,0,1,.5-1.5l.2.23c-.006.144-.01.288-.015.432-.189.27-.206.645-.516.841l-.167,0",
    transform: "translate(-9.418 -13.084)",
    fill: "#222223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87846",
    "data-name": "Path 87846",
    d: "M178.769,40.342c-.36-.09-.87.023-.886-.566a.631.631,0,0,1,.681-.715c-.8.566-.312.926.206,1.281",
    transform: "translate(-55.08 -12.059)",
    fill: "#333334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87847",
    "data-name": "Path 87847",
    d: "M227.255,43.517l.025-2.3.273.006a11.785,11.785,0,0,0-.129,2.292h-.168",
    transform: "translate(-70.368 -12.725)",
    fill: "#19191b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87848",
    "data-name": "Path 87848",
    d: "M.817,43.674l-.01.175c-.913.095-.926.082-.647-.75.086-.254.193-.5.291-.753a.153.153,0,0,1,.222.008.754.754,0,0,1-.082.76c-.523.467.081.405.222.558l0,0",
    transform: "translate(0 -13.06)",
    fill: "#3c3c3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87849",
    "data-name": "Path 87849",
    d: "M102.991,39.889a4.2,4.2,0,0,1-.761,1.974q.361-1.084.724-2.167a.12.12,0,0,1,.071.12c-.008.049-.019.073-.035.073",
    transform: "translate(-31.655 -12.255)",
    fill: "#3d3d3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87850",
    "data-name": "Path 87850",
    d: "M50.748,19.622l-.2-.01a10.984,10.984,0,0,1,.035-1.5.333.333,0,0,1,.166-.185,1.512,1.512,0,0,1,0,1.694",
    transform: "translate(-15.648 -5.535)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87851",
    "data-name": "Path 87851",
    d: "M4.429,42.477c.068-.378.32-.776-.195-1.066-.23-.129-.046-.336,0-.508l.3.019a.566.566,0,0,0,.1.572c.226.346.332.756-.207.983",
    transform: "translate(-1.276 -12.628)",
    fill: "#4b4b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87852",
    "data-name": "Path 87852",
    d: "M105.708,38.45c-.723.1-1.474-.149-2.179.174.117-.535.546-.319.848-.32a2.227,2.227,0,0,1,1.33.146",
    transform: "translate(-32.057 -11.812)",
    fill: "#414144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87853",
    "data-name": "Path 87853",
    d: "M40.485,43.023A2.86,2.86,0,0,1,42.653,43a.123.123,0,0,1-.024.2c-.686-.4-1.429-.114-2.144-.174",
    transform: "translate(-12.536 -13.213)",
    fill: "#434344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87854",
    "data-name": "Path 87854",
    d: "M32.954,43.373c.3.011.345.288.5.453.237.25.358.127.4-.16.251.079.409.3.236.475a.507.507,0,0,1-.739-.054,3.826,3.826,0,0,1-.4-.715",
    transform: "translate(-10.204 -13.39)",
    fill: "#343336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87855",
    "data-name": "Path 87855",
    d: "M52.006,39.868l-.039-.383c.24-.944.982-.362,1.49-.49a.28.28,0,0,1-.349.12c-.643-.144-.924.225-1.1.753",
    transform: "translate(-16.091 -12.019)",
    fill: "#474649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87856",
    "data-name": "Path 87856",
    d: "M196.766,38.462l-.279-.057a1.6,1.6,0,0,1,1.739-.011c-.03.037-.06.073-.089.11a1.959,1.959,0,0,1-1.371-.041",
    transform: "translate(-60.841 -11.774)",
    fill: "#363637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87857",
    "data-name": "Path 87857",
    d: "M189.94,38.48a2.244,2.244,0,0,1-1.312,1.2,8.31,8.31,0,0,1,1.312-1.2",
    transform: "translate(-58.407 -11.88)",
    fill: "#3d3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87858",
    "data-name": "Path 87858",
    d: "M5,40.085a3.628,3.628,0,0,0,.182-1.317c.5.516.316.938-.182,1.317",
    transform: "translate(-1.548 -11.968)",
    fill: "#353537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87859",
    "data-name": "Path 87859",
    d: "M68.013,42.49c.376-.573-.255-1.014-.2-1.545l.344,0c-.16.213-.056.355.072.559.224.357.329.759-.215.981",
    transform: "translate(-20.996 -12.641)",
    fill: "#4d4c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87860",
    "data-name": "Path 87860",
    d: "M135.44,43.621a6.455,6.455,0,0,0,.171-1.946l.159.163c-.061.608.137,1.239-.17,1.824l-.16-.041",
    transform: "translate(-41.938 -12.866)",
    fill: "#1b1b1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87861",
    "data-name": "Path 87861",
    d: "M162.291,38.82c.915.089.915.089.645.706.1-.5-.167-.57-.586-.542-.274.018-.777.129-.4-.461l.077.074c.084.079.179.145.263.223",
    transform: "translate(-50.105 -11.893)",
    fill: "#464649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87862",
    "data-name": "Path 87862",
    d: "M132.887,42.9l.67-.517c-.179.521-.64.795-1.008,1.151-.024-.284.244-.413.338-.634",
    transform: "translate(-41.042 -13.085)",
    fill: "#4e4e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87863",
    "data-name": "Path 87863",
    d: "M73.542,41.384a2.14,2.14,0,0,1-.574,1.661,8.085,8.085,0,0,1,.574-1.661",
    transform: "translate(-22.594 -12.776)",
    fill: "#3e3e40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87864",
    "data-name": "Path 87864",
    d: "M186,38.547l.2.019a2.688,2.688,0,0,1,.478,1.308l-.209.014a2.746,2.746,0,0,1-.466-1.34",
    transform: "translate(-57.594 -11.9)",
    fill: "#343437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87865",
    "data-name": "Path 87865",
    d: "M43.918,40.5l-.182.007c-.451-.176-.164-.523-.185-.8l.033-.71a4.157,4.157,0,0,1,.333,1.5",
    transform: "translate(-13.463 -12.04)",
    fill: "#474749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87866",
    "data-name": "Path 87866",
    d: "M.836,41.628l-.184,0a4.82,4.82,0,0,1,.514-1.659l.06.206-.066.467c-.052.348.018.736-.323.989",
    transform: "translate(-0.202 -12.338)",
    fill: "#4c4c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87867",
    "data-name": "Path 87867",
    d: "M177.411,38.982a4.3,4.3,0,0,0-.153,1.356c-.569-.522-.187-.936.153-1.356",
    transform: "translate(-54.797 -12.035)",
    fill: "#333334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87868",
    "data-name": "Path 87868",
    d: "M130.635,41.22c.014-.2.1-.46.3-.4.325.1.273.477.364.745-.055.077-.111.081-.168,0-.1-.209-.184-.44-.5-.346",
    transform: "translate(-40.45 -12.599)",
    fill: "#373739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87869",
    "data-name": "Path 87869",
    d: "M196.045,43.594c-.581.332-1,.267-1.163-.462a1.663,1.663,0,0,0,1.163.462",
    transform: "translate(-60.344 -13.316)",
    fill: "#414142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87870",
    "data-name": "Path 87870",
    d: "M68.553,40.225l.32-1.156c.321.5.039.84-.32,1.156",
    transform: "translate(-21.227 -12.061)",
    fill: "#363538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87871",
    "data-name": "Path 87871",
    d: "M165.626.726l.19.03a2.9,2.9,0,0,1-1.208.623,1.822,1.822,0,0,1,1.018-.653",
    transform: "translate(-50.97 -0.224)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87872",
    "data-name": "Path 87872",
    d: "M195.369,44.37a6.692,6.692,0,0,1,1.461-.324,1.372,1.372,0,0,1-1.461.324",
    transform: "translate(-60.495 -13.598)",
    fill: "#3f3f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87873",
    "data-name": "Path 87873",
    d: "M178.944,41.921c.413.008.367.312.365.578,0,.348-.154.564-.534.554.41-.324.544-.69.17-1.132",
    transform: "translate(-55.356 -12.942)",
    fill: "#39393a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87874",
    "data-name": "Path 87874",
    d: "M155.258,41.6c.009.236.017.472.026.709-.407.209-.645.125-.644-.373.5.42.455-.146.619-.336",
    transform: "translate(-47.883 -12.842)",
    fill: "#464647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87875",
    "data-name": "Path 87875",
    d: "M31.615,42.336c.041-.236-.137-.612.3-.612.3,0,.372.26.338.532-.269-.431-.452-.173-.635.08",
    transform: "translate(-9.788 -12.881)",
    fill: "#363638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87876",
    "data-name": "Path 87876",
    d: "M219.716,7.463c-.53-.149-.588-.572-.592-1.025l.583.8c0,.074.006.148.009.221",
    transform: "translate(-67.85 -1.988)",
    fill: "#f57821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87877",
    "data-name": "Path 87877",
    d: "M24.777,40.364l-.048.2a2.431,2.431,0,0,1-.266-1.383.1.1,0,0,1,.13.059q.091.561.183,1.122",
    transform: "translate(-7.567 -12.095)",
    fill: "#3b3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87878",
    "data-name": "Path 87878",
    d: "M49.683,16.77c-.205.027-.456-.026-.386-.247.094-.3.425-.254.693-.241-.1.164-.406.2-.307.488",
    transform: "translate(-15.261 -5.024)",
    fill: "#7c84b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87879",
    "data-name": "Path 87879",
    d: "M114.02,38.876l-.759.32a4.395,4.395,0,0,1,.391-.493c.238-.225.362-.134.367.173",
    transform: "translate(-35.07 -11.91)",
    fill: "#3e3e40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87880",
    "data-name": "Path 87880",
    d: "M106.994,39.694a1.479,1.479,0,0,0-.323-1.168c.639.243.665.654.323,1.168",
    transform: "translate(-33.03 -11.894)",
    fill: "#414144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87881",
    "data-name": "Path 87881",
    d: "M156.157,41.667h.173c-.079.386.01.848-.478,1.048q.152-.525.306-1.049",
    transform: "translate(-48.258 -12.863)",
    fill: "#464647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87882",
    "data-name": "Path 87882",
    d: "M197.528,31.958a2.375,2.375,0,0,1,.847-.827,1.092,1.092,0,0,1-.847.827",
    transform: "translate(-61.163 -9.611)",
    fill: "#243081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87883",
    "data-name": "Path 87883",
    d: "M133.884,41.125a.907.907,0,0,1-.725.844l.725-.844",
    transform: "translate(-41.232 -12.696)",
    fill: "#2d2c2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87884",
    "data-name": "Path 87884",
    d: "M89.552,38.782c-.1-.574-.45-.194-.7-.176a.463.463,0,0,1,.71-.279c.224.1.157.3-.006.456",
    transform: "translate(-27.511 -11.81)",
    fill: "#525253"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87885",
    "data-name": "Path 87885",
    d: "M10.59,7.664a1.415,1.415,0,0,1-.352,1.162,2.445,2.445,0,0,1,.352-1.162",
    transform: "translate(-3.17 -2.366)",
    fill: "#243282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87886",
    "data-name": "Path 87886",
    d: "M20.5,42.622a.973.973,0,0,1-.737.8l.737-.8",
    transform: "translate(-6.119 -13.158)",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87887",
    "data-name": "Path 87887",
    d: "M198.839,38.507c.248.074.423.23.239.47-.139.18-.372.355-.611.072.015-.033.03-.066.044-.1a3.308,3.308,0,0,0,.257-.353l.071-.089",
    transform: "translate(-61.454 -11.888)",
    fill: "#363637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87888",
    "data-name": "Path 87888",
    d: "M206.008,31.8c.047.185-.026.414.193.537-.037.181-.168.3-.329.27-.254-.057-.1-.247-.057-.377a4.259,4.259,0,0,1,.193-.43",
    transform: "translate(-63.703 -9.818)",
    fill: "#f38a3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87889",
    "data-name": "Path 87889",
    d: "M15.325,42.614a1.362,1.362,0,0,1,.362-1.172,2.726,2.726,0,0,1-.362,1.172",
    transform: "translate(-4.744 -12.794)",
    fill: "#383839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87890",
    "data-name": "Path 87890",
    d: "M224.37,42.359c-.036.169-.162.353-.3.285-.34-.165-.146-.5-.162-.769.173.143.019.6.464.484",
    transform: "translate(-69.318 -12.928)",
    fill: "#414142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87891",
    "data-name": "Path 87891",
    d: "M132.241,42.066c.023-.069.045-.138.068-.207.179.133.006.6.452.48.01.071.019.142.028.214-.606.314-.472-.2-.548-.487",
    transform: "translate(-40.947 -12.923)",
    fill: "#4e4e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87892",
    "data-name": "Path 87892",
    d: "M131.353,41.9h.168a1.558,1.558,0,0,1,.145,1.014,1.654,1.654,0,0,1-.313-1.013",
    transform: "translate(-40.672 -12.936)",
    fill: "#4e4e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87893",
    "data-name": "Path 87893",
    d: "M43.317,38.907l-.188.015c-.134.154-.189.406-.468.382a.477.477,0,0,1-.062-.1c.215-.159.189-.894.719-.3",
    transform: "translate(-13.19 -11.941)",
    fill: "#474749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87894",
    "data-name": "Path 87894",
    d: "M150.679,40.38h-.186a2.847,2.847,0,0,1,.331-1.222c.14.429-.146.808-.145,1.221",
    transform: "translate(-46.599 -12.089)",
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87895",
    "data-name": "Path 87895",
    d: "M177.154,44.363c.123-.509.541-.227.824-.308l.135.127c-.215.273-.567-.014-.8.2l-.162-.015",
    transform: "translate(-54.854 -13.599)",
    fill: "#1b1b1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87896",
    "data-name": "Path 87896",
    d: "M109.781,43.3c.057.353-.371.527-.324.877-.489-.513.236-.577.324-.877",
    transform: "translate(-33.84 -13.369)",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87897",
    "data-name": "Path 87897",
    d: "M113.863,26.2l-.039-.227a.942.942,0,0,1,.377-.814,2.14,2.14,0,0,1-.338,1.042",
    transform: "translate(-35.245 -7.768)",
    fill: "#243382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87898",
    "data-name": "Path 87898",
    d: "M197.048,38.894v-.153c.382-.028.833-.352,1.068.25l-.088.1a2.046,2.046,0,0,0-.98-.192",
    transform: "translate(-61.014 -11.926)",
    fill: "#363637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87899",
    "data-name": "Path 87899",
    d: "M89.4,40.036a1.063,1.063,0,0,1,.314-1.01,1.813,1.813,0,0,1-.314,1.01",
    transform: "translate(-27.678 -12.048)",
    fill: "#525253"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87900",
    "data-name": "Path 87900",
    d: "M121.846,41.7l-.175,0-.176-.977c.373.235.375.6.351.981",
    transform: "translate(-37.62 -12.572)",
    fill: "#434345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87901",
    "data-name": "Path 87901",
    d: "M221.264,42.733a1.03,1.03,0,0,1,.493-.829,1.069,1.069,0,0,1-.493.829",
    transform: "translate(-68.513 -12.937)",
    fill: "#333334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87902",
    "data-name": "Path 87902",
    d: "M39.046,44.26a1.519,1.519,0,0,1,.687-.686c-.115.343-.269.647-.687.686",
    transform: "translate(-12.09 -13.452)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87903",
    "data-name": "Path 87903",
    d: "M223.4,43.3l.044-.191c.246.15,0,.627.438.652-.708.419-.34-.287-.481-.46",
    transform: "translate(-69.173 -13.309)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87904",
    "data-name": "Path 87904",
    d: "M131.8,43.356c.263.064.159.52.517.481-.026.156-.148.272-.271.214-.286-.138-.226-.439-.246-.695",
    transform: "translate(-40.811 -13.385)",
    fill: "#4e4e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87905",
    "data-name": "Path 87905",
    d: "M24.363,43.129c.347.235.333.61.375.964-.405-.213-.242-.646-.375-.964",
    transform: "translate(-7.544 -13.315)",
    fill: "#424243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87906",
    "data-name": "Path 87906",
    d: "M222.217,39.654a.931.931,0,0,1-.46.892,1.694,1.694,0,0,1,.46-.892",
    transform: "translate(-68.665 -12.242)",
    fill: "#414142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87907",
    "data-name": "Path 87907",
    d: "M30.659,44.179c.17-.281.215-.639.516-.841-.068.344.078.819-.516.841",
    transform: "translate(-9.493 -13.379)",
    fill: "#363638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87908",
    "data-name": "Path 87908",
    d: "M64.115,42.143c.215.362.072.612-.251.806l.251-.806",
    transform: "translate(-19.775 -13.01)",
    fill: "#353537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87909",
    "data-name": "Path 87909",
    d: "M38.86,43.561l-.162.7c-.351-.164-.351-.164.162-.7",
    transform: "translate(-11.906 -13.448)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87910",
    "data-name": "Path 87910",
    d: "M225.1,41.63a.7.7,0,0,1-.514.674,1.379,1.379,0,0,1,.514-.674",
    transform: "translate(-69.54 -12.852)",
    fill: "#373738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87911",
    "data-name": "Path 87911",
    d: "M111.2,41.631a.65.65,0,0,1-.552.663l.552-.663",
    transform: "translate(-34.26 -12.852)",
    fill: "#3a3a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87912",
    "data-name": "Path 87912",
    d: "M176.542,43.225c-.044.113-.021.313-.2.283-.213-.037-.132-.245-.147-.391.132-.015.276-.068.348.109",
    transform: "translate(-54.556 -13.305)",
    fill: "#131315"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87913",
    "data-name": "Path 87913",
    d: "M152.516,39.69a.7.7,0,0,1-.547-.607,1.053,1.053,0,0,1,.547.607",
    transform: "translate(-47.056 -12.066)",
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87914",
    "data-name": "Path 87914",
    d: "M206.64,32.127a.761.761,0,0,1,.663-.514.948.948,0,0,1-.663.514",
    transform: "translate(-63.985 -9.76)",
    fill: "#f38a3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87915",
    "data-name": "Path 87915",
    d: "M128.717,44.248c.133-.243.194-.539.484-.667-.063.292-.1.606-.484.667",
    transform: "translate(-39.856 -13.454)",
    fill: "#333334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87916",
    "data-name": "Path 87916",
    d: "M177.389,44.438c.215-.273.536-.114.8-.195l.242.055a1.189,1.189,0,0,1-1.04.14",
    transform: "translate(-54.927 -13.659)",
    fill: "#353537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87917",
    "data-name": "Path 87917",
    d: "M190.892,38.642c-.074-.16-.231-.182-.375-.224.2-.182.429-.244.6,0,.077.111-.051.238-.22.226",
    transform: "translate(-58.992 -11.811)",
    fill: "#3d3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87918",
    "data-name": "Path 87918",
    d: "M125.6,38.62c-.131-.209-.351-.146-.541-.179.2-.174.438-.271.662-.1.13.1.046.237-.121.277",
    transform: "translate(-38.723 -11.809)",
    fill: "#4d4d4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87919",
    "data-name": "Path 87919",
    d: "M101.982,43.5l.019.731c-.467-.232-.092-.485-.019-.731",
    transform: "translate(-31.512 -13.429)",
    fill: "#3d3d3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87920",
    "data-name": "Path 87920",
    d: "M103.315,39.607c-.012-.064-.024-.129-.037-.193a.9.9,0,0,1,.179-.632c-.03.278.1.584-.142.825",
    transform: "translate(-31.979 -11.973)",
    fill: "#373739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87921",
    "data-name": "Path 87921",
    d: "M150.355,43.6l.052.187c-.01.237,0,.491-.353.47l.3-.657",
    transform: "translate(-46.463 -13.46)",
    fill: "#303032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87922",
    "data-name": "Path 87922",
    d: "M24.516,39.034a.223.223,0,0,1-.13-.059.485.485,0,0,0-.2-.435c.338-.092.374-.039.33.494",
    transform: "translate(-7.489 -11.887)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87923",
    "data-name": "Path 87923",
    d: "M114.272,39.558c.015-.185.03-.37.045-.554a1.341,1.341,0,0,1,.182.832l-.2.012a.217.217,0,0,1-.031-.29",
    transform: "translate(-35.371 -12.041)",
    fill: "#3e3e40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87924",
    "data-name": "Path 87924",
    d: "M43.589,43.288c.008-.065.016-.131.023-.2.25.269.137.591.13.9a1.12,1.12,0,0,1-.153-.7",
    transform: "translate(-13.496 -13.303)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87925",
    "data-name": "Path 87925",
    d: "M51.514,15.13a.962.962,0,0,1,.524-.515.577.577,0,0,1-.524.515",
    transform: "translate(-15.951 -4.512)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87926",
    "data-name": "Path 87926",
    d: "M194.334,44.089c.25-.045.5-.088.557.268a.487.487,0,0,1-.557-.268",
    transform: "translate(-60.174 -13.602)",
    fill: "#414142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87927",
    "data-name": "Path 87927",
    d: "M50.111,17.192a.684.684,0,0,1,.495.509l-.055.043a.442.442,0,0,1-.489-.494Z",
    transform: "translate(-15.501 -5.308)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87928",
    "data-name": "Path 87928",
    d: "M86.694,10.608a3.533,3.533,0,0,0,1.6-1.967,1.966,1.966,0,0,0-.44-2.1c-.273-.551-.783-.525-1.282-.525H68.652l-.031-.221a15.59,15.59,0,0,1,2-.262c4.436-.024,8.873-.057,13.308.019,1.089.019,2.189.1,3.285.142,1.015.041,1.458.482,1.679,1.5a3.882,3.882,0,0,1,.194,1.361c-.041.3.14.4.38.423.266.022.534,0,.854,0-.258.484-.678.3-1.027.332-.229.021-.806-.493-.516.333-.637.044-.7.748-1.146,1a7.833,7.833,0,0,1-4.109.848c-5.1-.056-10.195-.018-15.292-.032-.309,0-.753.224-.891-.318a1.623,1.623,0,0,1,.888-.079q8.589-.009,17.175,0a3.208,3.208,0,0,0,1.29-.457",
    transform: "translate(-20.852 -1.7)",
    fill: "#212f80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87929",
    "data-name": "Path 87929",
    d: "M63.957,20.733c.2-.119.165-.315.17-.5-.12-.224.023-.36.166-.5a1.456,1.456,0,0,1,.831-.176.564.564,0,0,1,.654,0h.336a1.333,1.333,0,0,1,.877-.151q6.938-.005,13.878,0a1.737,1.737,0,0,1,.964.153H82.5c.8-.225,1.087-.07,1.06.583-5.889-.331-11.782-.068-17.674-.144-1.067-.014-1.139.066-1.466,1.064-.24.733-.483,1.465-.677,2.211-.187.717-.12.8.636.834.138.006.275,0,.414,0,5.263,0,10.527-.008,15.79.011.59,0,1.2-.25,1.778.086-.2.568-.742.553-1.165.554q-8.952.03-17.905.006c-.05,0-.1-.043-.15-.067a.386.386,0,0,1-.184-.348.506.506,0,0,1,.017-.647h0a18.661,18.661,0,0,1,.989-2.976",
    transform: "translate(-19.459 -5.991)",
    fill: "#263582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87930",
    "data-name": "Path 87930",
    d: "M83.3,19.485H67.582c.067-.408.39-.317.648-.317q7.145-.006,14.29,0c.307,0,.618-.024.78.321",
    transform: "translate(-20.926 -5.915)",
    fill: "#233180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87931",
    "data-name": "Path 87931",
    d: "M92.425,20c-.215-.531-.688-.527-1.146-.552-.023-.14-.14-.451-.017-.389.408.206,1.075-.3,1.279.46.023.087.3.182.429.149.244-.063-.1-.283.055-.407.914.639.914.639.066,2.227.213-.118.357-.205.507-.28.1-.051.224-.066.279.059a.265.265,0,0,1-.016.23,1.364,1.364,0,0,0,.149,2.03.286.286,0,0,1-.069.433c-.186.153-.252.015-.361-.139a7.655,7.655,0,0,0-.645-.722c-.124-.119-.073-.245-.014-.371-.086.065-.081.185-.157.256-.12.116-.237.244-.4.05a.418.418,0,0,1-.008-.316A3.238,3.238,0,0,0,92.425,20",
    transform: "translate(-28.241 -5.883)",
    fill: "#233180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87932",
    "data-name": "Path 87932",
    d: "M83.727,24.568c.409-.032.393-.48.645-.684.172.276-.125.471-.086.71l-.164.166c-.112.109-.134.307-.33.333a.567.567,0,0,0-.331.33,1.33,1.33,0,0,1-1.324.661,1.626,1.626,0,0,1-.88.168q-8.605,0-17.211-.006c-.264,0-.559.094-.775-.16q8.76,0,17.519,0a2.188,2.188,0,0,0,1.675-.513,2.754,2.754,0,0,1,1.262-1.005",
    transform: "translate(-19.591 -7.374)",
    fill: "#19277b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87933",
    "data-name": "Path 87933",
    d: "M85.639,13.219l-18.372,0c-.333-.4-.108-.706.179-1-.165.625.029.8.71.8,5.825-.026,11.65,0,17.474,0,.052.04.071.082.056.125s-.032.065-.048.065",
    transform: "translate(-20.778 -3.774)",
    fill: "#2a3986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87934",
    "data-name": "Path 87934",
    d: "M90.6,26.771l1.324-.661c-.093.29.226.461.231.775-.536.022-1.056.2-1.555-.114",
    transform: "translate(-28.053 -8.061)",
    fill: "#233180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87935",
    "data-name": "Path 87935",
    d: "M64.013,21.326a16.534,16.534,0,0,1-.989,2.976,5.587,5.587,0,0,1,.989-2.976",
    transform: "translate(-19.515 -6.584)",
    fill: "#122279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87936",
    "data-name": "Path 87936",
    d: "M93,25.484a.57.57,0,0,1,.33-.333c0,.351.285.516.485.733a.377.377,0,0,1,.04.519c-.061.094-.127.207-.249.169a.327.327,0,0,1-.24-.451c.167-.4-.248-.425-.366-.637",
    transform: "translate(-28.796 -7.765)",
    fill: "#233180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87937",
    "data-name": "Path 87937",
    d: "M68.691,7.461a13.645,13.645,0,0,1-.873,2.771,6.025,6.025,0,0,1,.873-2.771",
    transform: "translate(-20.999 -2.303)",
    fill: "#2a3986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87938",
    "data-name": "Path 87938",
    d: "M64.647,19.82l-.166.5c-.158-.05-.39.208-.475-.084a.584.584,0,0,1,.063-.457c.182-.234.386-.018.578.045",
    transform: "translate(-19.813 -6.072)",
    fill: "#233180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87939",
    "data-name": "Path 87939",
    d: "M62.871,25.629l-.017.647c-.587-.231-.264-.438.017-.647",
    transform: "translate(-19.361 -7.912)",
    fill: "#122279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87940",
    "data-name": "Path 87940",
    d: "M66.8,19.5h-.654q.326-.575.654,0",
    transform: "translate(-20.482 -5.932)",
    fill: "#233180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87941",
    "data-name": "Path 87941",
    d: "M42.094,6.684c-.081.071-.206.219-.239.2-.974-.528-2.015-.044-3.012-.2-.282-.045-.937.723-.855.96s.259.109.407.086.251.074.375.264a2.121,2.121,0,0,0-.636.228c-.179.144-.472.344.039.555.487.2.015.4-.119.482-.83.5-.958,1.067-.311,1.875a3.121,3.121,0,0,0-2.545.279c-.222.163-.641.046-.969.075-.485.044-1.043-.2-1.4.408-.065.111-.409.082-.625.083q-6.651.006-13.3,0a.941.941,0,0,1-.92-.359c-.228-.308-.73-.18-1.091-.084-.4.106-.581.017-.623-.382.37-.347.834-.229,1.261-.23q8.018-.012,16.035-.007a3.419,3.419,0,0,0,1.3-.129c.086-.023.175-.048.259-.077a1.426,1.426,0,0,0,.752-.343,5.77,5.77,0,0,0,1.277-1.685c.485-.985.344-1.535-.534-2.068a2.571,2.571,0,0,1-.333-.24,2.754,2.754,0,0,0-1.225-.117q-8.1-.007-16.209-.008c-.428,0-.891.113-1.264-.228-.251-.409.124-.334.285-.322,1.239.09,2.46-.173,3.692-.174,4.1,0,8.2-.008,12.295.006.813,0,1.626.1,2.439.138.344.018.585.056.717.488.09.294.484.495.76.754.64-1.1,1.7-.7,2.6-.671.507.016,1.029.1,1.548.112.28,0,.272.14.166.33",
    transform: "translate(-5.039 -1.705)",
    fill: "#223080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87942",
    "data-name": "Path 87942",
    d: "M31.419,24.11a3.739,3.739,0,0,0,1.731-1.886,1.888,1.888,0,0,0-.585-2.345,1.632,1.632,0,0,0-1.23-.3q-8.451,0-16.9,0a1.679,1.679,0,0,1-.888-.077c.06-.409.38-.328.641-.328,5.87,0,11.74-.011,17.61.006a2.222,2.222,0,0,1,2.121,2.182,3.936,3.936,0,0,1-2.984,3.434,9.47,9.47,0,0,1-1.88.171c-5.292-.009-10.583,0-15.874-.011-.28,0-.6.115-.9-.173.309-.246.645-.147.942-.147q8.35-.011,16.7,0a1.852,1.852,0,0,0,1.5-.52",
    transform: "translate(-3.802 -5.916)",
    fill: "#212f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87943",
    "data-name": "Path 87943",
    d: "M13.586,19.641q8.922,0,17.844,0c.427,0,.9-.1,1.175.383a4.465,4.465,0,0,0-1.459-.2c-5.534.009-11.067.019-16.6-.01a.951.951,0,0,0-1.09.816,18.877,18.877,0,0,1-1,3.043l-.046-.221a10.261,10.261,0,0,1,1.016-3.643l.164-.167",
    transform: "translate(-3.841 -6.061)",
    fill: "#2a3884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87944",
    "data-name": "Path 87944",
    d: "M17.746,6.238q9.018,0,18.037,0c.36,0,.806-.153.983.367-.45.253-.919.047-1.377.048q-8.092,0-16.183.008c-.986,0-1.1.12-1.4,1.047a3.494,3.494,0,0,1-.753,1.707.3.3,0,0,1-.295-.037q.495-1.572.991-3.143",
    transform: "translate(-5.188 -1.921)",
    fill: "#253382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87945",
    "data-name": "Path 87945",
    d: "M16.542,10.793l.194.008a.81.81,0,0,1,.129.627c-.064.9-.061.924.844.919,5.626-.033,11.253.093,16.879-.066a.874.874,0,0,1,.629.137,1.651,1.651,0,0,1-1.371.36H16.21c-.345-.386.05-.7.108-1.044.053-.318.148-.629.224-.943",
    transform: "translate(-4.976 -3.332)",
    fill: "#273283"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87946",
    "data-name": "Path 87946",
    d: "M49.278,20.585a9.7,9.7,0,0,1-.66,2.482q-.644,2.108-1.292,4.215a.635.635,0,0,1-.364.418q1.076-3.558,2.151-7.115a.1.1,0,0,1,.164,0",
    transform: "translate(-14.542 -6.342)",
    fill: "#18257a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87947",
    "data-name": "Path 87947",
    d: "M13.131,19.886l-1.016,3.643c-.257.3-.233.718-.4,1.054-.28,0-.266-.217-.211-.341.572-1.281.739-2.689,1.261-3.985.077-.19.128-.364.37-.37",
    transform: "translate(-3.551 -6.139)",
    fill: "#1b2b7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87948",
    "data-name": "Path 87948",
    d: "M49.946,19.569h-.164c.055-.374.119-.746.162-1.121.069-.606-.154-1.007-.825-1.067.073-.191.219-.114.325-.125a2.244,2.244,0,0,1,.326.012l.489.494a3.356,3.356,0,0,1-.146,1.641l-.166.166",
    transform: "translate(-15.209 -5.326)",
    fill: "#1c2c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87949",
    "data-name": "Path 87949",
    d: "M53.592,6.389a.341.341,0,0,0-.166-.33c.107-.5-.269-1.1.331-1.489.006.182-.029.377.166.5.3.225-.044.581.165.827a1.628,1.628,0,0,1-.331.827.342.342,0,0,0-.166-.331",
    transform: "translate(-16.537 -1.411)",
    fill: "#213280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87950",
    "data-name": "Path 87950",
    d: "M51.135,13.9a4.751,4.751,0,0,1-1.158,1.157c.012-.507-.467-.433-.762-.706a2.222,2.222,0,0,0,1.921-.451",
    transform: "translate(-15.239 -4.292)",
    fill: "#213280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87951",
    "data-name": "Path 87951",
    d: "M52.21,11.749c-.019.464.1.963-.331,1.323-.468-.586-.283-1.008.331-1.323",
    transform: "translate(-15.983 -3.627)",
    fill: "#213280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87952",
    "data-name": "Path 87952",
    d: "M53.194.979c.478.069,1.089-.22,1.324.5a.818.818,0,0,0-.779-.05c-.384.146-.569-.046-.545-.447",
    transform: "translate(-16.47 -0.302)",
    fill: "#213280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87953",
    "data-name": "Path 87953",
    d: "M166.839,1.114c.244-.27.568-.16.857-.16q13.219-.009,26.439.013c.241,0,.971-.4.677.478-.014-.053-.028-.151-.042-.151-8.538-.01-17.077-.03-25.616.015-.793,0-1.535-.254-2.315-.2",
    transform: "translate(-51.66 -0.271)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87954",
    "data-name": "Path 87954",
    d: "M192.027,14.438a1.93,1.93,0,0,1,.141,1.86c-.352,1.022-.649,2.064-.969,3.1q-.342,1.233-.682,2.467c-.357-.067-.226-.283-.147-.483A10.767,10.767,0,0,1,191.2,18.4c.193-.243-.052-.66.329-.828.157-.608.337-1.21.467-1.824.191-.9-.059-1.165-.961-1.331a15.647,15.647,0,0,0-2.868-.151q-9.7,0-19.391,0c-.244,0-.488-.017-.732-.03-.015,0-.038-.037-.04-.057a.236.236,0,0,1,.024-.078,1.309,1.309,0,0,1,.727-.077q10.776-.005,21.553,0a1.322,1.322,0,0,1,.727.076,1.237,1.237,0,0,1,.993.337",
    transform: "translate(-52.021 -4.326)",
    fill: "#1b297b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87955",
    "data-name": "Path 87955",
    d: "M191.045,14.061H168.038c.244-.268.568-.158.857-.159q10.646-.008,21.293,0c.289,0,.612-.108.857.158",
    transform: "translate(-52.032 -4.285)",
    fill: "#1e2d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87956",
    "data-name": "Path 87956",
    d: "M200.032,24.672c.01.173-.035.362.147.483a10.1,10.1,0,0,1-.806,2l-.167-.167a5.085,5.085,0,0,1,.826-2.316",
    transform: "translate(-61.683 -7.617)",
    fill: "#1e2d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87957",
    "data-name": "Path 87957",
    d: "M163,6.833a1.632,1.632,0,0,1,.331-.827c.026.077.041.214.081.221.644.13.656.442.291.9-.093.118,0,.334-.228.464-.248-.182-.079-.676-.476-.758",
    transform: "translate(-50.473 -1.854)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87958",
    "data-name": "Path 87958",
    d: "M205.824,4.514c-.023.229.077.488-.165.662-.387.252-.621-.928-1.118.181.132-1.216.717-1.007,1.283-.843",
    transform: "translate(-63.335 -1.355)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87959",
    "data-name": "Path 87959",
    d: "M163.96,3.813a1.154,1.154,0,0,1,.5-1.158l.882.241c-.841-.237-.768.879-1.379.917",
    transform: "translate(-50.769 -0.82)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87960",
    "data-name": "Path 87960",
    d: "M169.163,6.429,169,5.767c.182.006.378-.029.5.166.254.346.735-.011.993.32-.443.044-.91-.084-1.325.176",
    transform: "translate(-52.329 -1.781)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87961",
    "data-name": "Path 87961",
    d: "M165.64,1.55a.908.908,0,0,1,.663-.33l.407.386c-.4.265-.728-.038-1.07-.056",
    transform: "translate(-51.289 -0.377)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87962",
    "data-name": "Path 87962",
    d: "M162.523,8.747q.084-.413.167-.826a.7.7,0,0,1-.016.967c-.1.148-.122-.062-.151-.141",
    transform: "translate(-50.324 -2.445)",
    fill: "#233281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87963",
    "data-name": "Path 87963",
    d: "M165.16,2.029a.571.571,0,0,1,.331-.33c-.059.2.274.424.02.583-.165.1-.27-.112-.351-.253",
    transform: "translate(-51.141 -0.525)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87964",
    "data-name": "Path 87964",
    d: "M163.721,5.139l0-.33c.163.035.445-.08.425.208s-.251.191-.427.122",
    transform: "translate(-50.695 -1.485)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87965",
    "data-name": "Path 87965",
    d: "M201.93,19.167c-.205.238-.067.612-.329.828.07-.292-.2-.718.329-.828",
    transform: "translate(-62.422 -5.917)",
    fill: "#1e2d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87966",
    "data-name": "Path 87966",
    d: "M141.574,13.944a7.574,7.574,0,0,1-1.8,1.315,15.988,15.988,0,0,1-3.528.18q-10.235.007-20.471.006c.227-.462.657-.325,1.022-.325,7.191-.006,14.382-.027,21.573.013a3.427,3.427,0,0,0,3.46-2.74c.407-2.24,1.3-4.353,1.916-6.542q-.079-.41.331-.331h0c-.313,1.875-1.087,3.618-1.575,5.445-.269,1-.614,1.987-.926,2.979",
    transform: "translate(-35.848 -1.7)",
    fill: "#192b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87967",
    "data-name": "Path 87967",
    d: "M138.3,6q-12.4.008-24.793.032c-.338,0-.376-.086-.34-.349a2.869,2.869,0,0,1,.3-.218c.563.611,1.3.358,1.956.36q10.206.024,20.413.006c.673,0,1.348-.053,2.019-.106A.41.41,0,0,1,138.3,6",
    transform: "translate(-35.037 -1.689)",
    fill: "#19297c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87968",
    "data-name": "Path 87968",
    d: "M156.483,5.009a.572.572,0,0,0-.332.332c-.173-.026-.388-.228-.283-.273.556-.241.273-.98.78-1.216q-.083.579-.165,1.157",
    transform: "translate(-48.255 -1.189)",
    fill: "#202f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87969",
    "data-name": "Path 87969",
    d: "M210.235,20.634a5.281,5.281,0,0,1,.5-1.489c.111.716.76.521,1.179.648.881.265,1.786.419,2.445-.5.042-.059.187-.126.2-.109.54.542,1.166.044,1.732.16.162.033.28.109.448,0,.126-.078.223-.421.423-.141.143.2.182.53-.109.64-1.006.382-1.339,1.752-2.6,1.78a1.1,1.1,0,0,0-.489.742c-.028.455-.561.429-.842.655a4.066,4.066,0,0,1-.689-.917c-.1-.265.206-.324.447-.27.2.044.121.384.445.364-.041-.92.735-1.061,1.353-1.357.2-.1.577,0,.474-.395a.452.452,0,0,0-.67-.275c-.7.627-1.424-.017-2.124.124-.362.073-.788-.08-.99.4-.086.2-.2.1-.376.073-.246-.045-.465-.36-.753-.127",
    transform: "translate(-65.098 -5.894)",
    fill: "#f47821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87970",
    "data-name": "Path 87970",
    d: "M195.287,6.394H172.113c.251-.255.571-.151.862-.151q10.725-.008,21.451,0c.291,0,.612-.1.862.151",
    transform: "translate(-53.294 -1.921)",
    fill: "#213080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87971",
    "data-name": "Path 87971",
    d: "M208.483,26.587c.227.291.3.544-.166.662l.166-.662",
    transform: "translate(-64.504 -8.208)",
    fill: "#f57821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87972",
    "data-name": "Path 87972",
    d: "M23.616,42.134a17.743,17.743,0,0,1-.384-1.747,3.777,3.777,0,0,1-.305-1.361c-.064-.167.148-.476-.245-.471l-2.318,2.811a3.214,3.214,0,0,1-.737.795c-.182.126-.419.277-.222.507.166.194.393.086.558-.1.126-.142.264-.273.4-.409.689-.909,1.593-.547,2.458-.419.2.283.163.657.361.94l.331.028c.233-.157.16-.348.106-.575m-1.265-1.04c-.284-.045-.864.377-.824-.389.38-.16.448-.662.848-.8.265.152.1.474.293.637.185.354.1.618-.318.552",
    transform: "translate(-5.986 -11.903)",
    fill: "#303032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87973",
    "data-name": "Path 87973",
    d: "M22.382,41.593c0,.633.484.312.753.358.4.069.382-.254.388-.521.275.34.285.6-.228.654a2.909,2.909,0,0,1-.9-.006c-.5-.111-.316-.31-.017-.485",
    transform: "translate(-6.839 -12.79)",
    fill: "#3b3b3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87974",
    "data-name": "Path 87974",
    d: "M208.762,28.613a.2.2,0,0,1-.128-.259c.022-.063.117-.155.162-.145.132.027.108.157.1.259,0,.084-.023.162-.138.145",
    transform: "translate(-64.598 -8.709)",
    fill: "#f57821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87975",
    "data-name": "Path 87975",
    d: "M227.287,39.563c.3-.041.3-.041.28.586-.287-.1-.322-.326-.28-.586",
    transform: "translate(-70.373 -12.209)",
    fill: "#19191b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87976",
    "data-name": "Path 87976",
    d: "M80.364,44.142a3.057,3.057,0,0,1,1.39,0,3.057,3.057,0,0,1-1.39,0",
    transform: "translate(-24.884 -13.603)",
    fill: "#161617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87977",
    "data-name": "Path 87977",
    d: "M151.592,40.048l-.322.2a.521.521,0,0,1,.234-.524c.082-.035.072.2.088.323",
    transform: "translate(-46.84 -12.263)",
    fill: "#303032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87978",
    "data-name": "Path 87978",
    d: "M112.173,41.464l.677-.951c.819-.189.628.483.757.883a1.015,1.015,0,0,1-1.434.068",
    transform: "translate(-34.734 -12.497)",
    fill: "#a6cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87979",
    "data-name": "Path 87979",
    d: "M114.181,39.806l.031.29c.091.411.206.817.264,1.232.036.259-.146.1-.247.077-.141-.162-.12-.4-.258-.563.032-.247-.135-.514.072-.745.01-.114.008-.234.137-.292",
    transform: "translate(-35.28 -12.289)",
    fill: "#131316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87980",
    "data-name": "Path 87980",
    d: "M113.488,41.364a.741.741,0,0,1,.149.523c-.462.345-.983.169-1.479.144-.182-.009-.146-.18-.03-.293.469.287.925.437,1.311-.129a.15.15,0,0,1,.049-.245",
    transform: "translate(-34.69 -12.77)",
    fill: "#3a3a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87981",
    "data-name": "Path 87981",
    d: "M113.836,41.011c-.017.082-.032.163-.049.245-.293-.211.048-.91-.633-.823.136-.319.419-.176.647-.207l.035.785",
    transform: "translate(-35.037 -12.417)",
    fill: "#3e3e40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87982",
    "data-name": "Path 87982",
    d: "M213.8,38.606c.56-.01,1.12-.016,1.68-.031.229-.006.434.008.464.3l-.009.006a3.885,3.885,0,0,0-2.135,0,.177.177,0,0,1,0-.279",
    transform: "translate(-66.18 -11.908)",
    fill: "#151517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87983",
    "data-name": "Path 87983",
    d: "M213.579,38.62c0,.093,0,.187,0,.279-.154.456-.133.975-.56,1.336.223-.527.08-1.166.561-1.616",
    transform: "translate(-65.959 -11.923)",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87984",
    "data-name": "Path 87984",
    d: "M215.322,41.33h-1.487c0-.026,0-.05,0-.076h1.487c0,.026,0,.05,0,.076",
    transform: "translate(-66.212 -12.736)",
    fill: "#1a1a1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87985",
    "data-name": "Path 87985",
    d: "M212.876,44.07h1.466l.006.15h-1.462a.5.5,0,0,1-.01-.15",
    transform: "translate(-65.915 -13.605)",
    fill: "#151516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87986",
    "data-name": "Path 87986",
    d: "M105.247,40.2l-1.038.335c-.337-.127-.39-.345-.2-.639v.017c.089-.395.121-.832.717-.767.289.031.633-.073.782.279a.6.6,0,0,1-.256.776",
    transform: "translate(-32.172 -12.083)",
    fill: "#a6cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87987",
    "data-name": "Path 87987",
    d: "M105.286,40.151c.185-.333.443-.7-.069-.95-.683-.337-.962.122-1.174.662-.033-.394-.068-.818.484-.841.382-.016.876-.191,1.094.286.145.319.153.712-.334.843",
    transform: "translate(-32.211 -12.033)",
    fill: "#414144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87988",
    "data-name": "Path 87988",
    d: "M103.962,40.235c-.01.238-.069.491.2.638-.538-.063-.478-.316-.2-.638",
    transform: "translate(-32.127 -12.421)",
    fill: "#373739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87989",
    "data-name": "Path 87989",
    d: "M89.84,44.2H88.686v-.076H89.84V44.2",
    transform: "translate(-27.461 -13.621)",
    fill: "#151517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87990",
    "data-name": "Path 87990",
    d: "M186.766,39.883a4.213,4.213,0,0,1-.478-1.308c.537.271.534.868.782,1.312a.162.162,0,0,1-.143.238c-.132,0-.141-.138-.162-.243",
    transform: "translate(-57.683 -11.909)",
    fill: "#202021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87991",
    "data-name": "Path 87991",
    d: "M41.478,41.454l.807-1c.436.03.52.337.521.688,0,.224-.062.52-.3.513-.342-.01-.785.322-1.032-.2",
    transform: "translate(-12.843 -12.489)",
    fill: "#a6cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87992",
    "data-name": "Path 87992",
    d: "M41.423,41.4a.789.789,0,0,0,1.095.048A.753.753,0,0,0,42.23,40.4c.171-.268.33-.044.493.01.1.379.355.737.161,1.157a2.256,2.256,0,0,1-1.317.158c-.217,0-.4-.085-.144-.326",
    transform: "translate(-12.788 -12.431)",
    fill: "#474749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87993",
    "data-name": "Path 87993",
    d: "M43.522,41.489q-.081-.579-.161-1.157c.015-.12.019-.246.153-.306.161.244-.081.581.184.8l.155.825-.332-.163",
    transform: "translate(-13.426 -12.357)",
    fill: "#18181b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87994",
    "data-name": "Path 87994",
    d: "M42.688,39.413l.468-.382c0,.206.011.413-.229.518-.15.066-.242.054-.24-.136",
    transform: "translate(-13.218 -12.05)",
    fill: "#18181b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87995",
    "data-name": "Path 87995",
    d: "M66.263,43.005l-.194.171a1.291,1.291,0,0,1-1.129.064c-.282-.4.041-.719.136-1.069.068-.659.612-.356.949-.47.3.068.672.044.677.507,0,.081,0,.162,0,.243-.043.265-.273.384-.438.553",
    transform: "translate(-20.073 -12.874)",
    fill: "#a6cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87996",
    "data-name": "Path 87996",
    d: "M66.415,39.061h.195c.376.139,1.062.007.7.795l-.121.189c-.283.515-.77.447-1.214.369-.342-.059-.186-.384-.193-.608.146-.3.153-.729.637-.744",
    transform: "translate(-20.358 -12.059)",
    fill: "#a6cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87997",
    "data-name": "Path 87997",
    d: "M65.786,39.978c.071.217-.227.54.1.655a1.223,1.223,0,0,0,1.206-.322c0,.109,0,.216,0,.325l-.65.2c-.483-.083-1.342.2-.827-.852.054-.08.113-.087.175-.01",
    transform: "translate(-20.267 -12.325)",
    fill: "#4d4c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87998",
    "data-name": "Path 87998",
    d: "M64.848,43.72l1.106.033.162.163a.35.35,0,0,1-.365.138,1.344,1.344,0,0,0-.944.012l-.349,0c.008-.178-.021-.368.148-.5.1.015.146.123.241.151",
    transform: "translate(-19.959 -13.451)",
    fill: "#353537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87999",
    "data-name": "Path 87999",
    d: "M67.692,39.855c.093-.549-.289-.683-.7-.795.9,0,1.011.12.7.795",
    transform: "translate(-20.745 -12.059)",
    fill: "#363538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88000",
    "data-name": "Path 88000",
    d: "M64.915,43.353l-.241-.151a1.034,1.034,0,0,1,.355-.821c.082.338-.269.626-.114.972",
    transform: "translate(-20.026 -13.084)",
    fill: "#424143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88001",
    "data-name": "Path 88001",
    d: "M65.857,39.7l-.176.01c.144-.321.139-.8.712-.661-.327.095-.4.4-.536.651",
    transform: "translate(-20.338 -12.047)",
    fill: "#363538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88002",
    "data-name": "Path 88002",
    d: "M67.239,42.174c-.12-.31-.4-.4-.677-.507l.219-.077c.34.048.583.173.458.584",
    transform: "translate(-20.61 -12.84)",
    fill: "#4d4c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88003",
    "data-name": "Path 88003",
    d: "M32.288,40.216c.023.193-.142.475.15.549a1.125,1.125,0,0,0,1.133-.415c-.122.708-.713.681-1.188.648s-.236-.5-.288-.791a.116.116,0,0,1,.193.009",
    transform: "translate(-9.932 -12.398)",
    fill: "#363638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88004",
    "data-name": "Path 88004",
    d: "M33.08,39.06h0l-.225,0c-.495.088-.431.574-.625.877-.017.278-.015.623.322.63a1.045,1.045,0,0,0,1.065-.559l.095-.332c.014-.435-.351-.482-.63-.618",
    transform: "translate(-9.978 -12.058)",
    fill: "#a6cbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88005",
    "data-name": "Path 88005",
    d: "M32.3,39.867l-.193-.009c.236-.27,0-.959.714-.806-.348.16-.314.565-.521.815",
    transform: "translate(-9.94 -12.049)",
    fill: "#353538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88006",
    "data-name": "Path 88006",
    d: "M198.067,38.983c-.28-.411-.694-.245-1.068-.25l-.108-.129,1.389.021c.279.328.057.357-.213.357",
    transform: "translate(-60.966 -11.918)",
    fill: "#0e0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88007",
    "data-name": "Path 88007",
    d: "M75.052,38.611a.821.821,0,0,1-.217.634.492.492,0,0,1,.217-.634",
    transform: "translate(-23.159 -11.92)",
    fill: "#060608"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88008",
    "data-name": "Path 88008",
    d: "M178.684,38.6a2.212,2.212,0,0,1,1.462.169,4.38,4.38,0,0,0-1.363-.053l-.1-.117",
    transform: "translate(-55.328 -11.904)",
    fill: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88009",
    "data-name": "Path 88009",
    d: "M164.736,38.582a4.123,4.123,0,0,1,1.028,0c.3.074.075.188-.062.249-.278-.256-.7.043-.966-.25",
    transform: "translate(-51.009 -11.9)",
    fill: "#151518"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88010",
    "data-name": "Path 88010",
    d: "M162.385,38.846c-.162.012-.295-.008-.263-.223l1.059-.017c-.213.255-.572.022-.8.24",
    transform: "translate(-50.198 -11.918)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88011",
    "data-name": "Path 88011",
    d: "M142.869,38.7a2.706,2.706,0,0,1,2.246.1,3.588,3.588,0,0,0-1.924.055.3.3,0,0,1-.322-.152",
    transform: "translate(-44.238 -11.888)",
    fill: "#151517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88012",
    "data-name": "Path 88012",
    d: "M142.867,41.2h1.622c0,.05,0,.1.006.149h-1.62c0-.05-.008-.1-.008-.149",
    transform: "translate(-44.238 -12.719)",
    fill: "#19191b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88013",
    "data-name": "Path 88013",
    d: "M143.711,44.2H142.4c0-.024,0-.046,0-.07h1.313c0,.024,0,.046,0,.07",
    transform: "translate(-44.092 -13.623)",
    fill: "#161617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88014",
    "data-name": "Path 88014",
    d: "M13.8,41.277l-2.291-.025L11.5,40.97l2.273.017c.052.093.211.176.026.29",
    transform: "translate(-3.562 -12.648)",
    fill: "#212024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88015",
    "data-name": "Path 88015",
    d: "M11.529,38.9c-.047.159-.095.319-.142.478-.251-.235-.159-.465.021-.68.028-.033.128-.007.194-.008-.025.071-.049.14-.073.211",
    transform: "translate(-3.478 -11.941)",
    fill: "#08080a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88016",
    "data-name": "Path 88016",
    d: "M49.874,38.712c.223-.272.516-.1.779-.124-.232.221-.517.1-.779.124",
    transform: "translate(-15.443 -11.903)",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88017",
    "data-name": "Path 88017",
    d: "M205.835,40.056l-.526,1.53c-.193-.164-.072-.359-.111-.525l.522-1.8c.094-.113.195-.1.3-.015q-.091.406-.183.813",
    transform: "translate(-63.537 -12.095)",
    fill: "#161619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88018",
    "data-name": "Path 88018",
    d: "M206.334,38.6h1.577c-.6.376-1.044.189-1.438.288-.113.119-.255.11-.32-.015s.044-.231.181-.273",
    transform: "translate(-63.827 -11.916)",
    fill: "#161619"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88019",
    "data-name": "Path 88019",
    d: "M205.817,38.6c-.142.187-.129.3.139.288l-.166.178-.3.015c-.286-.336-.694-.129-1.032-.232.171-.391.563-.074.8-.25h.556",
    transform: "translate(-63.31 -11.916)",
    fill: "#313133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88020",
    "data-name": "Path 88020",
    d: "M205.215,38.592c-.21.265-.578.025-.8.25-.173-.133-.11-.238.063-.254a6.727,6.727,0,0,1,.737,0",
    transform: "translate(-63.264 -11.91)",
    fill: "#151517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88021",
    "data-name": "Path 88021",
    d: "M15.718,39.886l-.164-.162q.171-.564.341-1.127l.155.049-.331,1.24",
    transform: "translate(-4.816 -11.916)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88022",
    "data-name": "Path 88022",
    d: "M.756,41.855a1.911,1.911,0,0,1,.323-.989c.233.194.193-.181.342-.163.286.263.7.189,1.011.372l-.012.433c-.1.083-.2.037-.3,0-.229-.092-.455-.169-.654.06a2.718,2.718,0,0,0-.25.708c-.088.254-.067.55-.286.753,0,.051,0,.1,0,.153-.313,0-.736.125-.44-.471a5.362,5.362,0,0,0,.263-.851",
    transform: "translate(-0.122 -12.566)",
    fill: "#323234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88023",
    "data-name": "Path 88023",
    d: "M3.647,39.779c.1-.351.064-.617-.361-.724a.7.7,0,0,0-.962.568q-.1.125-.191-.01c.335-.848.829-1.072,1.628-.637.509.278.266.581-.114.8",
    transform: "translate(-0.66 -11.966)",
    fill: "#353537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88024",
    "data-name": "Path 88024",
    d: "M2.056,39.993l.191.01c-.244,1.051.54.589.965.655-.059.142-.191.165-.318.2-.36-.062-.8.105-1.011-.371l.173-.491",
    transform: "translate(-0.583 -12.347)",
    fill: "#4c4c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88025",
    "data-name": "Path 88025",
    d: "M1.339,43.039c.016.814.681.257.984.466-.341.345-.774.109-1.158.181.023-.283-.089-.589.137-.84.1.048.112.112.037.193",
    transform: "translate(-0.358 -13.227)",
    fill: "#3c3c3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88026",
    "data-name": "Path 88026",
    d: "M3.791,42.746a1.275,1.275,0,0,0-.079-.8c.432.226.308.506.079.8",
    transform: "translate(-1.149 -12.95)",
    fill: "#4b4b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88027",
    "data-name": "Path 88027",
    d: "M66.907,43.34l.438-.553c.054.343-.109.514-.438.553",
    transform: "translate(-20.717 -13.209)",
    fill: "#3b3b3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88028",
    "data-name": "Path 88028",
    d: "M64.964,44.207a.725.725,0,0,1,.944-.012l-.944.012",
    transform: "translate(-20.116 -13.592)",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88029",
    "data-name": "Path 88029",
    d: "M93.951,13.424c0-.064,0-.127-.008-.19l.989-.347c-.2.4-.672.325-.981.537",
    transform: "translate(-29.089 -3.979)",
    fill: "#273283"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88030",
    "data-name": "Path 88030",
    d: "M90.247,3.374a4.1,4.1,0,0,0-.162.418c.13-.369.28-.732.388-1.109.4-1.391-.048-2.045-1.461-2.047C80.143.62,71.274.632,62.4.621a1.25,1.25,0,0,0-1.366,1.007C60.153,4.3,59.488,7.049,58.532,9.7c-.74,2.052-1.062,4.236-1.975,6.232-.529,1.931-1.309,3.785-1.794,5.732-.253,1.014-.1,1.266.94,1.267q12.925.013,25.848,0a3.485,3.485,0,0,0,2.311-.744,2.4,2.4,0,0,0,1.058-1.517c.26-1.217,1.039-2.312.844-3.634a.254.254,0,0,1,.083-.225c.593-.462.6-1.209.893-1.818a3.907,3.907,0,0,0,.175-.714c.226-.738.466-1.486-.36-2.047,0,0,.193-.007.231-.124.024-.218-.82-.253-.183-.532A6.093,6.093,0,0,0,88.24,10.3a30.685,30.685,0,0,0,1.185-3.142,35.052,35.052,0,0,0,1.333-4.3c-.409-.067-.405.29-.512.514M81.059,17.385A7.628,7.628,0,0,1,79.8,18.39a9.554,9.554,0,0,1-2.612.237c-5.236-.009-10.473-.016-15.709.009-.721,0-.938-.122-.657-.868.377-1,.661-2.043.949-3.077a.857.857,0,0,1,.973-.749q8.474.037,16.949.008a2.872,2.872,0,0,1,1.415.363c1.01,1.04.46,2.056-.048,3.072M82.79,9.279c-.414.122-.808.3-1.234.393-5.123.073-10.246.015-15.369.032-.634,0-1.267.019-1.9-.008-.88-.037-.989-.212-.694-1.055.054-.173-.012-.38.149-.522a25.637,25.637,0,0,1,.873-2.771.88.88,0,0,1,.989-.63q8.533.032,17.065.007a2.936,2.936,0,0,1,1.261.307c.529.109.667.509.708.971A3.186,3.186,0,0,1,82.79,9.279m7.193-5.195c.013-.046.033-.09.048-.135-.16.516-.255,1.053-.449,1.559.175-.463.263-.951.4-1.424",
    transform: "translate(-16.924 -0.192)",
    fill: "#243081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88031",
    "data-name": "Path 88031",
    d: "M39.208,1.23c-.433-.33-1.116.1-1.465-.481A3.112,3.112,0,0,0,36.6.656q-12.369,0-24.738,0a8.248,8.248,0,0,0-.827.018.649.649,0,0,0-.611.353A9.119,9.119,0,0,0,9.681,2.68a13.175,13.175,0,0,1-.773,2.432c-.146.348-.414.841.029,1.017.416.165.39-.451.574-.681-.168.447-.322.912.215,1.269-.787-.538-.958-.5-1.359.411a7.238,7.238,0,0,0-.5,2.724.424.424,0,0,1-.062.274A5.818,5.818,0,0,0,6.65,12.406a6.733,6.733,0,0,1-.411,2.015c-.663,1.425-1,2.957-1.522,4.424a.8.8,0,0,0-.029.722c.283.415.12.644-.255.845a1.043,1.043,0,0,0-.4.4,4,4,0,0,0-.192.454c-.489,1.449-.318,1.69,1.216,1.69q12.644,0,25.287,0a3.97,3.97,0,0,0,3.075-1.149,2.823,2.823,0,0,0,.208-.208,2.531,2.531,0,0,0,.308-.762c.647-2.1,1.326-4.192,1.914-6.312.321-1.471.309-1.589-.252-2.318a.2.2,0,0,0,.128-.129l-.187-.138c-.4-.478.21-.323.308-.488l.226-.14c-.062-.142-.324-.225-.131-.44a.405.405,0,0,0-.2-.411c.6.283.879-.353,1.313-.6a.582.582,0,0,0,.084-.209.92.92,0,0,1,.429-1.286,5.625,5.625,0,0,0,.931-2.893.406.406,0,0,0-.3-.376,16.483,16.483,0,0,0-3.276-.122c-.507.024-1.191.83-.947,1.172.408.572-.463.917-.134,1.41-.8.362-.681,1.064-.581,1.708-.5.082-.971-.161-1.362.1a3.146,3.146,0,0,1-1.905.391,1.345,1.345,0,0,0-.882.156,2.239,2.239,0,0,1-1.5.336c-3.723,0-7.446,0-11.169-.006a3.838,3.838,0,0,1-2.474-.4c-.215-.157-.537-.071-.813-.068-.2,0-.448.131-.59-.142A1.479,1.479,0,0,1,12.653,8.6c.013-.044.023-.08.039-.129.079-.261.122-.532.182-.8.169-.493.344-.984.512-1.477a14.653,14.653,0,0,1,.5-1.593,9.024,9.024,0,0,1,3.068-.3c4.483-.088,8.969-.077,13.452-.008,1.049.016,2.274-.2,3.014.98.148.236.548.455.748.071.257-.495.653-.4,1.047-.415.9-.035,1.8.1,2.7.024.5-.362.152-.994.455-1.42.071-.176.231-.191.387-.247a1.216,1.216,0,0,0,.445-2.056M13.964,13.715q7.142,0,14.284,0a3.462,3.462,0,0,1,1.461.187,1.871,1.871,0,0,1,1.128,2.062,2.8,2.8,0,0,1-2.107,2.43,7.359,7.359,0,0,1-2.2.245c-5.367-.01-10.733-.021-16.1.014-.721,0-.961-.149-.709-.843a15.39,15.39,0,0,1,.877-3.331,1,1,0,0,1,1.053-.76c.771-.008,1.542-.006,2.312-.006",
    transform: "translate(-1.113 -0.2)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88032",
    "data-name": "Path 88032",
    d: "M46.414,9.261A2.017,2.017,0,0,0,46,6.964a1.361,1.361,0,0,1,.415,2.3",
    transform: "translate(-14.243 -2.15)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88033",
    "data-name": "Path 88033",
    d: "M43.806,13.017a1.114,1.114,0,0,1,.688-.31.559.559,0,0,1-.688.31",
    transform: "translate(-13.564 -3.923)",
    fill: "#233081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88034",
    "data-name": "Path 88034",
    d: "M218.235,20.464c-.131-.167-.128-.376.012-.429.216-.083.177.108.127.233a1.024,1.024,0,0,1-.139.2",
    transform: "translate(-67.545 -6.179)",
    fill: "#f57821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88035",
    "data-name": "Path 88035",
    d: "M1.4,42.641c-.012-.064-.024-.129-.037-.193l.2-.809a.238.238,0,0,1,.376.021c-.362.227-.264.7-.536.98",
    transform: "translate(-0.423 -12.83)",
    fill: "#4c4c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88036",
    "data-name": "Path 88036",
    d: "M2.027,41.608l-.376-.021c.342-.239.674-.311.973.069l-.6-.048",
    transform: "translate(-0.511 -12.778)",
    fill: "#353537"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40918",
    "data-name": "Group 40918",
    transform: "translate(226.107 80.064)",
    opacity: 0.197
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40917",
    "data-name": "Group 40917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40916",
    "data-name": "Group 40916",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87650",
    "data-name": "Path 87650",
    d: "M169.772,389.125c0-3.781,13.542-52.934,43.336-104.609s66.63-16.383,102.383-73.1S355.265,60.035,355.265,60.035H313.632s-7.891,106.009-45.811,119.874-98.049,98.306-98.049,98.306Z",
    transform: "translate(-169.772 -60.035)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40921",
    "data-name": "Group 40921",
    transform: "translate(250.934 237.715)",
    opacity: 0.197
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40920",
    "data-name": "Group 40920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40919",
    "data-name": "Group 40919",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87651",
    "data-name": "Path 87651",
    d: "M188.413,445.637H213S349.283,250.982,369.5,215.982V178.249C350.922,222,188.413,445.637,188.413,445.637",
    transform: "translate(-188.413 -178.248)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40999",
    "data-name": "Group 40999",
    transform: "translate(140.768 54.322) rotate(-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76649-3",
    "data-name": "Path 76649",
    d: "M65.588,52.521A35.126,35.126,0,1,1,52.558,4.63a35.133,35.133,0,0,1,13.03,47.892",
    transform: "translate(0 0)",
    fill: "#dde8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76650-3",
    "data-name": "Path 76650",
    d: "M49.982,40.024a26.768,26.768,0,1,1-9.93-36.5,26.772,26.772,0,0,1,9.93,36.5",
    transform: "translate(8.354 8.344)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76651-3",
    "data-name": "Path 76651",
    d: "M47.278,40.262c-.144-.076.342-1.153.989-3.148a28.419,28.419,0,0,0,1.407-8.66,27.512,27.512,0,0,0-.653-5.986,26.825,26.825,0,0,0-2.37-6.456,26.167,26.167,0,0,0-4.435-6.137,25.859,25.859,0,0,0-3.007-2.654A28.594,28.594,0,0,0,35.725,5a28.569,28.569,0,0,0-3.79-1.646,25.935,25.935,0,0,0-3.883-1.01A26.2,26.2,0,0,0,20.478,2.1a26.8,26.8,0,0,0-6.683,1.645,27.478,27.478,0,0,0-5.333,2.8,28.508,28.508,0,0,0-6.4,6C.771,14.2.149,15.21.006,15.131c-.107-.054.275-1.191,1.4-3.036A24.822,24.822,0,0,1,7.618,5.369,26.864,26.864,0,0,1,20.245.226a25.976,25.976,0,0,1,3.99-.238,26.237,26.237,0,0,1,4.16.379,27.124,27.124,0,0,1,4.2,1.058,29.61,29.61,0,0,1,4.095,1.766A29.562,29.562,0,0,1,40.44,5.6a27.425,27.425,0,0,1,3.223,2.888,27.287,27.287,0,0,1,4.672,6.674A26.811,26.811,0,0,1,51.124,28.5a24.825,24.825,0,0,1-2.111,8.9c-.9,1.966-1.63,2.918-1.735,2.861",
    transform: "translate(11.468 7.374)",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-rupee-sign-3",
    "data-name": "Icon awesome-rupee-sign",
    d: "M18.373,3.815a.717.717,0,0,0,.716-.717V.71a.716.716,0,0,0-.716-.716L.716,0A.717.717,0,0,0,0,.717V3.389a.716.716,0,0,0,.716.716L5.8,4.1A4.3,4.3,0,0,1,9.439,5.73l-8.725,0A.717.717,0,0,0,0,6.45V8.839a.716.716,0,0,0,.716.716l9.471,0a4.128,4.128,0,0,1-4.461,3.5l-5.011,0a.717.717,0,0,0-.716.717v3.166a.717.717,0,0,0,.23.527l9.843,9.1a.715.715,0,0,0,.485.19l4.926,0a.717.717,0,0,0,.486-1.244l-9-8.315A8.184,8.184,0,0,0,15.221,9.55h3.151a.717.717,0,0,0,.716-.717V6.443a.716.716,0,0,0-.716-.716h-3.5a8.179,8.179,0,0,0-.85-1.911Z",
    transform: "translate(32.393 18.864) rotate(26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41002",
    "data-name": "Group 41002",
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 32.52, 269.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76649-4",
    "data-name": "Path 76649",
    d: "M54.182,43.41A29.021,29.021,0,1,1,43.416,3.829,29.012,29.012,0,0,1,54.182,43.41",
    transform: "translate(0 0)",
    fill: "#dde8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76650-4",
    "data-name": "Path 76650",
    d: "M41.29,33.081a22.116,22.116,0,1,1-8.2-30.164,22.108,22.108,0,0,1,8.2,30.164",
    transform: "translate(6.901 6.897)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76651-4",
    "data-name": "Path 76651",
    d: "M39.056,33.278a13.09,13.09,0,0,1,.817-2.6,23.5,23.5,0,0,0,1.162-7.157,22.75,22.75,0,0,0-.54-4.947,22.179,22.179,0,0,0-1.958-5.336,21.628,21.628,0,0,0-3.664-5.073A21.367,21.367,0,0,0,32.388,5.97a23.621,23.621,0,0,0-2.877-1.836,23.6,23.6,0,0,0-3.131-1.36,21.417,21.417,0,0,0-3.208-.835,21.629,21.629,0,0,0-6.256-.2A22.127,22.127,0,0,0,11.4,3.1a22.69,22.69,0,0,0-4.4,2.317,23.55,23.55,0,0,0-5.285,4.962C.638,11.739.124,12.57.006,12.506A6.5,6.5,0,0,1,1.166,10,20.507,20.507,0,0,1,6.293,4.438,22.182,22.182,0,0,1,16.724.188a21.447,21.447,0,0,1,3.3-.2A21.663,21.663,0,0,1,23.456.3a22.4,22.4,0,0,1,3.468.875,24.456,24.456,0,0,1,3.382,1.459,24.421,24.421,0,0,1,3.1,1.988,22.661,22.661,0,0,1,2.663,2.387,22.556,22.556,0,0,1,3.859,5.516,22.169,22.169,0,0,1,2.3,11.024,20.524,20.524,0,0,1-1.744,7.359,6.523,6.523,0,0,1-1.433,2.364",
    transform: "translate(9.474 6.095)",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-rupee-sign-4",
    "data-name": "Icon awesome-rupee-sign",
    d: "M15.18,3.156a.592.592,0,0,0,.592-.592V.59A.592.592,0,0,0,15.181,0L.591,0A.592.592,0,0,0,0,.592V2.8a.592.592,0,0,0,.591.592h4.2a3.553,3.553,0,0,1,3,1.345H.591A.592.592,0,0,0,0,5.33V7.3A.592.592,0,0,0,.59,7.9H8.415A3.408,3.408,0,0,1,4.73,10.789H.59A.592.592,0,0,0,0,11.382V14a.593.593,0,0,0,.19.435l8.134,7.518a.591.591,0,0,0,.4.157h4.069a.592.592,0,0,0,.4-1.027L5.758,14.208a6.758,6.758,0,0,0,6.818-6.313h2.6a.592.592,0,0,0,.592-.592V5.328a.592.592,0,0,0-.591-.592H12.287a6.762,6.762,0,0,0-.7-1.579Z",
    transform: "translate(26.76 15.592) rotate(26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41004",
    "data-name": "Group 41004",
    transform: "translate(275.786 322.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_22",
    "data-name": "Subtraction 22",
    d: "M55.411,105.042c-.191,0-.39,0-.592-.007l-3.653-.085-2.74-.064c-2.635-.062-5.8-.444-6.893-2.871a7.051,7.051,0,0,1-.312-3.432,11.68,11.68,0,0,0,.015-2.283c-.364-2.871-3.328-4.65-5.865-4.651a4.834,4.834,0,0,0-3.147,1.083,11.582,11.582,0,0,0-1.6,1.764,7.127,7.127,0,0,1-2.607,2.375,3.773,3.773,0,0,1-1.49.3c-2.055,0-4.088-1.543-5.629-2.886-.7-.608-1.422-1.212-2.122-1.8l-.008-.007c-3.806-3.177-7.4-6.178-6.551-9.451a7.368,7.368,0,0,1,2-3A11.379,11.379,0,0,0,15.8,78.05a5.384,5.384,0,0,0-.205-5.318,5.355,5.355,0,0,0-4.469-2.87h-.037a11.492,11.492,0,0,0-2.413.346l-.02,0a11.534,11.534,0,0,1-2.361.341,3.93,3.93,0,0,1-1.492-.27c-1.884-.761-2.657-3.033-3.119-4.928-.611-2.5-1.113-5.06-1.493-7.6A14.1,14.1,0,0,1,.312,52.42a4.606,4.606,0,0,1,2.937-3.59,7.691,7.691,0,0,1,2.062-.283,11.254,11.254,0,0,0,1.45-.13,5.69,5.69,0,0,0,4.423-4.192A5.723,5.723,0,0,0,9.1,38.485,11.409,11.409,0,0,0,7.4,37.493a7.437,7.437,0,0,1-2.38-1.618c-1.609-1.863-1.216-4.79,1.169-8.7q1.745-2.856,3.488-5.712c1.329-2.176,2.868-4.2,5.116-4.268l.116,0A7.073,7.073,0,0,1,18.617,18.7a11.333,11.333,0,0,0,2.556,1.345,4.376,4.376,0,0,0,1.334.206,5.7,5.7,0,0,0,4.323-2.2,5.025,5.025,0,0,0,1.141-4.157,10.769,10.769,0,0,0-.6-1.8,9.47,9.47,0,0,1-.647-2.039c-.521-3.307,2.547-6.194,5.846-7.335a35.377,35.377,0,0,1,4.078-1.056A30.832,30.832,0,0,0,41.308.4,5.534,5.534,0,0,1,43.313,0a4.193,4.193,0,0,1,3.8,2.359A16.184,16.184,0,0,1,48,4.494a10.783,10.783,0,0,0,1.467,3.015,5.059,5.059,0,0,0,4.054,1.826,5.429,5.429,0,0,0,5.068-3.028,10.936,10.936,0,0,0,.489-1.59,7.745,7.745,0,0,1,.773-2.147C60.7,1.185,62.183.483,64.276.484a14.66,14.66,0,0,1,4.824.969c2.374.869,4.746,1.858,7.049,2.938,1.79.839,3.894,2.062,4.277,4.1a6.638,6.638,0,0,1-.823,3.823,11.885,11.885,0,0,0-.827,2.392,5.061,5.061,0,0,0,1.207,4.181,6.165,6.165,0,0,0,4.577,2.29,4.518,4.518,0,0,0,1.809-.369,11.388,11.388,0,0,0,1.76-1.032,7.245,7.245,0,0,1,2.71-1.315,3.839,3.839,0,0,1,.651-.056c2.092,0,4.047,1.709,5.977,5.223q1.593,2.9,3.185,5.8c1.276,2.322,2.542,5.266,1,7.438a7.02,7.02,0,0,1-2.824,2,11.308,11.308,0,0,0-2.036,1.172,5.3,5.3,0,0,0-1.721,5.132,5.3,5.3,0,0,0,3.33,4.27,11.08,11.08,0,0,0,2.155.415,7.558,7.558,0,0,1,2.953.781,4.326,4.326,0,0,1,1.974,2.777,13.238,13.238,0,0,1-.159,5.851l-1.281,6.333c-.535,2.636-1.484,5.747-4.1,6.409a4.056,4.056,0,0,1-1.009.12,10.367,10.367,0,0,1-2.426-.4,11.714,11.714,0,0,0-2.261-.4c-.073,0-.146,0-.218,0a5.717,5.717,0,0,0-4.978,3.031,5.789,5.789,0,0,0,.558,6.006,11.465,11.465,0,0,0,1.046,1.121A7.535,7.535,0,0,1,92.1,83.206a5.02,5.02,0,0,1-.476,5.016,15.116,15.116,0,0,1-3.751,3.662l-3.081,2.371-.125.1L82.78,95.8c-1.536,1.182-3.191,2.276-4.894,2.276a3.66,3.66,0,0,1-1.112-.171,6.758,6.758,0,0,1-3.079-2.687,11.736,11.736,0,0,0-1.841-2.038,4.773,4.773,0,0,0-3.019-1.01c-2.485,0-5.394,1.744-5.76,4.566a11.294,11.294,0,0,0-.01,2.067,7.494,7.494,0,0,1-.22,2.942C62.063,103.935,59.562,105.044,55.411,105.042ZM52.271,19.489A32.986,32.986,0,0,0,22.008,65.282a33.079,33.079,0,0,0,17.5,17.555A32.945,32.945,0,0,0,75.515,29.156a32.738,32.738,0,0,0-23.244-9.668Z",
    transform: "translate(0 0)",
    fill: "#096ef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85211",
    "data-name": "Path 85211",
    d: "M12.618,12.581H5.2L3.788,16.011H0L7.119,0H10.77l7.142,16.011H14.033ZM11.454,9.767,8.921,3.636,6.389,9.767Z",
    transform: "translate(31.709 44.517)",
    fill: "#0a192c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85212",
    "data-name": "Path 85212",
    d: "M10.6.709a5.48,5.48,0,0,1,2.407,2.013,5.559,5.559,0,0,1,.844,3.088,5.572,5.572,0,0,1-.844,3.076A5.379,5.379,0,0,1,10.6,10.9a8.967,8.967,0,0,1-3.685.7H3.7v4.415H0V0H6.914A8.851,8.851,0,0,1,10.6.709M9.242,7.857a2.512,2.512,0,0,0,.867-2.047,2.54,2.54,0,0,0-.867-2.071,3.879,3.879,0,0,0-2.532-.72H3.7V8.577H6.71a3.879,3.879,0,0,0,2.532-.72",
    transform: "translate(51.285 44.517)",
    fill: "#0a192c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10834",
    "data-name": "Rectangle 10834",
    width: 3.696,
    height: 16.011,
    transform: "translate(67.758 44.517)",
    fill: "#0a192c"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40928",
    "data-name": "Group 40928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40927",
    "data-name": "Group 40927",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87652",
    "data-name": "Path 87652",
    d: "M343.135,401.469a18.137,18.137,0,0,1-11.056-5.036,34.73,34.73,0,0,1-7.165-10.039,64.83,64.83,0,0,1-6.891-31.851,17.72,17.72,0,0,1,1.352-6.883,7.309,7.309,0,0,1,5.246-4.289c3.476-.5,6.507,2.279,8.715,5.013a65.068,65.068,0,0,1,14.144,44.594c-.253,3.9-1.552,7.663-4.346,8.491",
    transform: "translate(105.511 114.535)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87653",
    "data-name": "Path 87653",
    d: "M351.427,383.962a32.142,32.142,0,0,1-1.4-22.914,44.828,44.828,0,0,1,12.552-19.52c6.256-5.872,14.288-10.382,22.862-10.428,3.656-.02,7.614.963,9.858,3.853,2.389,3.077,2.192,7.45,1.143,11.2-1.717,6.147-5.359,11.616-9.71,16.278a116.747,116.747,0,0,1-14.466,12.481c-5.695,4.384-11.844,8.922-19.007,9.469",
    transform: "translate(115.666 110.461)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87654",
    "data-name": "Path 87654",
    d: "M351.1,394.274c1.01-7.927,7.157-14.482,14.349-17.948s15.335-4.317,23.306-4.717a15.23,15.23,0,0,1,5.289.376,5.389,5.389,0,0,1,3.733,3.487c.6,2.253-.831,4.513-2.32,6.3a46.062,46.062,0,0,1-36.031,16.339,12.89,12.89,0,0,1-4.641-.778,5.375,5.375,0,0,1-3.2-3.278",
    transform: "translate(116.504 123.955)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87655",
    "data-name": "Path 87655",
    d: "M323.092,348.116a462.936,462.936,0,0,1,22.7,71.59q2.4,10.47,4.314,21.043c.116.632,1.077.364.964-.265a463.089,463.089,0,0,0-19.341-72.573q-3.6-10.118-7.674-20.06c-.24-.588-1.207-.331-.963.265",
    transform: "translate(107.199 115.938)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87656",
    "data-name": "Path 87656",
    d: "M344.778,434.967c-.466-14.35.67-28.834,4.689-42.664a96.554,96.554,0,0,1,20.322-37.111,111.326,111.326,0,0,1,20.5-17.881c.527-.361.028-1.23-.5-.864-12.81,8.784-23.97,19.9-31.821,33.38a106.419,106.419,0,0,0-13.14,40.213,156.5,156.5,0,0,0-1.043,24.927c.021.641,1.02.645,1,0",
    transform: "translate(114.043 112.215)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87657",
    "data-name": "Path 87657",
    d: "M345.05,402.01a76.258,76.258,0,0,1,44.089-25.292c.631-.113.364-1.078-.266-.966A77.12,77.12,0,0,0,344.344,401.3c-.418.485.286,1.2.706.707",
    transform: "translate(114.221 125.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87658",
    "data-name": "Path 87658",
    d: "M375.527,422.329V405.171H327.791v17.158s-.918,30.334,15.911,33.092h15.913c16.829-2.758,15.911-33.092,15.911-33.092",
    transform: "translate(108.768 135.172)",
    fill: "#204490"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40996",
    "data-name": "Group 40996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40995",
    "data-name": "Group 40995",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87660",
    "data-name": "Path 87660",
    d: "M177.915,162.72,157.2,155.229a1.856,1.856,0,0,1-1.113-2.375l14.458-40.079a1.851,1.851,0,0,1,2.371-1.114l20.713,7.491a1.856,1.856,0,0,1,1.112,2.375L180.287,161.6a1.852,1.852,0,0,1-2.372,1.115",
    transform: "translate(51.759 37.215)",
    fill: "#0a192c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87662",
    "data-name": "Path 87662",
    d: "M190.714,150.19l-21.652,27.6s-21.751-31.3-29.909-38.079c-7.484-6.215.5,8.89.5,8.89s.112,26.659.984,27.414,24.182,34.739,36.126,24.584,24.2-48.366,24.2-48.366Z",
    transform: "translate(45.113 46.111)",
    fill: "#d6917a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87663",
    "data-name": "Path 87663",
    d: "M179.087,128.658s12.142,3.537,13.559,6.236-3,22.263-3.252,22.283c-.158.012-5-1.127-8.6-1.983a3.5,3.5,0,0,1-2.521-4.5,16.006,16.006,0,0,0,.834-3.589c.039-.667-7.639-3.77-7.542-5.92s1.192-1.835,1.192-1.835-4.057-1.891-3.2-4.092a3.422,3.422,0,0,1,3.914-2.122s-2.292-2.414-1.869-4.178c.627-2.615,7.488-.305,7.488-.305",
    transform: "translate(56.224 42.608)",
    fill: "#d6917a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87664",
    "data-name": "Path 87664",
    d: "M171.764,137.068A40.118,40.118,0,0,1,180.9,139.7c.585.249,1.095-.612.5-.863a41.06,41.06,0,0,0-9.373-2.737c-.629-.1-.9.86-.265.964",
    transform: "translate(56.877 45.404)",
    fill: "#a24e3f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87665",
    "data-name": "Path 87665",
    d: "M172.162,132.377a28.685,28.685,0,0,1,10.388,3.478.5.5,0,0,0,.5-.864,29.985,29.985,0,0,0-10.893-3.614c-.635-.083-.63.919,0,1",
    transform: "translate(56.971 43.828)",
    fill: "#a24e3f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40934",
    "data-name": "Group 40934",
    transform: "translate(231.077 157.113)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40933",
    "data-name": "Group 40933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40932",
    "data-name": "Group 40932",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87666",
    "data-name": "Path 87666",
    d: "M176.617,120.172a1.608,1.608,0,1,1-.955-2.309,1.781,1.781,0,0,1,.955,2.309",
    transform: "translate(-173.503 -117.81)",
    fill: "#fff"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87667",
    "data-name": "Path 87667",
    d: "M96.838,123.559c5.094-9.594,7.348-20.038,11.162-30.21a30.611,30.611,0,0,1,5.805-8.742c3.3-3.651,12.077-7.859,15.305-8.082l16.352,2.659c16.576-2.1,19.312,22.3,19.81,38.734s-4.107,33.394-13.513,46.873c-1.866,2.674-3.949,5.348-6.84,6.849-3.589,1.864-7.859,1.65-11.891,1.332-13.6-1.067-28.392-3.366-37.586-13.458a39.771,39.771,0,0,0,6.052-17.557,30.424,30.424,0,0,1-12.254,13.236l-10.411-9.1c9.278-8.294,12.913-12.941,18.008-22.535",
    transform: "translate(26.158 25.53)",
    fill: "#0a192c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87668",
    "data-name": "Path 87668",
    d: "M88.705,143.476h.005l.051-.024Z",
    transform: "translate(29.435 47.858)",
    fill: "#407bff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87669",
    "data-name": "Path 87669",
    d: "M137.862,134.389s8.195.723,13.638,10.128,10.779,17.1,10.779,17.1l-17.6,11.756Z",
    transform: "translate(45.747 44.835)",
    fill: "#407bff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40937",
    "data-name": "Group 40937",
    transform: "translate(183.609 179.224)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40936",
    "data-name": "Group 40936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40935",
    "data-name": "Group 40935",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87670",
    "data-name": "Path 87670",
    d: "M137.862,134.389s8.195.723,13.638,10.128,10.779,17.1,10.779,17.1l-17.6,11.756Z",
    transform: "translate(-137.862 -134.389)",
    fill: "#fff"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87671",
    "data-name": "Path 87671",
    d: "M172.246,195.8c-1.963-1.316-4.47-1.415-6.831-1.439a258.789,258.789,0,0,0-52.69,4.884l-3.042,1.5c-2.4-1.4-5.61-.453-7.63,1.454s-3.12,4.569-4.159,7.147c-8.986,22.29-17.538,44.816-23.613,68.072-1.406,5.382-2.613,11.385.031,16.278,3.086,5.711,10.173,7.72,16.557,8.857,20.852,3.713,42.15,3.942,63.33,3.986,5.148.011,10.652-.095,14.894-3.015,5.939-4.089,7.348-12.141,8.04-19.325a370.587,370.587,0,0,0-.806-78.961c-.416-3.519-1.14-7.467-4.081-9.438",
    transform: "translate(24.139 64.837)",
    fill: "#204490"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87672",
    "data-name": "Path 87672",
    d: "M132.443,438.871l14.651,1.436,10.828-37.144-22.288-2.43Z",
    transform: "translate(43.948 133.692)",
    fill: "#b97964"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87673",
    "data-name": "Path 87673",
    d: "M150.914,425.55h-5.231a3.711,3.711,0,0,0-2.977,1.556c-3.017,4.125-5.285,2.565-8.565-1.312-2.086-.244-2.648,2.152-2.818,2.8l-3.91,14.243a2.236,2.236,0,0,0,2.186,2.857h41.444c6.591,0,7.958-6.652,5.242-7.267-12.209-2.7-20.854-6.3-24.628-9.857-.7-.622.019-1.088-.742-3.017",
    transform: "translate(42.251 141.971)",
    fill: "#0a192c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87674",
    "data-name": "Path 87674",
    d: "M155.714,429.311a2.139,2.139,0,0,0,.887-1.71.96.96,0,0,0-.426-.924c-1.639-1.163-8.18,1.9-8.914,2.258a.29.29,0,0,0,0,.547,23.623,23.623,0,0,0,4.9.632,5.829,5.829,0,0,0,3.552-.8m.051-2.138a.376.376,0,0,1,.17.393,1.709,1.709,0,0,1-.649,1.248c-1.485,1.111-5.072.632-7,.273,2.716-1.2,6.575-2.547,7.48-1.915",
    transform: "translate(48.802 142.26)",
    fill: "#407bff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87675",
    "data-name": "Path 87675",
    d: "M147.494,430.439c1.963-.82,6.078-4.053,5.856-5.762-.033-.359-.29-.787-1.177-.906-3.587-.411-5.124,6.035-5.124,6.309a.291.291,0,0,0,.085.307.357.357,0,0,0,.205,0Zm4.559-6.139c.666.068.666.308.666.393.188,1.043-2.8,3.727-4.936,4.856.445-1.5,1.759-5.266,4.03-5.266Z",
    transform: "translate(48.791 141.371)",
    fill: "#407bff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87676",
    "data-name": "Path 87676",
    d: "M148.871,428.581a6.341,6.341,0,0,0-4.443,2.866",
    transform: "translate(47.926 142.982)",
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87677",
    "data-name": "Path 87677",
    d: "M151.312,430.418a6.337,6.337,0,0,0-4.442,2.866",
    transform: "translate(48.736 143.595)",
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87678",
    "data-name": "Path 87678",
    d: "M154.349,431.963a6.341,6.341,0,0,0-4.443,2.865",
    transform: "translate(49.743 144.11)",
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40940",
    "data-name": "Group 40940",
    transform: "translate(177.577 554.655)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40939",
    "data-name": "Group 40939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40938",
    "data-name": "Group 40938",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87679",
    "data-name": "Path 87679",
    d: "M151.9,417.734l-1.328,4.556-17.243-2.653.313-3.734Z",
    transform: "translate(-133.333 -415.902)"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87680",
    "data-name": "Path 87680",
    d: "M94.321,439.754l14.651,1.436L119.8,404.046l-22.288-2.43Z",
    transform: "translate(31.299 133.986)",
    fill: "#b97964"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87681",
    "data-name": "Path 87681",
    d: "M112.793,426.433h-5.231a3.714,3.714,0,0,0-2.978,1.556c-3.017,4.125-5.283,2.566-8.564-1.312-2.086-.244-2.648,2.152-2.818,2.8l-3.91,14.244a2.239,2.239,0,0,0,1.536,2.769,2.191,2.191,0,0,0,.65.087h41.444c6.591,0,7.958-6.651,5.242-7.267-12.209-2.7-20.855-6.3-24.628-9.855-.7-.623.019-1.09-.742-3.018",
    transform: "translate(29.601 142.266)",
    fill: "#0a192c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87682",
    "data-name": "Path 87682",
    d: "M117.593,430.194a2.142,2.142,0,0,0,.887-1.711.958.958,0,0,0-.426-.923c-1.639-1.163-8.18,1.9-8.914,2.257a.291.291,0,0,0,0,.548,23.622,23.622,0,0,0,4.9.632,5.829,5.829,0,0,0,3.552-.8m.051-2.138a.377.377,0,0,1,.17.393,1.711,1.711,0,0,1-.649,1.248c-1.486,1.111-5.072.632-7,.273,2.716-1.2,6.574-2.547,7.48-1.915",
    transform: "translate(36.152 142.554)",
    fill: "#407bff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87683",
    "data-name": "Path 87683",
    d: "M109.373,431.322c1.963-.82,6.078-4.053,5.856-5.762-.033-.359-.29-.787-1.177-.906-3.587-.411-5.124,6.036-5.124,6.309a.3.3,0,0,0,.085.308.383.383,0,0,0,.205,0Zm4.559-6.139c.666.068.666.308.666.393.188,1.043-2.8,3.727-4.934,4.856.443-1.5,1.758-5.266,4.029-5.266Z",
    transform: "translate(36.141 141.666)",
    fill: "#407bff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87684",
    "data-name": "Path 87684",
    d: "M110.749,429.464a6.339,6.339,0,0,0-4.442,2.865",
    transform: "translate(35.276 143.277)",
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87685",
    "data-name": "Path 87685",
    d: "M113.19,431.3a6.344,6.344,0,0,0-4.443,2.865",
    transform: "translate(36.086 143.89)",
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87686",
    "data-name": "Path 87686",
    d: "M116.227,432.846a6.339,6.339,0,0,0-4.442,2.865",
    transform: "translate(37.094 144.405)",
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40943",
    "data-name": "Group 40943",
    transform: "translate(126.806 555.832)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40942",
    "data-name": "Group 40942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40941",
    "data-name": "Group 40941",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87687",
    "data-name": "Path 87687",
    d: "M95.212,420.52l.312-3.734,18.259,1.831-1.328,4.556",
    transform: "translate(-95.212 -416.785)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40946",
    "data-name": "Group 40946",
    transform: "translate(127.71 285.54)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40945",
    "data-name": "Group 40945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40944",
    "data-name": "Group 40944",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87688",
    "data-name": "Path 87688",
    d: "M172.479,219.183s-10.76,11.376-31.845,11.57-44.743-12.1-44.743-12.1l2.648-4.541,60.722,6.625,11.62-6.625Z",
    transform: "translate(-95.891 -214.109)"
  }))))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87689",
    "data-name": "Path 87689",
    d: "M168.786,222.807s12.814,52.566,18.6,99.337c1.762,14.256,4.447,39.82,1.329,53.855L162.966,486.014l-27.205-2.729c6.9-48.538,13.743-106.353,13.743-129.273L112.583,238.954Z",
    transform: "translate(37.358 74.332)",
    fill: "#096ef2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87691",
    "data-name": "Path 87691",
    d: "M165.2,205.4s-26.31,14.166-62.18,11.512q-.529-.04-1.067-.085l-2.3,1.528c-4.1,7.031-9.551,21.639-9.472,41.2.791,30.624,5.331,78.2,5.74,88.528l.124.011c-.268,7.89-.545,13.882-.822,16.85-3.753,40.2-5.044,130.673-5.044,130.673l27.3.4s20.413-136.9,20.919-145.295c.056-.931.12-1.882.186-2.841l1.251-14.654c1.28-13.4,2.9-28.3,3.7-43.384l2.084-24.433c17.92-5.9,27.486-32.3,30.6-36.8-4.679-17.253-6.748-15.7-11.017-23.212",
    transform: "translate(29.924 68.525)",
    fill: "#096ef2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87692",
    "data-name": "Path 87692",
    d: "M93.747,175.539l-9.159-31.273c5.793-8.659,34.462-15.313,34.462-15.313l18.888,1.034s7.26,1.622,13.475,3.651c8.3,2.71,12.784,4.889,14.762,9.5,0,0,3.463,10.214,1.381,31.263-.573,5.788-1.882,36.334-.268,46.275l11.733,22.988c-34.512,26.914-78.694.012-78.694.012,1.552-4.752,4.961-15.278,5.662-19.922-.506-5.925-2.167-9.815-4.673-20.191-.483-2-6.73-26.078-7.57-28.023",
    transform: "translate(28.069 43.021)",
    fill: "#407bff"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40952",
    "data-name": "Group 40952",
    transform: "translate(112.656 171.974)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40951",
    "data-name": "Group 40951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40950",
    "data-name": "Group 40950",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87693",
    "data-name": "Path 87693",
    d: "M93.747,175.539l-9.159-31.273c5.793-8.659,34.462-15.313,34.462-15.313l18.888,1.034s7.26,1.622,13.475,3.651c8.3,2.71,12.784,4.889,14.762,9.5,0,0,3.463,10.214,1.381,31.263-.573,5.788-1.882,36.334-.268,46.275l11.733,22.988c-34.512,26.914-78.694.012-78.694.012,1.552-4.752,4.961-15.278,5.662-19.922-.506-5.925-2.167-9.815-4.673-20.191-.483-2-6.73-26.078-7.57-28.023",
    transform: "translate(-84.587 -128.953)",
    fill: "#32cbd1"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87694",
    "data-name": "Path 87694",
    d: "M129.971,137.225c-1.976-1.976-2.867-2.423-2.493-5.3a29.091,29.091,0,0,1,1.821-6.747l-2.947-3.207-15.332-14.41c.731,9.967,1.212,24.9-6.382,30.6l25.334,20.5Z",
    transform: "translate(34.722 35.885)",
    fill: "#d6917a"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40955",
    "data-name": "Group 40955",
    transform: "translate(153.689 152.167)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40954",
    "data-name": "Group 40954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40953",
    "data-name": "Group 40953",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87695",
    "data-name": "Path 87695",
    d: "M123.825,130.411c-4.155-2.27-8.77-6.3-8.409-11.113a22.445,22.445,0,0,1,.97-5.2l8.7,10.7a26.75,26.75,0,0,0-1.257,5.605",
    transform: "translate(-115.397 -114.101)"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87696",
    "data-name": "Path 87696",
    d: "M106.455,101.295c1.942,15.166,2.444,21.61,10.576,29.3,12.232,11.573,30.233,6.876,32.81-8.32,2.321-13.678-1.248-36.182-16.4-42.036-14.928-5.767-28.931,5.884-26.988,21.051",
    transform: "translate(35.265 26.27)",
    fill: "#d6917a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87701",
    "data-name": "Path 87701",
    d: "M129.493,97.944a51.77,51.77,0,0,0,5.4,9.063,1.177,1.177,0,0,1-.485,1.815,7.509,7.509,0,0,1-4.07.213Z",
    transform: "translate(42.97 32.676)",
    fill: "#a5654f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87704",
    "data-name": "Path 87704",
    d: "M103.472,90.421c-2.06,2.982,2.043,11.646,2.043,11.646s7.289-2.171,7.687,8.825c2.688.445,5.707-9.821,5.267-20.14-.538-5.831-11.357-5.6-15-.331",
    transform: "translate(34.143 28.833)",
    fill: "#0a192c"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87705",
    "data-name": "Path 87705",
    d: "M137.783,81.866c-3.215-6.692-8.835-9.145-23.894-2.682-13.606,5.817-4.961,26.1-1.869,35.382.658,1.971,17.986-20,17.986-20Z",
    transform: "translate(35.326 25.158)",
    fill: "#0a192c"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87706",
    "data-name": "Path 87706",
    d: "M103.576,107.408a12.243,12.243,0,0,0,7.594,5.484c4.059.864,5.9-5.688,4.383-9.673a8.087,8.087,0,0,0-9.294-4.914c-3.829.92-4.865,5.609-2.684,9.1",
    transform: "translate(33.996 32.726)",
    fill: "#d6917a"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40958",
    "data-name": "Group 40958",
    transform: "translate(139.632 134.341)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40957",
    "data-name": "Group 40957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40956",
    "data-name": "Group 40956",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87707",
    "data-name": "Path 87707",
    d: "M108.286,101.128a2.453,2.453,0,0,0-3.049,1.423c-.513,1.29.2,4.285,4.143,5.225",
    transform: "translate(-104.759 -100.651)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87709",
    "data-name": "Path 87709",
    d: "M129.976,206.3a45.091,45.091,0,0,0-29.5-7.663L95.42,211.918c14.132,12.759,31.414,14.47,50.432,13.876,2.677-9.854-7.329-13.623-15.877-19.5",
    transform: "translate(31.663 66.203)",
    fill: "#204490"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87710",
    "data-name": "Path 87710",
    d: "M157.7,198.992c-1.4-2.613-4.241-4.692-7.164-4.238-2.178.337-3.917,1.948-5.421,3.561a62.493,62.493,0,0,0-13.4,22.377l1.112,6.353,5.9-2.425c5.574-2.292,11.322-4.7,15.488-9.061s6.326-11.246,3.485-16.568",
    transform: "translate(43.706 64.952)",
    fill: "#204490"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87711",
    "data-name": "Path 87711",
    d: "M143.594,216.993a7.986,7.986,0,1,1-7.986-8,7.991,7.991,0,0,1,7.986,8",
    transform: "translate(42.349 69.725)",
    fill: "#204490"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87712",
    "data-name": "Path 87712",
    d: "M141.311,245.671q-.991-14.241-1.983-28.483l-3.713,2.415a85.505,85.505,0,0,0-14.024,58.823,70.694,70.694,0,0,0,15.034.97q-2.126-4.5-4.25-8.991c4.383-1.714,7.278-6.1,8.43-10.669s.834-9.363.506-14.064",
    transform: "translate(40.112 72.458)",
    fill: "#204490"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87713",
    "data-name": "Path 87713",
    d: "M152.413,256c2.12-2.9,2.516-6.717,2.289-10.3a36.129,36.129,0,0,0-17.063-28.159l-1.588-1.248c5.67,17.128,4.567,35.664,3.4,53.671q5.716-1.16,11.434-2.318c-1.176-2.362-2.376-5.074-1.446-7.543.6-1.588,1.97-2.733,2.973-4.1",
    transform: "translate(45.146 72.157)",
    fill: "#204490"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40961",
    "data-name": "Group 40961",
    transform: "translate(170.135 278.905)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40960",
    "data-name": "Group 40960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40959",
    "data-name": "Group 40959",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87714",
    "data-name": "Path 87714",
    d: "M134.19,210.246a6.848,6.848,0,1,1-.24.055.5.5,0,0,0-.265-.964,7.881,7.881,0,1,0,.24-.055c-.63.124-.364,1.088.265.964",
    transform: "translate(-127.745 -209.134)"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40964",
    "data-name": "Group 40964",
    transform: "translate(173.501 280.289)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40963",
    "data-name": "Group 40963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40962",
    "data-name": "Group 40962",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87715",
    "data-name": "Path 87715",
    d: "M137.778,210.336a43.17,43.17,0,0,0-7.468,12.369c-.236.6.73.859.963.267a41.738,41.738,0,0,1,7.211-11.929c.418-.484-.285-1.195-.706-.707",
    transform: "translate(-130.273 -210.172)"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40967",
    "data-name": "Group 40967",
    transform: "translate(184.03 273.81)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40966",
    "data-name": "Group 40966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40965",
    "data-name": "Group 40965",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87716",
    "data-name": "Path 87716",
    d: "M139.115,214.191q3.126-4.061,6.252-8.123a.5.5,0,0,0-.18-.684.511.511,0,0,0-.683.18q-3.124,4.061-6.252,8.122a.5.5,0,1,0,.863.505",
    transform: "translate(-138.178 -205.314)"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40970",
    "data-name": "Group 40970",
    transform: "translate(184.598 278.499)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40969",
    "data-name": "Group 40969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40968",
    "data-name": "Group 40968",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87717",
    "data-name": "Path 87717",
    d: "M139.236,213.136a63.707,63.707,0,0,0,7.005-3.375c.562-.313.059-1.178-.5-.863a61.869,61.869,0,0,1-6.767,3.274.516.516,0,0,0-.349.615.5.5,0,0,0,.614.349",
    transform: "translate(-138.605 -208.83)"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40973",
    "data-name": "Group 40973",
    transform: "translate(155.239 280.69)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40972",
    "data-name": "Group 40972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40971",
    "data-name": "Group 40971",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87718",
    "data-name": "Path 87718",
    d: "M131.653,215.344a65.333,65.333,0,0,1-14.33-4.818c-.578-.272-1.087.589-.5.864a66.443,66.443,0,0,0,14.57,4.918c.626.133.895-.831.265-.964",
    transform: "translate(-116.561 -210.473)",
    fill: "#263238"
  }))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87719",
    "data-name": "Path 87719",
    d: "M85.564,141.124c-9.433,9.131,1.117,44.464,1.117,44.464l30.122-7.946s-7.157-26.618-14.356-33.328c-6.1-5.655-11.7-8.364-16.884-3.19",
    transform: "translate(27.092 46.162)",
    fill: "#407bff"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40976",
    "data-name": "Group 40976",
    transform: "translate(108.734 184.53)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40975",
    "data-name": "Group 40975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40974",
    "data-name": "Group 40974",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87720",
    "data-name": "Path 87720",
    d: "M85.564,141.124c-9.433,9.131,1.117,44.464,1.117,44.464l30.122-7.946s-7.157-26.618-14.356-33.328c-6.1-5.655-11.7-8.364-16.884-3.19",
    transform: "translate(-81.643 -138.368)",
    fill: "#34bcdb"
  }))))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87721",
    "data-name": "Path 87721",
    d: "M142.52,174.385l-18.868-26.471a2.221,2.221,0,0,1,.515-3.1l15.646-11.182a2.215,2.215,0,0,1,3.094.517l18.868,26.47a2.223,2.223,0,0,1-.517,3.1L145.613,174.9a2.214,2.214,0,0,1-3.092-.517",
    transform: "translate(40.894 44.445)",
    fill: "#407bff"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40979",
    "data-name": "Group 40979",
    transform: "translate(176.955 183.839)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40978",
    "data-name": "Group 40978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40977",
    "data-name": "Group 40977",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87722",
    "data-name": "Path 87722",
    d: "M135.381,145.347l-2.182-3.061a1.8,1.8,0,0,1,.417-2.5l2.24-1.6a1.788,1.788,0,0,1,2.5.417l2.182,3.061a1.794,1.794,0,0,1-.417,2.5l-2.24,1.6a1.79,1.79,0,0,1-2.5-.417",
    transform: "translate(-132.866 -137.85)",
    fill: "#fff"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40982",
    "data-name": "Group 40982",
    transform: "translate(173.52 188.523)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40981",
    "data-name": "Group 40981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40980",
    "data-name": "Group 40980",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87723",
    "data-name": "Path 87723",
    d: "M130.367,142.025l2.772,3.889a.42.42,0,0,0,.683-.489q-1.384-1.944-2.77-3.887a.421.421,0,0,0-.685.488",
    transform: "translate(-130.287 -141.362)",
    fill: "#fff"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40985",
    "data-name": "Group 40985",
    transform: "translate(177.787 194.509)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40984",
    "data-name": "Group 40984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40983",
    "data-name": "Group 40983",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87724",
    "data-name": "Path 87724",
    d: "M133.571,146.514q1.386,1.942,2.772,3.887a.42.42,0,0,0,.683-.488q-1.384-1.946-2.772-3.887a.42.42,0,0,0-.683.488",
    transform: "translate(-133.491 -145.851)",
    fill: "#fff"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40988",
    "data-name": "Group 40988",
    transform: "translate(182.055 200.496)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40987",
    "data-name": "Group 40987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40986",
    "data-name": "Group 40986",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87725",
    "data-name": "Path 87725",
    d: "M136.775,151l2.772,3.889a.421.421,0,0,0,.685-.489l-2.772-3.887a.421.421,0,0,0-.685.488",
    transform: "translate(-136.695 -150.34)",
    fill: "#fff"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40991",
    "data-name": "Group 40991",
    transform: "translate(186.322 206.483)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40990",
    "data-name": "Group 40990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40989",
    "data-name": "Group 40989",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87726",
    "data-name": "Path 87726",
    d: "M139.979,155.491q1.386,1.944,2.772,3.888a.421.421,0,0,0,.685-.488q-1.386-1.944-2.772-3.889a.421.421,0,0,0-.685.489",
    transform: "translate(-139.899 -154.829)",
    fill: "#fff"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40994",
    "data-name": "Group 40994",
    transform: "translate(169.968 191.005)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40993",
    "data-name": "Group 40993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40992",
    "data-name": "Group 40992",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87727",
    "data-name": "Path 87727",
    d: "M127.694,143.974l6.165,8.019a.517.517,0,0,0,.683.18.5.5,0,0,0,.178-.684l-6.164-8.02a.518.518,0,0,0-.683-.179.5.5,0,0,0-.18.684",
    transform: "translate(-127.62 -143.223)",
    fill: "#fff"
  }))))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87728",
    "data-name": "Path 87728",
    d: "M117.845,166.884c-.344.673-.73,1.506-1.139,2.417l-4.123,7.736,9.091,6.691c1.858-2.826,5.2-4.3,7.274-5.775,3.338-2.37,3.893-7.044,5.454-7.918,4.177-2.341,13.233-3.329,12.756-6.087s-10.147-.451-10.147-.451,10.011-3.754,9.5-6.319c-.709-3.547-1.906-2.945-1.906-2.945a2.553,2.553,0,0,0-1.2-3.142c-1.223-.651-7.872.569-14.978,5.657,0,0,1.849-2.135,5.134-5.308,1.315-1.268,3.649-1.828,4.817-3.727,1.638-2.661-4.89-2.367-8.857,1.012s-8.542,11.995-11.682,18.157",
    transform: "translate(37.358 48.685)",
    fill: "#d6917a"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87729",
    "data-name": "Path 87729",
    d: "M140.737,152.079a33.668,33.668,0,0,0-8.5,2.747,27.683,27.683,0,0,0-7.871,6.759c-.416.487.288,1.2.707.707a26.964,26.964,0,0,1,7.669-6.6,32.786,32.786,0,0,1,8.26-2.646c.627-.14.362-1.1-.265-.964",
    transform: "translate(41.227 50.732)",
    fill: "#a24e3f"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87730",
    "data-name": "Path 87730",
    d: "M132.615,158.753a44.527,44.527,0,0,0-3.942,2.131,6.324,6.324,0,0,0-2.569,2.973.5.5,0,0,0,.349.616.511.511,0,0,0,.615-.348,5.462,5.462,0,0,1,2.4-2.561c1.173-.721,2.432-1.312,3.653-1.946.57-.3.065-1.16-.5-.865",
    transform: "translate(41.837 52.943)",
    fill: "#a24e3f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87731",
    "data-name": "Path 87731",
    d: "M88.273,175.5s6.908,27.8,10.573,30.589,6.574,5.444,13.654,1.772,21.332-35.86,21.332-35.86L123.381,165.6l-14.8,17.077-2.276-12.313Z",
    transform: "translate(29.292 55.246)",
    fill: "#d6917a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbps);
export default __webpack_public_path__ + "static/media/bbps.1abcd5983a8b34fa1e49850054be7abd.svg";
export { ForwardRef as ReactComponent };